import {NewRequest, parseResponseAndHandleErrors, URLForEndpoint} from "@/data/requests";
import {ERROR_SERVER_UNREACHABLE} from "@/data/datasourceConst";
import axios from "axios";
import jQuery from 'jquery';
import moment from "moment";
import Cookies from "js-cookie";
import { generateRandomIndex } from "@/helper/utily";
import { getUserID } from "@/helper/util_custom";
import { lang } from "@/locale";
import { Notification } from 'element-ui';

const API_HOST = process.env.VUE_APP_ROOT_API || "http://local.emsv2";
const API_HOST2 = process.env.VUE_APP_ROOT_API2;
let GoogleGeocodeAPIKey = 'AIzaSyBSjzdBEO1Akg0aZfKpglWYBtdqLMHJLzM';

function getMs() {
    const d = new Date();
    return d.getTime();
}


// let alertExpireDate = new Date(new Date().getTime() + 1 * 60 * 1000);
function setToHappen(fn, d) {
    const t = d.getTime() - (new Date()).getTime();
    return setTimeout(fn, t);
}

function alertExpire() {
    alert("almost expire");
}


export default class DataSource {
    static get shared() {
        if (DataSource.instance == null || DataSource.instance === undefined) {
            DataSource.instance = new DataSource();
        }
        return DataSource.instance;
    }

    constructor() {
        this.loggedIn = false;
        this.isExpireAlerted = false;
    }

    async callAPI(endPoint, method = "GET", queryObject, requestBody, hasContentType = true, host) {
        const url = URLForEndpoint(endPoint, queryObject, host);
        const request = NewRequest(method, hasContentType);

        if (!hasContentType) {
            delete request.headers["Content-Type"];
            request.body = requestBody;
        } else if (method !== "GET" && requestBody) {
            request.body = JSON.stringify(requestBody);
        }
        let response;
        try {
            response = await fetch(url, request);
        } catch (err) {
            throw ERROR_SERVER_UNREACHABLE;
        }
        return response;
        // return await parseResponseAndHandleErrors(response);
    }

    // by default, withToken set to true
    callWebService(endPoint, data = {}, method = "GET", withToken = true, withFormData = false,isStringData=false, host) {
        const url = URLForEndpoint(endPoint, null, host)
        const request = {
            dataType: "json",
            // url: `${API_HOST}${endPoint}`,
            url: url,
            cache: false,
            success: function (response) {
                return response;
            }
        };

        if (method) {
            request.method = method;
        }

        if (data) {
            request.data = data;
        }

        if(isStringData){
            request.contentType = "application/json";
        }


        if (withToken) {
            data.token = Cookies.get('authToken');
            data.UserSchool_Session = Cookies.get('schoolSession');
            data.UserID_Session = Cookies.get('userIDSession');
            data.UserType_Session = Cookies.get('userTypeSession');
            data.UserUniversity_Session = Cookies.get('userUniversitySession');
            data.UserEmail_Session = Cookies.get('userEmailSession');
            data.USRid_Session = Cookies.get('usRidSession');
            data.UserName_Session = Cookies.get('userNameSession');
            data.UserSchoolName_Session = Cookies.get('userSchoolNameSession');
            data.UserSchoolInfoSerialize_Session = Cookies.get('userSchoolInfoSerializeSession');
            const extendTime = Cookies.get('extendTime');
            const expireTime = Cookies.get('expireTime');
            const nowMs = getMs();
            // const expireAlert = Cookies.get('alert');
            // if (expireAlert) {
            //     const date = Date.parse(expireAlert);
            //     const now = new Date();
            //     if (now.getTime() > date) {
            //         if (!this.isExpireAlerted) {
            //             // alert("token almost expire");
            //             this.isExpireAlerted = true;
            //         }
            //
            //     }
            // }

            // console.log(" data.token", data.token);
            // console.log(new Date(nowMs), "now");
            // if (extendTime) {
            //     console.log(new Date(Number(extendTime)), "extendTime");
            // }
            //
            // if (expireTime) {
            //     console.log(new Date(Number(expireTime)), "expireTime");
            // }


            //expire date after login
            if (nowMs >= extendTime && nowMs < expireTime) {
                const newExtendDate = new Date(Number(expireTime) + (120 * 60 * 1000));
                // const newExtendDate = new Date(Number(extendTime) + (1 * 60 * 1000));
                // console.log('first extend check');
                // console.log(newExtendDate, "new extend");
                // console.log(newExtendDate.getTime() + " " + Number(expireTime));
                if (newExtendDate.getTime() >= Number(expireTime)) {
                    const newExpireDate = new Date(Number(expireTime) + (180 * 60 * 1000));
                    this.extendCookies(newExpireDate, newExtendDate);
                    // alert('extend!');
                    // console.log(newExpireDate, "later");
                }
            }
        }

        // this is just testing, remove this if savePost not working
        // this might just use for upload file request only(formData), not for whole request
        if (withFormData) {
            request.processData = false;
            request.contentType = false;
        }

        // get token from session
        // const token = Cookies.get('authToken');

        // if token is available and withToken set as true, then pass request with headers
        // they not using header Authorization so disable this
        // if (token && withToken === true) {
        //     request.headers = {"Authorization": token};
        // }
        return jQuery.ajax(request);
    }

    async uploadFile(files, postID) {
        const formData = new FormData();
        formData.append('token', Cookies.get('authToken'));
        formData.append('UserID_Session', Cookies.get('userIDSession'));
        formData.append("file", files[0]);
        formData.append("postID", postID);

        const request = {
            url: `${API_HOST}/controller/Upload_File.asmx/uploadFile`,
            cache: false,
            type: 'POST',
            data: formData,
            enctype: 'multipart/form-data',
            processData: false,
            contentType: false,
            async: false,
            json: false,
            success: function (response) {
                return response;
            }
        };

        return jQuery.ajax(request);

        // const response = await this.callWebService("/controller/Upload_File.asmx/uploadFile", data, "POST", true, true);
        // return response;
    }

    async login(userId, password) {
        const data = {
            userID: userId,
            userPassword: password,
            type: 'Kagami Website'
        };

        try {
            // Cookies.set('alert', alertExpireDate, {expires: expireDate});
            //set expire date onlogin
            let extendDate = new Date(new Date().getTime() + 120 * 60 * 1000);
            let expireDate = new Date(new Date().getTime() + 180 * 60 * 1000);
            const extendMs = extendDate.getTime();
            const expiredMs = expireDate.getTime();

            // console.log("login", extendMs);

            const response = await this.callWebService("/controller/Login.asmx/checkLogin", data, "POST", false);
            Cookies.set('authToken', response.token, {expires: expireDate}); //expire in 3 hour);
            Cookies.set('schoolSession', response.UserSchool_Session, {expires: expireDate}); //expire in 3 hour);
            Cookies.set('userIDSession', response.UserID_Session, {expires: expireDate}); //expire in 3 hour);
            Cookies.set('userTypeSession', response.UserType_Session, {expires: expireDate}); //expire in 3 hour);
            Cookies.set('userUniversitySession', response.UserUniversity_Session, {expires: expireDate}); //expire in 3 hour);
            Cookies.set('usRidSession', response.USRid_Session, {expires: expireDate}); //expire in 3 hour);
            Cookies.set('userEmailSession', response.UserEmail_Session, {expires: expireDate}); //expire in 3 hour);
            Cookies.set('userNameSession', response.UserName_Session, {expires: expireDate}); //expire in 3 hour);
            Cookies.set('expireTime', expiredMs, {expires: expireDate}); //expire in 3 hour);
            Cookies.set('extendTime', extendMs, {expires: expireDate}); //expire in 3 hour);
            Cookies.set('userSchoolNameSession', response.UserSchoolName_Session, {expires: expireDate}); //expire in 3 hour);
            Cookies.set('userSchoolInfoSerializeSession', response.SchoolInfoSerialize_Session, {expires: expireDate}); //expire in 3 hour)
            return response;
        } catch (e) {
            throw e;
        }
    }

    async login_parent(userId, password) {
        const data = {
            userID: userId,
            userPassword: password,
            type: 'Kagami Website Parent'
        };

        try {
            // Cookies.set('alert', alertExpireDate, {expires: expireDate});
            //set expire date onlogin
            let extendDate = new Date(new Date().getTime() + 120 * 60 * 1000);
            let expireDate = new Date(new Date().getTime() + 180 * 60 * 1000);
            const extendMs = extendDate.getTime();
            const expiredMs = expireDate.getTime();

            // console.log("login", extendMs);

            const response = await this.callWebService("/controller/Login.asmx/checkParentLogin", data, "POST", false);
            Cookies.set('authToken', response.token, {expires: expireDate}); //expire in 3 hour);
            Cookies.set('schoolSession', response.UserSchool_Session, {expires: expireDate}); //expire in 3 hour);
            Cookies.set('userIDSession', response.UserID_Session, {expires: expireDate}); //expire in 3 hour);
            Cookies.set('userTypeSession', response.UserType_Session, {expires: expireDate}); //expire in 3 hour);
            Cookies.set('userUniversitySession', response.UserUniversity_Session, {expires: expireDate}); //expire in 3 hour);
            Cookies.set('usRidSession', response.USRid_Session, {expires: expireDate}); //expire in 3 hour);
            Cookies.set('userEmailSession', response.UserEmail_Session, {expires: expireDate}); //expire in 3 hour);
            Cookies.set('userNameSession', response.UserName_Session, {expires: expireDate}); //expire in 3 hour);
            Cookies.set('expireTime', expiredMs, {expires: expireDate}); //expire in 3 hour);
            Cookies.set('extendTime', extendMs, {expires: expireDate}); //expire in 3 hour);
            Cookies.set('userSchoolNameSession', response.UserSchoolName_Session, {expires: expireDate}); //expire in 3 hour);
            Cookies.set('userSchoolInfoSerializeSession', response.SchoolInfoSerialize_Session, {expires: expireDate}); //expire in 3 hour)
            return response;
        } catch (e) {
            throw e;
        }
    }

    extendCookies(expireDate, extendTime) {
        try {
            const token = Cookies.get('authToken');
            const UserSchool_Session = Cookies.get('schoolSession');
            const UserID_Session = Cookies.get('userIDSession');
            const UserType_Session = Cookies.get('userTypeSession');
            const UserUniversity_Session = Cookies.get('userUniversitySession');
            const UserEmail_Session = Cookies.get('userEmailSession');
            const USRid_Session = Cookies.get('usRidSession');
            const UserName_Session = Cookies.get('userNameSession');
            const expiredMs = expireDate.getTime();
            const extendMs = extendTime.getTime();
            const UserSchoolName_Session = Cookies.get('userSchoolNameSession');
            const UserSchoolInfoSerializeSession = Cookies.get('userSchoolInfoSerializeSession');
            // console.log("extendCookies extendMs", extendMs);

            Cookies.set('authToken', token, {expires: expireDate}); //expire in 3 hour);
            Cookies.set('schoolSession', UserSchool_Session, {expires: expireDate}); //expire in 3 hour);
            Cookies.set('userIDSession', UserID_Session, {expires: expireDate}); //expire in 3 hour);
            Cookies.set('userTypeSession', UserType_Session, {expires: expireDate}); //expire in 3 hour);
            Cookies.set('userUniversitySession', UserUniversity_Session, {expires: expireDate}); //expire in 3 hour);
            Cookies.set('usRidSession', USRid_Session, {expires: expireDate}); //expire in 3 hour);
            Cookies.set('userEmailSession', UserEmail_Session, {expires: expireDate}); //expire in 3 hour);
            Cookies.set('userNameSession', UserName_Session, {expires: expireDate}); //expire in 3 hour);
            Cookies.set('expireTime', expiredMs, {expires: expireDate}); //expire in 3 hour);
            Cookies.set('extendTime', extendMs, {expires: expireDate}); //expire in 3 hour);
            Cookies.set('userSchoolNameSession', UserSchoolName_Session, {expires: expireDate}); //expire in 3 hour);
            Cookies.set('userSchoolInfoSerializeSession', UserSchoolInfoSerializeSession, {expires: expireDate}); //expire in 3 hour);
        } catch (e) {
            console.log(e);
        }
    }


    async externalLogin(userId, tokenId) {
        const data = {
            userID: userId,
            externalLoginToken: tokenId,
            type: 'Kagami Website'
        };

        const response = await this.callWebService("/controller/Login.asmx/checkLogin", data, "POST", false);
        Cookies.set('authToken', response.token, {expires: 3 / 24}); //expire in 3 hour);
        Cookies.set('schoolSession', response.UserSchool_Session, {expires: 3 / 24}); //expire in 3 hour);
        Cookies.set('userIDSession', response.UserID_Session, {expires: 3 / 24}); //expire in 3 hour);
        Cookies.set('userTypeSession', response.UserType_Session, {expires: 3 / 24}); //expire in 3 hour);
        Cookies.set('userUniversitySession', response.UserUniversity_Session, {expires: 3 / 24}); //expire in 3 hour);
        Cookies.set('usRidSession', response.USRid_Session, {expires: 3 / 24}); //expire in 3 hour);
        Cookies.set('userEmailSession', response.UserEmail_Session, {expires: 3 / 24}); //expire in 3 hour);
        Cookies.set('userNameSession', response.UserName_Session, {expires: 3 / 24}); //expire in 3 hour);
        return response;
    }

    logout() {
        let $ = require("jquery");

        let internalSession = new Promise((resolve, reject) => {
            const data = {};

            this.callWebService("/controller/Login.asmx/logOut", data, "POST").then((result) => {
                resolve(result == "1");
            });
        });

        let sessionSignout = new Promise((resolve, reject) => {
            Cookies.remove('authToken');
            Cookies.remove('schoolSession');
            Cookies.remove('userIDSession');
            Cookies.remove('userTypeSession');
            Cookies.remove('userUniversitySession');
            Cookies.remove('usRidSession');
            Cookies.remove('userEmailSession');
            Cookies.remove('userNameSession');
            resolve(true);
        });

        let googleSignout = new Promise((resolve, reject) => {
            $.getScript('https://apis.google.com/js/platform.js', function () {
                gapi.load("auth2", () => {
                    gapi.auth2.init({
                        client_id: "646978523324-lcudp248dvuuk0rda4q6kf2bti9qkk3b.apps.googleusercontent.com"
                    }).then((auth2) => {
                        auth2.signOut();
                        resolve(true);
                    });
                });
            });
        });

        let fbSignout = new Promise((resolve, reject) => {
            $.getScript('https://connect.facebook.net/en_US/sdk.js', function () {
                FB.init({
                    // appId: '255792542012990',
                    appId: '1983777365262188',
                    version: 'v2.7' // or v2.1, v2.2, v2.3, ...
                });

                FB.getLoginStatus(() => {
                    FB.logout();
                    resolve(true);
                });
            });
        });

        Promise.all([internalSession, sessionSignout, googleSignout, fbSignout]).then((result) => {
            window.location.replace("/login");
        });
    }

    async resetEmailPassword(userEmail, type) {
        const data = {
            userEmail: userEmail,
            type: type,
        };
        const response = await this.callWebService("/controller/Login.asmx/resetPasswordEmail", data, "POST", false);
        return response;
    }

    async resetPassword(userEmail, userPassword, otp) {
        const data = {
            userEmail: userEmail,
            userPassword: userPassword,
            otp: otp
        };
        const response = await this.callWebService("/controller/Login.asmx/resetPassword", data, "POST", false);
        return response;
    }

    async parentRegister(userEmail, userPassword, studentIDNo, studentID_Index, studentDOB, studentIDType, externalLoginType, externalLoginToken) {
        const date = moment(studentDOB).format('Y-MM-DD HH:mm:ss');
        console.log(date);
        const data = {
            userEmail: userEmail,
            userPassword: userPassword,
            studentID_Index: studentID_Index,
            studentDOB: date,
            studentIDType: studentIDType,
            studentIDNo: studentIDNo,
            externalLoginType: externalLoginType,
            externalLoginToken: externalLoginToken
        };
        let response = await this.callWebService("/controller/Register.asmx/parentRegistration", data, "POST", false);

        if (typeof response === "string") {
            response = JSON.parse(response);
        }

        return response;

    }

    async getStudent(studentID, studentID_Index, studentFirstName, studentLastName, parentName) {
        const data = {
            studentID: studentID,
            studentID_Index: studentID_Index,
            studentFirstName: studentFirstName,
            studentLastName: studentLastName,
            parentName: parentName,
            // token: Cookies.get('authToken'),
            //UserSchool_Session: Cookies.get('schoolSession'),
        };
        const response = await this.callWebService("/controller/Students.asmx/getStudent", data, "POST");
        return response;
    }

    async getStudentParentView(studentID) {
        const data = {
            studentID: studentID,
            parentView: "YES"
        };
        const response = await this.callWebService("/controller/Students.asmx/getStudent", data, "POST");
        return response;
    }

    async getStudentWithStatus(studentID, studentID_Index, studentFirstName, studentLastName, parentName, studentStatus, type) {
        const data = {
            studentID: studentID,
            studentID_Index: studentID_Index,
            studentFirstName: studentFirstName,
            studentLastName: studentLastName,
            parentName: parentName,
            studentStatus: studentStatus,
            type: type,
        };
        const response = await this.callWebService("/controller/Students.asmx/getStudent", data, "POST");
        return response;
    }

    async getStudentWithPendingCourse(studList, studentID_Index, studentFirstName, studentLastName, parentName, studentStatus, levelID, classID, classType, mode, teacherID) {
        const data = {
            studList: studList,
            teacherID: teacherID,
            studentID_Index: studentID_Index,
            studentFirstName: studentFirstName,
            studentLastName: studentLastName,
            parentName: parentName,
            studentStatus: studentStatus,
            levelID: levelID,
            classID: classID,
            classType: classType,
            mode: mode,
        };
        const response = await this.callWebService("/controller/Students.asmx/getStudentWithPendingCourse", data, "POST");
        return response;
    }

    async checkStudentDuplication(studentFirstName, studentLastName, studentDOB, finExpire, fin, birthCert, ic, passport, passportExpire) {
        const data = {
            studentFirstName: studentFirstName,
            studentLastName: studentLastName,
            studentDOB: studentDOB,
            finExpire: finExpire,
            fin: fin,
            birthCert: birthCert,
            ic: ic,
            passport: passport,
            passportExpire: passportExpire,
        };
        const response = await this.callWebService("/controller/Students.asmx/checkStudentDuplication", data, "POST");
        return response;
    }

    async getStudentProfilePicture(studentID) {
        const data = {
            studentID: studentID,
        };
        const response = await this.callWebService("/controller/Students.asmx/getStudentProfilePicture", data, "POST");
        return response;
    }

    async getStudentAddressGoogleAPI(postcode, country) {
        let result = '';

        if (country === '' || country === 'Singapore') {
            country = 'Singapore';

            //to take out S in front of postcode
            if (postcode.substring(0, 1).toUpperCase() === 'S') {
                postcode = postcode.substring(1, postcode.length);
            }
            //to take out S in front of postcode
        }

        //search by address / postcode
        const request = {
            url: 'https://maps.googleapis.com/maps/api/geocode/json?address=' + postcode + '+' + country + '&result_type=street_address&key=' + GoogleGeocodeAPIKey,
            cache: false,
            type: 'POST',
            enctype: 'multipart/form-data',
            processData: false,
            contentType: false,
            async: false,
            json: false,
            success: function (response) {
                return response;
            }
        };

        let response = await jQuery.ajax(request);
        if (typeof response === "string") {
            response = JSON.parse(response);
        }
        //search by address / postcode

        //get lat lng
        let lat = '';
        let lng = '';

        this.resultResponse = response.results;
        this.resultResponse.forEach(m => {
            lat = m.geometry.location.lat;
            lng = m.geometry.location.lng;
        });
        //get lat lng

        //search by lat lng
        if (response.status === 'OK') {
            const request2 = {
                url: 'https://maps.googleapis.com/maps/api/geocode/json?latlng=' + lat + ',' + lng + '&key=' + GoogleGeocodeAPIKey,
                cache: false,
                type: 'POST',
                enctype: 'multipart/form-data',
                processData: false,
                contentType: false,
                async: false,
                json: false,
                success: function (response2) {
                    return response2;
                }
            };

            let response2 = await jQuery.ajax(request2);
            if (typeof response2 === "string") {
                response2 = JSON.parse(response2);
            }

            result = response2.results[0].formatted_address;

            // const resultResponse2 = response2.results[0].address_components;
            // resultResponse2.forEach(m => {
            //     console.log(m);
            // });
        }
        //search by lat lng

        return result;
    }

    async oneMapCommonApiSearchVal(value) {
        //https://docs.onemap.sg/#search

        const request = {
            url: 'https://developers.onemap.sg/commonapi/search?searchVal=' + value + '&returnGeom=Y&getAddrDetails=Y',
            cache: false,
            type: 'GET',
            enctype: 'multipart/form-data',
            processData: false,
            contentType: false,
            async: false,
            json: false,
            success: function (response) {
                return response;
            }
        };

        let response = await jQuery.ajax(request);
        if (typeof response === "string") {
            response = JSON.parse(response);
        }
        return response;
    }

    async saveStudent(files, jsonString, jsonString2, familyID, parentID, allergiesList, authorizedPickupList, classID) {
        const data = new FormData();
        data.append('token', Cookies.get('authToken'));
        data.append('UserSchool_Session', Cookies.get('schoolSession'));
        data.append('UserID_Session', Cookies.get('userIDSession'));
        data.append('UserUniversity_Session', Cookies.get('userUniversitySession'));

        if (files && files.length > 1) {
            for (let key in files) {
                //console.log(key);
                if (files.hasOwnProperty(key)) {
                    // console.log(files[key]);
                    if (key > 0) {
                        data.append(`upload_${key}`, files[key]);
                    } else {
                        data.append("upload", files[key]);
                    }
                }
            }
        } else if (files) {
            data.append("upload", files[0]);
        }

        data.append("jsonString", jsonString);
        data.append("jsonString2", jsonString2);
        data.append("familyID", familyID);
        data.append("parentID", parentID);
        data.append("allergiesList", allergiesList);
        data.append("authorizedPickupList", authorizedPickupList);
        data.append("classID", classID);

        const request = {
            url: `${API_HOST}/controller/Students.asmx/saveStudent`,
            cache: false,
            type: 'POST',
            data: data,
            enctype: 'multipart/form-data',
            processData: false,
            contentType: false,
            async: false,
            json: false,
            success: function (response) {
                return response;
            }
        };

        let response = await jQuery.ajax(request);
        if (typeof response === "string") {
            response = JSON.parse(response);
        }
        return response;
    }

    async updateStudent(files, studentID, jsonString, allergiesList, authorizedPickupList) {
        const data = new FormData();
        data.append('token', Cookies.get('authToken'));
        data.append('UserID_Session', Cookies.get('userIDSession'));

        if (files && files.length > 1) {
            for (let key in files) {
                //console.log(key);
                if (files.hasOwnProperty(key)) {
                    // console.log(files[key]);
                    if (key > 0) {
                        data.append(`upload_${key}`, files[key]);
                    } else {
                        data.append("upload", files[key]);
                    }
                }
            }
        } else if (files) {
            data.append("upload", files[0]);
        }

        data.append("studentID", studentID);
        data.append("jsonString", jsonString);
        data.append("allergiesList", allergiesList);
        data.append("authorizedPickupList", authorizedPickupList);

        const request = {
            url: `${API_HOST}/controller/Students.asmx/updateStudent`,
            cache: false,
            type: 'POST',
            data: data,
            enctype: 'multipart/form-data',
            processData: false,
            contentType: false,
            async: false,
            json: false,
            success: function (response) {
                return response;
            }
        };

        let response = await jQuery.ajax(request);
        if (typeof response === "string") {
            response = JSON.parse(response);
        }
        return response;
    }

    async requestResetParentPassword(parentId, parentEmail) {
        const data = {
            parentID: parentId,
            email: parentEmail,
        };
        return await this.callWebService("/controller/Parents.asmx/resetParentPassword", data, "POST");
    }

    async getStudentAvailableStatusAction(currentStatus, currentIndexNo, currentStudentID) {
        const data = {
            currentStatus: currentStatus,
            currentIndexNo: currentIndexNo,
            currentStudentID: currentStudentID
        };
        const response = await this.callWebService("/controller/Students.asmx/getStudentAvailableStatusAction", data, "POST");
        return response;
    }

    async updateStudentStatus(studentID, newStatus, rejectedReason, rejectedDate) {
        const data = {
            studentID: studentID,
            newStatus: newStatus,
            rejectedReason: rejectedReason,
            rejectedDate: rejectedDate,
        };
        const response = await this.callWebService("/controller/Students.asmx/updateStudentStatus", data, "POST");
        return response;
    }

    async getParentList(familyId, parentFirstName, parentLastName, parentEmail) {
        const data = {
            familyID: familyId,
            parentFirstName: parentFirstName,
            parentLastName: parentLastName,
            parentEmail: parentEmail,
            // token: Cookies.get('authToken'),
            // UserSchool_Session: Cookies.get('schoolSession'),
        };
        const response = await this.callWebService("/controller/Parents.asmx/getParentList", data, "POST");
        return response;
    }

    async getParent(parentID, familyID, emailJsonString) {
        const data = {
            parentID: parentID,
            familyID: familyID,
            emailJsonString: emailJsonString,
        };
        const response = await this.callWebService("/controller/Parents.asmx/getParent", data, "POST");
        return response;
    }

    async getParentStudentsInfo(parentID) {
        const data = {
            parentID: parentID
        };
        const response = await this.callWebService("/controller/Parents.asmx/getParentStudentsInfo", data, "POST");
        return response;
    }

    async getRelationship(familyID, studentID, parentFirstName, parentLastName, studentName) {
        const data = {
            familyID: familyID,
            studentID: studentID,
            parentFirstName: parentFirstName,
            parentLastName: parentLastName,
            studentName: studentName,
        };
        const response = await this.callWebService("/controller/Parents.asmx/getRelationship", data, "POST");
        return response;
    }

    async getRelationshipByParentID(parentID) {
        const data = {
            parentID: parentID,
        };
        const response = await this.callWebService("/controller/Parents.asmx/getRelationship", data, "POST");
        return response;
    }

    async getStudentSiblingReligionLanguages(parentID) {
        const data = {
            parentID: parentID,
        };
        const response = await this.callWebService("/controller/Parents.asmx/getStudentSiblingReligionLanguages", data, "POST");
        return response;
    }

    async updateRelationship(familyID, studentID) {
        const data = {
            familyID: familyID,
            studentID: studentID,
        };
        const response = await this.callWebService("/controller/Parents.asmx/updateRelationship", data, "POST");
        return response;
    }

    async getStudentLevel(studentID) {
        const data = {
            studentID: studentID,
        };
        const response = await this.callWebService("/controller/Students.asmx/getStudentLevel", data, "POST");
        return response;
    }

    async getStudentAllLevel(studentID) {
        const data = {
            studentID: studentID,
        };
        const response = await this.callWebService("/controller/Students.asmx/getStudentAllLevel", data, "POST");
        return response;
    }

    async getStudentLevelActiveOnly(studentID) {
        const data = {
            studentID: studentID,
            onlyActive: 'Yes',
        };
        const response = await this.callWebService("/controller/Students.asmx/getStudentLevel", data, "POST");
        return response;
    }

    async getStudentClass(studentID, courseID) {
        const data = {
            studentID: studentID,
            courseID: courseID,
        };
        const response = await this.callWebService("/controller/Students.asmx/getStudentClass", data, "POST");
        return response;
    }

    async setClass(studentID, classID, studentCourseID) {
        const data = {
            studentID: studentID,
            classID: classID,
            studentCourseID: studentCourseID,
        };
        const response = await this.callWebService("/controller/Students.asmx/setClass", data, "POST");
        return response;
    }

    async massSetClass(classID, jsonString) {
        const data = {
            classID: classID,
            jsonString: jsonString,
        };
        const response = await this.callWebService("/controller/Students.asmx/massSetClass", data, "POST");
        return response;
    }

    async updateLevelStudent(studentID, studentCourseID, actionMode) {
        const data = {
            studentID: studentID,
            studentCourseID: studentCourseID,
            actionMode: actionMode,
        };
        const response = await this.callWebService("/controller/Students.asmx/updateLevel", data, "POST");
        return response;
    }

    async getSibling(studentID_Index, studentID) {
        const data = {
            studentID_Index: studentID_Index,
            studentID: studentID,
        };
        const response = await this.callWebService("/controller/Students.asmx/getSibling", data, "POST");
        return response;
    }

    async updateParent(parentID, jsonString) {
        const data = {
            parentID: parentID,
            jsonString: jsonString,
        };
        const response = await this.callWebService("/controller/Parents.asmx/updateParent", data, "POST");
        return response;
    }

    async getAcademicYearDateRange(academicYearID) {
        const data = {
            academicYearID: academicYearID,
        };
        const response = await this.callWebService("/controller/Course.asmx/getAcademicYearDateRange", data, "POST");
        return response;
    }

    async setLevel(mode, studentID, crsID, semID, commencementDate, studentSchoolID) {
        const data = {
            mode: mode,
            studentID: studentID,
            crsID: crsID,
            semID: semID,
            commencementDate: commencementDate,
            studentSchoolID: studentSchoolID,
        };
        const response = await this.callWebService("/controller/Students.asmx/setLevel", data, "POST");
        return response;
    }

    async setLevelAllowTodayDate(mode, studentID, crsID, semID, commencementDate, studentSchoolID) {
        const data = {
            mode: mode,
            studentID: studentID,
            crsID: crsID,
            semID: semID,
            commencementDate: commencementDate,
            studentSchoolID: studentSchoolID,
        };
        const response = await this.callWebService("/controller/Students.asmx/setLevelAllowTodayDate", data, "POST");
        return response;
    }

    async checkParentDuplication(firstName, lastName, checkMode) {
        const data = {
            firstName: firstName,
            lastName: lastName,
            checkMode: checkMode,
        };
        const response = await this.callWebService("/controller/Parents.asmx/checkParentDuplication", data, "POST");
        return response;
    }

    async getUserMenu() {
        const data = {};

        const userType = Cookies.get('userTypeSession');
        if (userType !== "Parent") {
            data.USRid_Session = Cookies.get('usRidSession');
        }

        const response = await this.callWebService("/controller/User.asmx/getUserMenu", data, "POST");
        return response;
    }

    async getUserSch() {
        const data = {};

        const userEmail = Cookies.get('userEmailSession');
        if (userEmail !== "" || userEmail !== null) {
            data.UserEmail_Session = Cookies.get('userEmailSession');
        }

        const response = await this.callWebService("/controller/User.asmx/getUserSch", data, "POST");
        if (response.Table) {
            window.schList = response.Table;
        }

        return response;
    }

    async getAllStaffListBySchool() {
        const data = {};

        const response = await this.callWebService("/controller/User.asmx/getAllStaffListBySchool", data, "POST");
        return response;
    }

    async getAllStaffList() {
        const data = {};

        const response = await this.callWebService("/controller/User.asmx/getAllStaffList", data, "POST");
        return response;
    }

    async getStaffPost(int_NumberOfPost, str_LastPostID, postType) {
        const data = {
            UserID_Session: Cookies.get('userIDSession'),
            numberOfPost: int_NumberOfPost,
            lastPostID: str_LastPostID,
            postType: postType,
        };

        const response = await this.callWebService("/controller/Posting.asmx/getPostStaff", data, "POST");
        return response;
    }

    async getStaffPostFeedPage(int_NumberOfPost, str_LastPostID, postType, notEqualPostType, mode, equalPostType, postTagValue, fromDate, toDate, postStatus, postTagValueEqual) {
        const data = {
            UserID_Session: Cookies.get('userIDSession'),
            numberOfPost: int_NumberOfPost,
            lastPostID: str_LastPostID,
            postType: postType,
            notEqualPostType: notEqualPostType,
            mode: mode,
            equalPostType: equalPostType,
            // postTagValue: postTagValue,
            postTagValueWithNewsFeedPostContent: postTagValue,
            fromDate: fromDate,
            toDate: toDate,
            postStatus: postStatus,
            postTagValueEqual,
        };

        const response = await this.callWebService("/controller/Posting.asmx/getPostStaff", data, "POST");
        return response;
    }

    async getFilterPost(numberOfPost, schoolid, classid, studentid, teacherid, fromDate, toDate, levelid) {
        const data = {
            numberOfPost: numberOfPost,
            schoolid: JSON.stringify(schoolid),
            classid: JSON.stringify(classid),
            levelid: JSON.stringify(levelid),
            studentid: JSON.stringify(studentid),
            teacherid: JSON.stringify(teacherid),
            fromDate: fromDate,
            toDate: toDate
        };
        console.log(data, "data");
        const response = await this.callWebService('/controller/Api.asmx/GetPosts', data, 'POST');
        return response;
    }

    async getStaffPostFeedPageByClass(int_NumberOfPost, str_LastPostID, postType, notEqualPostType, mode, equalPostType, postTagValue, fromDate, toDate, postStatus, postTagValueEqual) {
        const data = {
            UserID_Session: Cookies.get('userIDSession'),
            numberOfPost: int_NumberOfPost,
            lastPostID: str_LastPostID,
            postType: postType,
            notEqualPostType: notEqualPostType,
            mode: mode,
            equalPostType: equalPostType,
            // postTagValue: postTagValue,
            postTagValueWithNewsFeedPostContent: postTagValue,
            fromDate: fromDate,
            toDate: toDate,
            postStatus: postStatus,
            postTagValueEqual: postTagValueEqual
        };

        const response = await this.callWebService("/controller/Posting.asmx/getPostStaffByClass", data, "POST");
        return response;
    }

    async getStaffActivityPostAllByClass(int_NumberOfPost, str_LastPostID, postType, notEqualPostType, mode, equalPostType, postTagValue,
                                         fromDate, toDate, postStatus, postTagValueEqual, userRole, schoolid = [], levelid = [],
                                         classid = [], studentid = [], teacherid = [], isAllLevel) {
        const data = {
            UserID_Session: Cookies.get('userIDSession'),
            numberOfPost: int_NumberOfPost,
            lastPostID: str_LastPostID,
            postType: postType,
            notEqualPostType: notEqualPostType,
            mode: mode,
            equalPostType: equalPostType,
            // postTagValue: postTagValue,
            postTagValueWithNewsFeedPostContent: postTagValue,
            fromDate: fromDate,
            toDate: toDate,
            postStatus: postStatus,
            postTagValueEqual: postTagValueEqual,
            userRole: userRole,
            schoolid: JSON.stringify(schoolid),
            levelid: JSON.stringify(levelid),
            classid: JSON.stringify(classid),
            studentid: JSON.stringify(studentid),
            teacherid: JSON.stringify(teacherid),
            isAllLevel: isAllLevel
        };
        const response = await this.callWebService('/controller/Api.asmx/GetPosts', data, 'POST');
        return response;
    }

    async getEditorUploadURL(file){
        const formData = new FormData();
        formData.append('token', Cookies.get('authToken'));
        formData.append('file0', file);

        const request = {
            url: `${API_HOST}/controller/Api.asmx/UploadFile`,
            cache: false,
            type: 'POST',
            data: formData,
            enctype: 'multipart/form-data',
            processData: false,
            contentType: false,
            async: false,
            json: false,
            success: function (response) {
                return response;
            }
        };
        let response = await jQuery.ajax(request);
        if (typeof response === "string") {
            response = JSON.parse(response);
        }
        return response;
    }

    async getParentPost(int_NumberOfPost, str_LastPostID, postType, fromDate, toDate) {
        const data = {
            UserID_Session: Cookies.get('userIDSession'),
            numberOfPost: int_NumberOfPost,
            lastPostID: str_LastPostID,
            postType: postType,
            fromDate: fromDate,
            toDate: toDate,
        };
        const response = await this.callWebService("/controller/Posting.asmx/getPostParent", data, "POST");
        return response;
    }

    async getParentPostFeedPage(int_NumberOfPost, str_LastPostID, postType, notEqualPostType, mode, equalPostType, postTagValue, postContent, studentID, fromDate, toDate, postTagValueEqual, postTagValueNotEqual) {
        const data = {
            UserID_Session: Cookies.get('userIDSession'),
            numberOfPost: int_NumberOfPost,
            lastPostID: str_LastPostID,
            postType: postType,
            notEqualPostType: notEqualPostType,
            mode: mode,
            equalPostType: equalPostType,
            postTagValue: postTagValue,
            postContent: postContent,
            studentID: studentID,
            fromDate: fromDate,
            toDate: toDate,
            postTagValueEqual: postTagValueEqual,
            postTagValueNotEqual: postTagValueNotEqual,
        };
        const response = await this.callWebService("/controller/Posting.asmx/getPostParent", data, "POST");
        return response;
    }

    async getPostDropdown() {
        const data = {};
        const response = await this.callWebService("/controller/Posting.asmx/getPostDropDown", data, "POST");
        return response;
    }

    async getStaffPostHome() {
        const data = {};

        data.UserID_Session = Cookies.get('userIDSession');
        data.numberOfPost = 5;

        const response = await this.callWebService("/controller/Posting.asmx/getPostStaff", data, "POST");
        return response;
    }

    async uploadPostMedia(files){
        const formData = new FormData();
        formData.append('token', Cookies.get('authToken'));
        formData.append('UserID_Session', Cookies.get('userIDSession'));
        formData.append('UserSchool_Session', Cookies.get('schoolSession'));
        if (files && files.length > 1) {
            for (let key in files) {
                // console.log(key);
                if (files.hasOwnProperty(key)) {
                    // console.log(files[key]);
                    if (key > 0) {
                        formData.append(`upload_${key}`, files[key]);
                    } else {
                        formData.append("upload", files[key]);
                    }
                }
            }
        } else if (files && files.length) {
            formData.append("upload", files[0]);
        }else{
            formData.append("upload", files);
        }

        const response = await this.callWebService("/controller/Api.asmx/Upload", formData, "POST", true, true);
        return response;
    }

    async uploadFiles(files){
        const formData = new FormData();
        formData.append('token', Cookies.get('authToken'));
        formData.append('UserID_Session', Cookies.get('userIDSession'));
        formData.append('UserSchool_Session', Cookies.get('schoolSession'));
        if (files && files.length > 1) {
            for (let key in files) {
                // console.log(key);
                if (files.hasOwnProperty(key)) {
                    // console.log(files[key]);
                    if (key > 0) {
                        formData.append(`upload_${key}`, files[key]);
                    } else {
                        formData.append("upload", files[key]);
                    }
                }
            }
        } else if (files && files.length) {
            formData.append("upload", files[0]);
        }else{
            formData.append("upload", files);
        }

        const request = {
            url: `${API_HOST}/controller/Api.asmx/UploadFiles`,
            cache: false,
            type: 'POST',
            data: formData,
            enctype: 'multipart/form-data',
            processData: false,
            contentType: false,
            async: false,
            json: false,
            success: function (response) {
                return response;
            }
        };

        let response = await jQuery.ajax(request);
        if (typeof response === "string") {
            response = JSON.parse(response);
        }
        return response;
    }

    async savePostUpdate(files, tagUserID, tagClassID, tagLevelID, postLinkID, postAllowComment,
                         postKeyTag, postStatus, isAllLevel, isAllClasses,
                         postType, scheduleDate, scheduleStatus, uploadDates, postObervation,
                         {title, content, content2, content3, content4, ungroupDevelopmentGoals}) {
        // const postType = "UPDATE";
        const formData = new FormData();
        formData.append('token', Cookies.get('authToken'));
        formData.append('UserID_Session', Cookies.get('userIDSession'));
        formData.append('UserSchool_Session', Cookies.get('schoolSession'));
        formData.append("postLinkID", postLinkID);
        formData.append("postAllowComment", postAllowComment);
        formData.append("updateLearningMoments", JSON.stringify(ungroupDevelopmentGoals));
        formData.append("uploadDates", uploadDates);
        formData.append("postKeyTag", postKeyTag);
        formData.append("postStatus", postStatus);
        if (scheduleStatus || scheduleDate) {
            formData.append("ScheduledDate", scheduleDate);
            formData.append("ScheduledStatus", scheduleStatus);
        }
        formData.append("uploadFiles", JSON.stringify(files));

        // if (files && files.length > 1) {
        //     for (let key in files) {
        //         // console.log(key);
        //         if (files.hasOwnProperty(key)) {
        //             // console.log(files[key]);
        //             if (key > 0) {
        //                 formData.append(`upload_${key}`, files[key]);
        //             } else {
        //                 formData.append("upload", files[key]);
        //             }
        //         }
        //     }
        // } else if (files) {
        //     formData.append("upload", files[0]);
        // }
        formData.append("PostUpdDtlTitle", title);
        formData.append("content1", content !== undefined ? encodeURIComponent(content) : null);
        formData.append("broadContent", content !== undefined ? encodeURIComponent(content) : null);
        formData.append("content2", content2 !== undefined ? encodeURIComponent(content2) : null);
        formData.append("content3", content3 !== undefined ? encodeURIComponent(content3) : null);
        formData.append("content4", content4 !== undefined ? encodeURIComponent(content4) : null);
        // formData.append("tagAcademicYearID", tagAcademicYearID);
        formData.append("postType", postType);
        if (isAllLevel === 1) {
            formData.append("isAllLevel", isAllLevel);
        }
        if (tagUserID && tagUserID.length > 0) {
            formData.append("tagUserID", tagUserID);
        }
        if (tagLevelID && tagLevelID.length > 0) {
            formData.append("tagLevelID", tagLevelID);
        }
        if (tagClassID && tagClassID.length > 0) {
            formData.append("tagClassID", tagClassID);
        }

        const response = await this.callWebService("/controller/Posting.asmx/savePost", formData, "POST", true, true);
        return response;
    }

    async savePostUpdateJapan(files, postContent, tagUserID, tagClassID, tagLevelID, postLinkID, postAllowComment,
                              updateLearningMoments, postKeyTag, postStatus, isAllLevel, isAllClasses,
                         postTitle, postType, scheduleDate, scheduleStatus) {
        // const postType = "UPDATE";
        const formData = new FormData();
        formData.append('token', Cookies.get('authToken'));
        formData.append('UserID_Session', Cookies.get('userIDSession'));
        formData.append('UserSchool_Session', Cookies.get('schoolSession'));
        formData.append("postLinkID", postLinkID);
        formData.append("postAllowComment", postAllowComment);
        formData.append("updateLearningMoments", updateLearningMoments);
        formData.append("postKeyTag", postKeyTag);
        formData.append("postStatus", postStatus);
        if (scheduleStatus || scheduleDate) {
            formData.append("ScheduledDate", scheduleDate);
            formData.append("ScheduledStatus", scheduleStatus);
        }
        formData.append("uploadFiles", JSON.stringify(files));

        formData.append("PostUpdDtlTitle", postTitle);
        formData.append("content1", postContent ? encodeURIComponent(postContent) : null);
        formData.append("broadContent", postContent ? encodeURIComponent(postContent) : null);
        // formData.append("broadContent", postContent);
        // formData.append("tagAcademicYearID", tagAcademicYearID);
        formData.append("postType", postType);
        if (isAllLevel === 1) {
            formData.append("isAllLevel", isAllLevel);
        }
        if (tagUserID && tagUserID.length > 0) {
            formData.append("tagUserID", tagUserID);
        }
        if (tagLevelID && tagLevelID.length > 0) {
            formData.append("tagLevelID", tagLevelID);
        }
        if (tagClassID && tagClassID.length > 0) {
            formData.append("tagClassID", tagClassID);
        }

        const request = {
            url: `${API_HOST}/controller/Posting.asmx/savePost`,
            cache: false,
            type: 'POST',
            data: formData,
            enctype: 'multipart/form-data',
            processData: false,
            contentType: false,
            async: false,
            json: false,
            success: function (response) {
                return response;
            }
        };

        let response = await jQuery.ajax(request);
        if (typeof response === "string") {
            response = JSON.parse(response);
        }
        return response;
    }

    async sendPushNotification(postid){
        const response = await this.callWebService(`Communications/Action/SendPushNotification/post/${postid}`, {}, "POST", true, false, false,"https://api.etonhouse.com/");
        return response;
    }

    async savePortfolioPost(files, porTitle, porObservation, porAnalysisReflection, porDevelopmentObject, tagUserID, tagClassID, tagLevelID, postLinkID, porPorfolioObject, porPortfolioThemes, porResearchQuestion) {
        const postType = "PORTFOLIO";
        const formData = new FormData();
        formData.append('token', Cookies.get('authToken'));
        formData.append('UserID_Session', Cookies.get('userIDSession'));
        formData.append('UserSchool_Session', Cookies.get('schoolSession'));
        formData.append("porTitle", porTitle);
        formData.append("porObservation", porObservation);
        formData.append("porAnalysisReflection", porAnalysisReflection);
        formData.append("porDevelopmentObject", porDevelopmentObject);
        formData.append("postLinkID", postLinkID);
        formData.append("porPorfolioObject", porPorfolioObject);
        formData.append("porPortfolioThemes", porPortfolioThemes);
        formData.append("porResearchQuestion", porResearchQuestion);

        if (files && files.length > 1) {
            for (let key in files) {
                // console.log(key);
                if (files.hasOwnProperty(key)) {
                    // console.log(files[key]);
                    if (key > 0) {
                        formData.append(`upload_${key}`, files[key]);
                    } else {
                        formData.append("upload", files[key]);
                    }
                }
            }
        } else if (files) {
            formData.append("upload", files[0]);
        }

        // formData.append("tagAcademicYearID", tagAcademicYearID);
        formData.append("postType", postType);

        if (tagUserID && tagUserID.length > 0) {
            formData.append("tagUserID", tagUserID);
        } else if (tagLevelID) {
            formData.append("tagLevelID", tagLevelID);
        } else if (tagClassID) {
            formData.append("tagClassID", tagClassID);
        }

        const request = {
            url: `${API_HOST}/controller/Posting.asmx/savePost`,
            cache: false,
            type: 'POST',
            data: formData,
            enctype: 'multipart/form-data',
            processData: false,
            contentType: false,
            async: false,
            json: false,
            success: function (response) {
                return response;
            }
        };

        let response = await jQuery.ajax(request);
        if (typeof response === "string") {
            response = JSON.parse(response);
        }
        return response;
    }

    async saveReportPost(files, repTitle, repObservation, tagUserID, tagClassID, tagLevelID, postLinkID) {
        const postType = "REPORT";
        const formData = new FormData();
        formData.append('token', Cookies.get('authToken'));
        formData.append('UserID_Session', Cookies.get('userIDSession'));
        formData.append('UserSchool_Session', Cookies.get('schoolSession'));
        formData.append("repTitle", repTitle);
        formData.append("repObservation", repObservation);
        formData.append("postLinkID", postLinkID);

        if (files && files.length > 1) {
            for (let key in files) {
                // console.log(key);
                if (files.hasOwnProperty(key)) {
                    // console.log(files[key]);
                    if (key > 0) {
                        formData.append(`upload_${key}`, files[key]);
                    } else {
                        formData.append("upload", files[key]);
                    }
                }
            }
        } else if (files) {
            formData.append("upload", files[0]);
        }

        // formData.append("tagAcademicYearID", tagAcademicYearID);
        formData.append("postType", postType);

        if (tagUserID && tagUserID.length > 0) {
            formData.append("tagUserID", tagUserID);
        } else if (tagLevelID) {
            formData.append("tagLevelID", tagLevelID);
        } else if (tagClassID) {
            formData.append("tagClassID", tagClassID);
        }

        const request = {
            url: `${API_HOST}/controller/Posting.asmx/savePost`,
            cache: false,
            type: 'POST',
            data: formData,
            enctype: 'multipart/form-data',
            processData: false,
            contentType: false,
            async: false,
            json: false,
            success: function (response) {
                return response;
            }
        };

        let response = await jQuery.ajax(request);
        if (typeof response === "string") {
            response = JSON.parse(response);
        }
        return response;
    }

    async saveDocumentPost(files, docContent, postLinkID) {
        const postType = "DOCUMENTATION";
        const formData = new FormData();
        formData.append('token', Cookies.get('authToken'));
        formData.append('UserID_Session', Cookies.get('userIDSession'));
        formData.append('UserSchool_Session', Cookies.get('schoolSession'));
        formData.append("docContent", docContent);
        formData.append("postLinkID", postLinkID);

        if (files && files.length > 1) {
            for (let key in files) {
                // console.log(key);
                if (files.hasOwnProperty(key)) {
                    // console.log(files[key]);
                    if (key > 0) {
                        formData.append(`upload_${key}`, files[key]);
                    } else {
                        formData.append("upload", files[key]);
                    }
                }
            }
        } else if (files) {
            formData.append("upload", files[0]);
        }

        // formData.append("tagAcademicYearID", tagAcademicYearID);
        formData.append("postType", postType);

        if (tagUserID && tagUserID.length > 0) {
            formData.append("tagUserID", "");
        } else if (tagLevelID) {
            formData.append("tagLevelID", "");
        } else if (tagClassID) {
            formData.append("tagClassID", "");
        }

        const request = {
            url: `${API_HOST}/controller/Posting.asmx/savePost`,
            cache: false,
            type: 'POST',
            data: formData,
            enctype: 'multipart/form-data',
            processData: false,
            contentType: false,
            async: false,
            json: false,
            success: function (response) {
                return response;
            }
        };

        let response = await jQuery.ajax(request);
        if (typeof response === "string") {
            response = JSON.parse(response);
        }
        return response;
    }

    async saveBroadcastPost(files, broadContent, tagUserID, tagClassID, tagLevelID, postLinkID, broadMessage) {
        const postType = "BROADCAST";
        const formData = new FormData();
        formData.append('token', Cookies.get('authToken'));
        formData.append('UserID_Session', Cookies.get('userIDSession'));
        formData.append('UserSchool_Session', Cookies.get('schoolSession'));
        formData.append("broadContent", broadContent);
        formData.append("postLinkID", postLinkID);
        formData.append("broadMsg", broadMessage);

        if (files && files.length > 1) {
            for (let key in files) {
                // console.log(key);
                if (files.hasOwnProperty(key)) {
                    // console.log(files[key]);
                    if (key > 0) {
                        formData.append(`upload_${key}`, files[key]);
                    } else {
                        formData.append("upload", files[key]);
                    }
                }
            }
        } else if (files) {
            formData.append("upload", files[0]);
        }

        // formData.append("tagAcademicYearID", tagAcademicYearID);
        formData.append("postType", postType);

        if (tagUserID && tagUserID.length > 0) {
            formData.append("tagUserID", tagUserID);
        } else if (tagLevelID) {
            formData.append("tagLevelID", tagLevelID);
        } else if (tagClassID) {
            formData.append("tagClassID", tagClassID);
        }

        const request = {
            url: `${API_HOST}/controller/Posting.asmx/savePost`,
            cache: false,
            type: 'POST',
            data: formData,
            enctype: 'multipart/form-data',
            processData: false,
            contentType: false,
            async: false,
            json: false,
            success: function (response) {
                return response;
            }
        };

        let response = await jQuery.ajax(request);
        if (typeof response === "string") {
            response = JSON.parse(response);
        }
        return response;
    }

    async getPostFile(postID) {
        const data = {
            postID: postID
        };
        const response = await this.callWebService("/controller/Posting.asmx/getPostFile", data, "POST");
        return response;
    }

    async getPostFileWithoutTokenCheckByEncryptedPostID(encryptedPostID) {
        const data = {
            encryptedPostID: encryptedPostID
        };
        const response = await this.callWebService("/controller/Posting.asmx/getPostFileWithoutTokenCheckByEncryptedPostID", data, "POST");
        return response;
    }

    async getPostAllTaggingStudentsByPostID(postID, postStatus) {
        const data = {
            postID: postID,
            postStatus: postStatus,
        };
        const response = await this.callWebService("/controller/Posting.asmx/getPostAllTaggingStudentsByPostID", data, "POST");
        return response;
    }

    async getPostTagListByPostID(postID) {
        const data = {
            postID: postID,
        };
        const response = await this.callWebService("/controller/Posting.asmx/postTagLists", data, "POST");
        return response;
    }

    async saveComment(PostID, postContent) {
        const data = {
            postID: PostID,
            postContent: postContent,
        };
        const response = await this.callWebService("/controller/Posting.asmx/savePostComment", data, "POST");
        return response;
    }

    async getComment(PostID) {
        const data = {
            postId: PostID
        };
        const response = await this.callWebService("/controller/Posting.asmx/getPostComment", data, "POST");
        return response;
    }

    async editComment(commentPostID, postContent, actionMode) {
        const data = {
            commentPostID: commentPostID,
            postContent: postContent,
            actionMode: actionMode
        };
        const response = await this.callWebService("/controller/Posting.asmx/updatePostComment", data, "POST");
        return response;
    }

    async deleteComment(commentPostID, postContent, actionMode) {
        const data = {
            commentPostID: commentPostID,
            postContent: postContent,
            actionMode: actionMode
        };
        const response = await this.callWebService("/controller/Posting.asmx/updatePostComment", data, "POST");
        return response;
    }

    async saveGallery(files, fileType, galFolderID, folderName) {

        const formData = new FormData();
        formData.append('token', Cookies.get('authToken'));
        formData.append('UserID_Session', Cookies.get('userIDSession'));

        if (files && files.length > 1) {
            for (let key in files) {
                // console.log(key);
                if (files.hasOwnProperty(key)) {
                    // console.log(files[key]);
                    if (key > 0) {
                        formData.append(`upload_${key}`, files[key]);
                    } else {
                        formData.append("upload", files[key]);
                    }
                }
            }
        } else if (files) {
            formData.append("upload", files[0]);
        }

        formData.append("fileType", fileType);
        formData.append("galFolderID", galFolderID);
        formData.append("folderName", folderName);

        const request = {
            url: `${API_HOST}/controller/Gallery.asmx/saveFile`,
            cache: false,
            type: 'POST',
            data: formData,
            enctype: 'multipart/form-data',
            processData: false,
            contentType: false,
            async: false,
            json: false,
            success: function (response) {
                return response;
            }
        };

        let response = await jQuery.ajax(request);
        if (typeof response === "string") {
            response = JSON.parse(response);
        }
        return response;

    }

    async pendingPost(ID, PostID, PostContent, PostStatus, PostCreatedDate, PostApproverID) {
        const data = {
            ID: ID,
            PostID: PostID,
            PostContent: PostContent,
            PostStatus: PostStatus,
            PostCreatedDate: PostCreatedDate,
            PostApproverID: PostApproverID
        };
        data.UserID_Session = Cookies.get('userIDSession');
        const response = await this.callWebService("/controller/Approver.asmx/getPendingApproverPost", data, "POST");
        return response;
    }

    async approvePost(postID, postType, actionStatus, postComment) {

        const data = {
            postID: postID,
            postType: postType,
            actionStatus: actionStatus,
            postComment: postComment
        };

        const response = await this.callWebService("/controller/Posting.asmx/approvePost", data, "POST");
        return response;
    }

    async updatePost(currentFiles, actionStatus, postID, UpdateContent, profolio, tagUserID, tagClassID, tagLevelID) {
        const formData = new FormData();
        formData.append('token', Cookies.get('authToken'));
        formData.append('UserID_Session', Cookies.get('userIDSession'));
        console.log(currentFiles);
        if (currentFiles && currentFiles.length > 1) {
            for (let key in currentFiles) {
                // console.log(key);
                if (currentFiles.hasOwnProperty(key)) {
                    // console.log(files[key]);
                    if (key > 0) {
                        formData.append(`upload_${key}`, currentFiles[key]);
                    } else {
                        formData.append("upload", currentFiles[key]);
                    }
                }
            }
        } else if (currentFiles) {
            formData.append("upload", currentFiles[0]);
        }

        formData.append("actionStatus", actionStatus);
        formData.append("postID", postID);
        formData.append("UpdateContent", UpdateContent);
        formData.append("profolio", profolio);
        formData.append("tagUserID", tagUserID);
        formData.append("tagClassID", tagClassID);
        formData.append("tagLevelID", tagLevelID);

        const request = {
            url: `${API_HOST}/controller/Posting.asmx/updatePost`,
            cache: false,
            type: 'POST',
            data: formData,
            enctype: 'multipart/form-data',
            processData: false,
            contentType: false,
            async: false,
            json: false,
            success: function (response) {
                return response;
            }
        };

        let response = await jQuery.ajax(request);
        if (typeof response === "string") {
            response = JSON.parse(response);
        }
        return response;
    }

    async softDeletePost(postId, profolio) {
        const data = {
            postID: postId,
            profolio,
            actionStatus: "Void"
        };

        const response = await this.callWebService("/controller/Posting.asmx/updatePost", data, "POST");
        return response;
    }

    async getApproverMaster() {
        const data = {};

        const response = await this.callWebService("/controller/Approver.asmx/getApproverMaster", data, "POST");
        return response;
    }

    async saveApproverMaster(approverLevel, approverUserID, approverType) {
        const data = {
            approverLevel: approverLevel,
            approverUserID: approverUserID,
            approverType: approverType
        };

        const response = await this.callWebService("/controller/Approver.asmx/saveApproverMaster", data, "POST");
        return response;
    }

    async updateApproverMaster(approverMasterID, actionStatus) {
        const data = {
            approverMasterID: approverMasterID,
            actionStatus: actionStatus,
        };

        const response = await this.callWebService("/controller/Approver.asmx/updateApproverMaster", data, "POST");
        return response;
    }

    async getApproverMasterSpecificUser() {
        const data = {};

        const response = await this.callWebService("/controller/Approver.asmx/getApproverMasterSpecificUser", data, "POST");
        return response;
    }

    async updateApproverMasterSpecificUser(approverMasterSpecificID, actionStatus) {
        const data = {
            approverMasterSpecificID: approverMasterSpecificID,
            actionStatus: actionStatus
        };

        const response = await this.callWebService("/controller/Approver.asmx/updateApproverMasterSpecificUser", data, "POST");
        return response;
    }

    async saveApproverMasterSpecificUser(neededApproveSpecificUserID, approverType) {
        const data = {
            neededApproveSpecificUserID: neededApproveSpecificUserID,
            approverType: approverType
        };

        const response = await this.callWebService("/controller/Approver.asmx/saveApproverMasterSpecificUser", data, "POST");
        return response;
    }

    async getPendingApprover() {
        const data = {};

        const response = await this.callWebService("/controller/Approver.asmx/getPendingApprover", data, "POST");
        return response;
    }

    async checkApproveStatusByUser(itemID, mode) {
        const data = {
            itemID: itemID,
            mode: mode
        };

        let result = await this.callWebService("/controller/Approver.asmx/checkApproveStatusByUser", data, "POST");
        return result;
    }

    async login2(userId, password) {
        const data = {
            username: userId,
            password: password
        };
        const response = await this.callAPI("/login", "POST", null, data);
        Cookies.set('authToken', response.token, {expires: 3 / 24}); //expire in 3 hour);
        return response;
    }

    async getCountryList() {
        // let response;
        // try {
        //     response = await fetch("http://local.emsv2/controller/Students.asmx/getCountryList");
        // } catch (err) {
        //     console.log(err);
        //     throw ERROR_SERVER_UNREACHABLE;
        // }
        // return await parseResponseAndHandleErrors(response);

        const data = {};

        const response = await this.callWebService("/controller/Students.asmx/getCountryList", data, "POST");
        return response;
    }

    async getCountryListwBlank() {
        // let response;
        // try {
        //     response = await fetch("http://local.emsv2/controller/Students.asmx/getCountryList");
        // } catch (err) {
        //     console.log(err);
        //     throw ERROR_SERVER_UNREACHABLE;
        // }
        // return await parseResponseAndHandleErrors(response);

        const data = {};

        const response = await this.callWebService("/controller/Students.asmx/getCountryListwBlank", data, "POST");
        return response;
    }

    async getLevel(customLevelNotEqual) {
        const data = {
            customLevelNotEqual: customLevelNotEqual,
        };
        const response = await this.callWebService("/controller/Course.asmx/getLevel", data, "POST");
        return response;
    }

    async getLevelAll(customLevelNotEqual) {
        const data = {
            customLevelNotEqual: customLevelNotEqual,
        };
        const response = await this.callWebService("/controller/Course.asmx/getLevelAll", data, "POST");
        return response;
    }

    async getClassLevel(courseID, schoolID) {
        const data = {
            courseID: courseID,
            schoolID: schoolID,
        };
        const response = await this.callWebService("/controller/Course.asmx/getLevelClass", data, "POST");
        return response;
    }


    async getLevelSpecificSchool(speificSchoolID) {
        const data = {
            speificSchoolID: speificSchoolID,
        };
        const response = await this.callWebService("/controller/Course.asmx/getLevel", data, "POST");
        return response;
    }

    async getStudentDropDownList(jsonString) {
        const data = {
            jsonString: jsonString,
        };
        const response = await this.callWebService("/controller/Students.asmx/getStudentDropDownList", data, "POST");
        return response;
    }

    async getStudentEnrollment(passHowManyDaysStudentCreated) {
        const data = {
            passHowManyDaysStudentCreated: passHowManyDaysStudentCreated
        };
        const response = await this.callWebService("/controller/Students.asmx/getNewEnrolmentBySchoolWithPastDay", data, "POST");
        return response;
    }

    async getWithdrawStudent(passHowManyDays) {
        const data = {
            passHowManyDays: passHowManyDays
        };
        const response = await this.callWebService("/controller/Students.asmx/getWithdrawnBySchoolWithPastDay", data, "POST");
        return response;
    }

    async getTransferStudent(pastHowManyDays) {
        const data = {
            pastHowManyDays: pastHowManyDays
        };
        const response = await this.callWebService("/controller/Students.asmx/getTransferBySchoolWithPastDay", data, "POST");
        return response;
    }

    async getAcademicYear() {
        const data = {};
        const response = await this.callWebService("/controller/Course.asmx/getAcademicYear", data, "POST");
        return response;
    }

    async getAcademicYearWithClosedPastYear() {
        const data = {};
        const response = await this.callWebService("/controller/Course.asmx/getAcademicYearWithClosedPastYear", data, "POST");
        return response;
    }

    async getAcademicYearforFourYears() {
        const data = {};
        const response = await this.callWebService("/controller/Course.asmx/getAcademicYearforFourYears", data, "POST");
        return response;
    }

    async getAcademicYearBySchoolID(customSchoolName) {
        const data = {
            customSchoolName: customSchoolName
        };
        const response = await this.callWebService("/controller/Course.asmx/getAcademicYear", data, "POST");
        return response;
    }

    async getAllAcademicYears(customSchoolName) {
        const data = {
            customSchoolName: customSchoolName
        };
        const response = await this.callWebService("/controller/Course.asmx/getAllAcademicYears", data, "POST");
        return response;
    }

    async getAllAcademicYearsByGroup(schoolGroup) {
        const data = {
            schoolGroup: schoolGroup
        };
        const response = await this.callWebService("/controller/Course.asmx/getAllAcademicYearsByGroup", data, "POST");
        return response;
    }

    async getIntakeYear() {
        const data = {};
        const response = await this.callWebService("/controller/Students.asmx/getIntakeYear", data, "POST");
        return response;
    }

    // SAMPLE 2 using axios
    async PostToGetDataWEIRD() {
        const options = {
            countryID: "",
        };

        let response;
        try {
            response = await axios.post("http://local.emsv2/controller/Students.asmx/getCountryList?countryID=", options);
        } catch (err) {
            console.log(err);
            throw ERROR_SERVER_UNREACHABLE;
        }
        return response.data;
    }

    // POST SAMPLE
    async createStudent() {
        const headers = new Headers();
        headers.append("Content-Type", "application/json");
        const request = {
            method: "POST",
            headers: headers,
        };
        const requestBody = {
            countryID: "",
        };
        request.body = JSON.stringify(rquestBody);

        let response;
        try {
            response = await fetch("URL", request);
        } catch (err) {
            console.log(err);
            getApproverMaster;
            throw ERROR_SERVER_UNREACHABLE;
        }
        return await parseResponseAndHandleErrors(response);
    }

    async getAttendanceClass() {
        const data = {};
        const response = await this.callWebService("/controller/Attendance.asmx/getAttendanceClass", data, "POST");
        return response;
    }

    async getAttendanceClassWithMode(mode) {
        const data = {
            mode: mode,
        };
        const response = await this.callWebService("/controller/Attendance.asmx/getAttendanceClass", data, "POST");
        return response;
    }

    async LoadAttendanceList(classValue, statuses) {

        const data = {
            classValue: classValue,
            statuses: statuses
        };
        const response = await this.callWebService("/controller/Attendance.asmx/LoadAttendanceList", data, "POST");
        return response;
    }

    async LoadAttendanceAudit(strStartDate, strEndDate, indexNo) {

        const data = {
            startDate: strStartDate,
            endDate: strEndDate,
            indexNo: indexNo,
        };

        const response = await this.callWebService("/controller/Attendance.asmx/LoadAttendanceAudit", data, "POST");
        return response;
    }


    async LoadAttendanceListWithMode(classValue, mode) {

        const data = {
            classValue: classValue,
            mode: mode,
        };
        const response = await this.callWebService("/controller/Attendance.asmx/LoadAttendanceList", data, "POST");
        return response;
    }

    async LoadAttendanceListWithDateMode(classValue, mode, loadDate) {

        const data = {
            classValue: classValue,
            mode: mode,
            loadDate: loadDate
        };
        const response = await this.callWebService("/controller/Attendance.asmx/LoadAttendanceList", data, "POST");
        return response;
    }

    async updateAttendanceList(jsonString) {
        const data = {
            jsonString: jsonString,
        };
        const response = await this.callWebService("/controller/Attendance.asmx/updateAttendanceList", data, "POST");
        return response;
    }

    async updateAttendanceListWithDateMode(jsonString, loadDate) {
        console.log("here!!!", loadDate)
        const data = {
            jsonString: jsonString,
            loadDate: loadDate,
        };
        const response = await this.callWebService("/controller/Attendance.asmx/updateAttendanceList", data, "POST");
        return response;
    }

    //#region Gallery
    async getFiles(galFolderID, startRowNo, endRowNo, fileText) {
        const data = {
            galFolderID: galFolderID,
            startRowNo: startRowNo,
            endRowNo: endRowNo,
            fileRetrieveMode: "File",
            fileText: fileText
        };

        const response = await this.callWebService("/controller/Gallery.asmx/getFile", data, "POST");
        return response;
    }

    async getFolders(galFolderID) {
        const data = {
            galFolderID: galFolderID,
            fileRetrieveMode: "Folder"
        };

        const response = await this.callWebService("/controller/Gallery.asmx/getFile", data, "POST");
        return response;
    }

    async downloadFile(galID) {
        const data = {
            galID: galID
        };

        const response = await this.callWebService("/controller/Gallery.asmx/downloadFile", data, "POST");
        return response;
    }

    async saveFile(files, galFolderID) {
        const formData = new FormData();

        formData.append('fileType', "File");
        formData.append('galFolderID', galFolderID);
        formData.append('token', Cookies.get('authToken'));
        formData.append('UserID_Session', Cookies.get('userIDSession'));
        formData.append('folderName', "");

        if (files && files.length > 1) {
            for (let i = 0; i < files.length; i++) {
                formData.append("files" + i, files[i]);
                // console.log(files[i], "more");
                formData.append("files" + i + '_FileText', files[i].FileText);
            }
        } else if (files /*&& files.length === 1*/) {
            formData.append("files", files[0]);
            formData.append("files_FileText", files[0].FileText);
        }

        const request = {
            url: `${API_HOST}/controller/Gallery.asmx/saveFile`,
            cache: false,
            type: 'POST',
            data: formData,
            enctype: 'multipart/form-data',
            processData: false,
            contentType: false,
            async: false,
            json: false,
            success: function (response) {
                return response;
            }
        };

        let response = await jQuery.ajax(request);
        if (typeof response === "string") {
            response = JSON.parse(response);
        }
        return response;
    }

    async createFolder(galFolderID, folderName) {
        const formData = new FormData();

        formData.append('fileType', "Folder");
        formData.append('galFolderID', galFolderID);
        formData.append('token', Cookies.get('authToken'));
        formData.append('UserID_Session', Cookies.get('userIDSession'));
        formData.append('folderName', folderName);
        formData.append("files", null);

        const request = {
            url: `${API_HOST}/controller/Gallery.asmx/saveFile`,
            cache: false,
            type: 'POST',
            data: formData,
            enctype: 'multipart/form-data',
            processData: false,
            contentType: false,
            async: false,
            json: false,
            success: function (response) {
                return response;
            }
        };

        let response = await jQuery.ajax(request);
        if (typeof response === "string") {
            response = JSON.parse(response);
        }
        return response;
    }

    async removeFile(galID) {
        const data = {
            galID: galID,
            updateFileMode: "Delete"
        };

        const response = await this.callWebService("/controller/Gallery.asmx/updateFile", data, "POST");
        return response;
    }

    async renameFile(galID, folderRename) {
        const data = {
            galID: galID,
            folderRename: folderRename,
            updateFileMode: "Rename"
        };

        const response = await this.callWebService("/controller/Gallery.asmx/updateFile", data, "POST");
        return response;
    }

    async moveFile(galID, galFolderID) {
        const data = {
            galID: galID,
            galFolderID: galFolderID,
            updateFileMode: "Move"
        };

        const response = await this.callWebService("/controller/Gallery.asmx/updateFile", data, "POST");
        return response;
    }

    async getWhitelist() {
        const data = {};
        const response = await this.callWebService("/controller/Gallery.asmx/getWhitelistFileExt", data, "POST");

        return response;
    }

    //#endregion

    /*#region Portfolio*/
    async updatePortfolio(portfolioID, actionStatus) {
        const data = {
            portfolioID: portfolioID,
            actionStatus: actionStatus,
        };

        const response = await this.callWebService("/controller/Portfolio.asmx/updatePortfolio", data, "POST");
        return response;
    }

    async getPortfolioListByStudentID(str_StudentID) {
        const data = {studentID: str_StudentID};

        return await this.callWebService("/controller/Portfolio.asmx/getPortfolioList", data, "POST");
    }

    async getPostByPortfolioID(str_PortfolioID) {
        const data = {portfolioID: str_PortfolioID};

        return await this.callWebService("/controller/Portfolio.asmx/getPortfolioPostingPost", data, "POST");
    }

    async getPortfolioHeaderDetails(portfolioID, byPassToken) {
        const data = {portfolioID: portfolioID, byPassToken: byPassToken};

        return await this.callWebService("/controller/Portfolio.asmx/getPortfolioHeaderDetails", data, "POST");
    }

    async getStudentPostByType(str_StudentID, str_PostType, numberOfPost, lastPostID, mode) {
        const data = {
            studentID: str_StudentID,
            postType: str_PostType,
            numberOfPost: numberOfPost,
            lastPostID: lastPostID,
            mode: mode
        };
        return await this.callWebService("/controller/Posting.asmx/getPostStudent", data, "POST");
    }


    async approvePortfolio(portfolioID, actionStatus, jsonHeaderComment, jsonPostComment) {
        const data = {
            portfolioID: portfolioID,
            actionStatus: actionStatus,
            jsonHeaderComment: jsonHeaderComment,
            jsonPostComment: jsonPostComment,
        };

        let result = await this.callWebService("/controller/Portfolio.asmx/approvePortfolio", data, "POST");
        return result;
    }

    async getApproverComment(itemID) {
        const data = {
            itemID: itemID,
        };

        let result = await this.callWebService("/controller/Approver.asmx/getApproverComment", data, "POST");
        return result;
    }

    /*#endregion*/

    /*#region Promotion*/
    async getPromotionAcademicYear() {
        const data = {};

        const response = await this.callWebService("/controller/Operations.asmx/getMassPromotionsAcademicYear", data, "POST");
        return response;
    }

    async getPromotionLevel() {
        const data = {};

        const response = await this.callWebService("/controller/Operations.asmx/getMassPromotionsLevel", data, "POST");
        return response;
    }

    async getClassByLevelClassID(str_LevelID, str_ClassID) {
        const data = {levelID: str_LevelID, classID: str_ClassID};

        const response = await this.callWebService("/controller/Operations.asmx/getMassPromotionsStudentListByClassLevel", data, "POST");
        return response;
    }

    async getClassByAcademicYear(str_AcademicYearID) {
        const data = {academicYearID: str_AcademicYearID};

        const response = await this.callWebService("/controller/Operations.asmx/getMassPromotionsClassLevelByAcademicYear", data, "POST");
        return response;
    }

    async getClassByAcademicYearBySchoolID(str_AcademicYearID, customSchoolID) {
        const data = {
            academicYearID: str_AcademicYearID,
            customSchoolID: customSchoolID
        };

        const response = await this.callWebService("/controller/Operations.asmx/getMassPromotionsClassLevelByAcademicYear", data, "POST");
        return response;
    }

    async getClassBySemesterAndCourseID(academicYear, courseID) {
        const data = {
            academicYear: academicYear,
            courseID: courseID
        };

        const response = await this.callWebService("/controller/Course.asmx/getClass", data, "POST");
        return response;
    }

    async getNextLevel(str_LevelID) {
        const data = {levelID: str_LevelID};

        const response = await this.callWebService("/controller/Operations.asmx/getMassPromotionsNextLevel", data, "POST");
        return response;
    }

    // studentIDArray (student id split by comma ",") & levelID & academicYearID & classID
    async saveStudentPromotions(arrstr_StudentID, str_AcademicYearID, str_LevelID, str_ClassID) {
        const data = {
            studentIDArray: arrstr_StudentID,
            academicYearID: str_AcademicYearID,
            levelID: str_LevelID,
            classID: str_ClassID
        };

        const response = await this.callWebService("/controller/Operations.asmx/saveMassPromotions", data, "POST");
        return response;
    }

    async getAllActiveStudentsBySchool() {
        const data = {};

        const response = await this.callWebService("/controller/Students.asmx/getAllActiveStudentsBySchool", data, "POST");
        return response;
    }

    async getAllActiveStudentsBySchoolWithMode(mode) {
        const data = {
            mode: mode,
        };

        const response = await this.callWebService("/controller/Students.asmx/getAllActiveStudentsBySchool", data, "POST");
        return response;
    }

    /*#endregion*/

    /*#region Report*/

    async getReportListByStudentID(str_StudentID) {
        const data = {studentID: str_StudentID};

        return await this.callWebService("/controller/Report.asmx/getReportList", data, "POST");
    }

    async saveReport(str_ReportDesc, str_StudentID, arrstr_PostID, ReportLinkReportID) {
        const data = {
            reportDesc: str_ReportDesc,
            studentID: str_StudentID,
            jsonStringPostID: arrstr_PostID,
            ReportLinkReportID: ReportLinkReportID,
        };

        return await this.callWebService("/controller/Report.asmx/saveReport", data, "POST");
    }

    async getPostByReportID(str_ReportID) {
        const data = {reportID: str_ReportID};

        return await this.callWebService("/controller/Report.asmx/getReport", data, "POST");
    }

    async softDeleteReport(arrstr_ReportID) {
        const data = {
            jsonStringReportID: arrstr_ReportID,
            actionStatus: "VOID"
        };

        const response = await this.callWebService("/controller/Report.asmx/updateReport", data, "POST");
        return response;
    }

    /*#endregion*/

    /*#region Reactions*/
    async getPostReaction(relatedPostID) {
        const data = {relatedPostID: relatedPostID};

        return await this.callWebService("/controller/Posting.asmx/getPostReaction", data, "POST");
    }

    async savePostReaction(relatedPostID, postReaction, postType) {
        const data = {
            relatedPostID: relatedPostID,
            postReaction: postReaction,
            postType: postType,
        };

        return await this.callWebService("/controller/Posting.asmx/savePostReaction", data, "POST");
    }

    async updatePostReaction(relatedPostID, actionMode) {
        const data = {
            relatedPostID: relatedPostID,
            actionMode: actionMode,
        };

        return await this.callWebService("/controller/Posting.asmx/updatePostReaction", data, "POST");
    }

    async getPostByPostID(jsonStringPostID) {
        const data = {
            jsonStringPostID: jsonStringPostID,
        };

        return await this.callWebService("/controller/Posting.asmx/getPostByPostID", data, "POST");
    }

    async getPostByPostIDByStatus(jsonStringPostID, postStatus) {
        const data = {
            jsonStringPostID: jsonStringPostID,
            postStatus: postStatus,
        };

        return await this.callWebService("/controller/Posting.asmx/getPostByPostID", data, "POST");
    }

    /*#endregion*/

    async getAllActiveStudentsByClass(classID) {
        const data = {classID: classID};

        const response = await this.callWebService("/controller/Students.asmx/getAllActiveStudentsByClassSchool", data, "POST");
        return response;
    }

    async getDailyRoutineByStudentID(studentID) {
        const data = {studentID: studentID};

        const response = await this.callWebService("/controller/Daily_Routine.asmx/getKgm_DailyRoutine", data, "POST");
        return response;
    }

    async updateDailyRoutine(btnUpdateObject) {
        const data = {
            studentID: btnUpdateObject.studentID,
            DrID: btnUpdateObject.drID,
            drRemark: btnUpdateObject.drRemark
        };
        const response = await this.callWebService("/controller/Daily_Routine.asmx/updateDailyRoutine", data, "POST");
        return response;
    }

    async addDailyRoutine(btnAddObject) {
        const data = {
            studentIDArray: btnAddObject.studentIDArray,
            drRemark: btnAddObject.DrRemark,
            drStartTime: btnAddObject.DrStartTime,
            drEndTime: btnAddObject.DrEndTime,
            drReferenceType: btnAddObject.DrReferenceType
        };

        const response = await this.callWebService("/controller/Daily_Routine.asmx/addDailyRoutine", data, "POST");
        return response;
    }

    async deleteDailyRoutine(btnDelObject) {
        const data = {
            studentID: btnDelObject.DrStudentID,
            DrID: btnDelObject.drID
        };
        const response = await this.callWebService("/controller/Daily_Routine.asmx/deleteDailyRoutine", data, "POST");
        return response;
    }

    async deString(inputString) {
        const data = {
            inputString: inputString
        };
        const response = await this.callWebService("/controller/Login.asmx/deString", data, "POST");
        return response;
    }

    async getStaffProfileImage() {
        const data = {};
        const response = await this.callWebService("/controller/User.asmx/getStaffProfileImage", data, "POST");
        return response;
    }

    async saveStaffProfileImage(files) {
        const data = new FormData();
        data.append('token', Cookies.get('authToken'));
        data.append('UserSchool_Session', Cookies.get('schoolSession'));
        data.append('UserID_Session', Cookies.get('userIDSession'));
        data.append('UserUniversity_Session', Cookies.get('userUniversitySession'));

        if (files && files.length > 1) {
            for (let key in files) {
                //console.log(key);
                if (files.hasOwnProperty(key)) {
                    // console.log(files[key]);
                    if (key > 0) {
                        data.append(`upload_${key}`, files[key]);
                    } else {
                        data.append("upload", files[key]);
                    }
                }
            }
        } else if (files) {
            data.append("upload", files[0]);
        }

        const request = {
            url: `${API_HOST}/controller/User.asmx/saveStaffProfileImage`,
            cache: false,
            type: 'POST',
            data: data,
            enctype: 'multipart/form-data',
            processData: false,
            contentType: false,
            async: false,
            json: false,
            success: function (response) {
                return response;
            }
        };

        let response = await jQuery.ajax(request);
        if (typeof response === "string") {
            response = JSON.parse(response);
        }
        return response;
    }

    async resetPasswordByPassword(userCurrentPassword, userNewPassword) {
        const data = {
            userCurrentPassword: userCurrentPassword,
            userNewPassword: userNewPassword
        };
        const response = await this.callWebService("/controller/Login.asmx/resetPasswordByPassword", data, "POST");
        return response;
    }

    async getAllActiveSchool(schoolCountry, universityCode) {
        const data = {
            schoolCountry: schoolCountry,
            universityCode: universityCode,
        };
        const response = await this.callWebService("/controller/Operations.asmx/getAllActiveSchool", data, "POST");
        return response;
    }

    async saveTransferSchool(studentID, toTransferSchoolID, remark, effectiveDate, referralTransfer) {
        const data = {
            studentID: studentID,
            toTransferSchoolID: toTransferSchoolID,
            remark: remark,
            effectiveDate: effectiveDate,
            referralTransfer: referralTransfer,
        };
        const response = await this.callWebService("/controller/Students.asmx/saveTransferSchool", data, "POST");
        return response;
    }

    async saveTransferSchoolAllowToday(studentID, toTransferSchoolID, remark, effectiveDate, referralTransfer) {
        const data = {
            studentID: studentID,
            toTransferSchoolID: toTransferSchoolID,
            remark: remark,
            effectiveDate: effectiveDate,
            referralTransfer: referralTransfer,
        };
        const response = await this.callWebService("/controller/Students.asmx/saveTransferSchoolAllowToday", data, "POST");
        return response;
    }

    async getPendingAcceptTransferSchoolBySchool() {
        const data = {};
        const response = await this.callWebService("/controller/Students.asmx/getPendingAcceptTransferSchoolBySchool", data, "POST");
        return response;
    }

    async getClassType(filter_school=null) {
        const data = {filter_school:filter_school};
        const response = await this.callWebService("/controller/Class.asmx/getClassType", data, "POST");
        return response;
    }

    async getTeacherListBySchool() {
        const data = {};
        const response = await this.callWebService("/controller/User.asmx/getTeacherListBySchool", data, "POST");
        return response;
    }

    async getTeacherPrinListBySchool() {
        const data = {};
        const response = await this.callWebService("/controller/User.asmx/getTeacherPrinListBySchool", data, "POST");
        return response;
    }

    getFeedFilterSemesterList() {
        return this.callWebService('/controller/Api.asmx/GetFilterSemesterList', {}, 'POST');
    }

    getFeedFilterLevelList() {
        return this.callWebService('/controller/Api.asmx/GetFilterLevelList', {}, 'POST');
    }

    getFeedFilterClassList() {
        return this.callWebService('/controller/Api.asmx/GetFilterClassList', {}, 'POST');
    }

    getFeedFilterTeacherList() {
        return this.callWebService('/controller/Api.asmx/GetFilterTeacherList', {}, 'POST');
    }

    GetAlumniReport(dateRange,schoolID) {
        const data = {
            dateRange: dateRange,
            schoolID: schoolID,

        };
        return this.callWebService('/controller/Api.asmx/GetAlumniReport', data, 'POST');
    }

    GetSchoolFeeReport1(school,academicyear) {
        const data = {
            school: school,
            academicyear: academicyear,

        };
        return this.callWebService('/controller/Api.asmx/GetSchoolFeeReport1', data, 'POST');
    }

    GetSchoolFeeReport2(school,academicyear) {
        const data = {
            school: school,
            academicyear: academicyear,

        };
        return this.callWebService('/controller/Api.asmx/GetSchoolFeeReport2', data, 'POST');
    }

    GetSchoolFeeReportManualMovement_Withdrawal(school,academicyear) {
        const data = {
            school: school,
            academicyear: academicyear,

        };
        return this.callWebService('/controller/Api.asmx/GetSchoolFeeReportManualMovement_Withdrawal', data, 'POST');
    }

    GetGroupSchoolFeeReport1(school,academicyear) {
        const data = {
            school: school,
            academicyear: academicyear,

        };
        return this.callWebService('/controller/Api.asmx/GetGroupSchoolFeeReport1', data, 'POST');
    }

    GetGroupSchoolFeeReport2(school,academicyear) {
        const data = {
            school: school,
            academicyear: academicyear,

        };
        return this.callWebService('/controller/Api.asmx/GetGroupSchoolFeeReport2', data, 'POST');
    }

    GetAlumniRelationshipReport(dateRange,schoolID) {
        const data = {
            dateRange: dateRange,
            schoolID: schoolID,

        };
        return this.callWebService('/controller/Api.asmx/GetAlumniRelationshipReport', data, 'POST');
    }
    GetParentsEmail(studentID) {
        const data = {
            studentID: studentID,

        };
        return this.callWebService('/controller/Api.asmx/GetParentsEmail', data, 'POST');
    }
    ClassTransferGoals(crsID,fromClassID,toClassID,semID) {
        const data = {

            crsID: crsID,
            fromClassID: fromClassID,
            toClassID: toClassID,
            semID: semID,
        };
        return this.callWebService('/controller/Api.asmx/ClassTransferGoals', data, 'POST');
    }
    async GetFinanceNotificationEmailList(schoolID) {
        const data = {
            schoolID: schoolID,
        };
        return this.callWebService('/controller/Api.asmx/GetFinanceNotificationEmailList', data, 'POST');
    }
    async SaveFinanceNotificationEmailList(SchoolId,EmailTo,EmailCC,EmailBCC) {
        const data = {
            SchoolId: SchoolId,
            EmailTo: EmailTo,
            EmailCC: EmailCC,
            EmailBCC: EmailBCC,
        };
        return this.callWebService('/controller/Api.asmx/SaveFinanceNotificationEmailList', data, 'POST');
    }



    async saveClass(levelID, semesterID, batch, className, maxStudents, classTeacher, saveType, classAssitantTeacherID) {
        const data = {
            levelID: levelID,
            semesterID: semesterID,
            batch: batch,
            className: className,
            maxStudents: maxStudents,
            classTeacher: classTeacher,
            saveType: saveType,
            classAssitantTeacherID: classAssitantTeacherID,
        };
        const response = await this.callWebService("/controller/Class.asmx/saveClass", data, "POST");
        return response;
    }

    async getClass(academicYear) {
        const data = {
            academicYear: academicYear,
        };
        const response = await this.callWebService("/controller/Course.asmx/getClass", data, "POST");
        return response;
    }

    async getClassIncludeClosed(academicYear) {
        const data = {
            academicYear: academicYear,
        };
        const response = await this.callWebService("/controller/Course.asmx/getClassIncludeClosed", data, "POST");
        return response;
    }

    async getClassByLevel(courseID) {
        const data = {
            courseID: courseID,
        };
        const response = await this.callWebService("/controller/Course.asmx/getClass", data, "POST");
        return response;
    }

    async getStudentType() {
        const data = {
            courseID: "courseID",
        };
        const response = await this.callWebService("/controller/Students.asmx/getStudentType", data, "POST");
        return response;
    }

    async getStudentByCourseClassType(CourseID,ClassID,StudentType) {
        const data = {
            CourseID: CourseID,
            ClassID: ClassID,
            StudentType: StudentType,
        };
        const response = await this.callWebService("/controller/Students.asmx/getStudentByCourseClassType", data, "POST");
        return response;
    }

    async getParentClassList(academicYear, modeType) {
        const data = {
            academicYear: academicYear,
            modeType: modeType,
        };
        const response = await this.callWebService("/controller/Course.asmx/getClass", data, "POST");
        return response;
    }

    async updateClass(classStatus, newClassName, maxStudents, currentClassName, levelID, semesterID, classTeacherID, classAssitantTeacherID) {
        const data = {
            classStatus: classStatus,
            newClassName: newClassName,
            maxStudents: maxStudents,
            currentClassName: currentClassName,
            levelID: levelID,
            semesterID: semesterID,
            classTeacherID: classTeacherID,
            classAssitantTeacherID: classAssitantTeacherID,
        };
        const response = await this.callWebService("/controller/Class.asmx/updateClass", data, "POST");
        return response;
    }

    async updateClassProgramme(classID, classStatus) {
        const data = {
            classID: classID,
            classStatus: classStatus,
        };
        const response = await this.callWebService("/controller/Class.asmx/updateClassProgramme", data, "POST");
        return response;
    }

    async getActiveStudentsByLevelSchool(levelID, classID, semID, includePendingStatus, filterClassScheduleDate) {
        const data = {
            levelID: levelID,
            classID: classID,
            semID: semID,
            includePendingStatus: includePendingStatus,
            filterClassScheduleDate: filterClassScheduleDate,
        };
        const response = await this.callWebService("/controller/Students.asmx/getActiveStudentsByLevelSchool", data, "POST");
        return response;
    }

    async saveStudentGraduation(obj) {
        const data = {
            obj: obj
        };
        const response = await this.callWebService("/controller/Students.asmx/saveStudentGraduation", data, "POST");
        return response;
    }

    async saveStudentDocument(files, studentID, fileDescription, uploadMode, parFolder) {
        const data = new FormData();
        data.append('token', Cookies.get('authToken'));
        data.append('UserSchool_Session', Cookies.get('schoolSession'));
        data.append('UserID_Session', Cookies.get('userIDSession'));
        data.append('UserUniversity_Session', Cookies.get('userUniversitySession'));

        if (files && files.length > 1) {
            for (let key in files) {
                //console.log(key);
                if (files.hasOwnProperty(key)) {
                    // console.log(files[key]);
                    if (key > 0) {
                        data.append(`upload_${key}`, files[key]);
                    } else {
                        data.append("upload", files[key]);
                    }
                }
            }
        } else if (files) {
            data.append("upload", files[0]);
        }

        data.append('studentID', studentID);
        data.append('fileDescription', fileDescription);
        data.append('uploadMode', uploadMode);
        data.append('parFolder', parFolder);

        const request = {
            url: `${API_HOST}/controller/Students.asmx/saveStudentDocument`,
            cache: false,
            type: 'POST',
            data: data,
            enctype: 'multipart/form-data',
            processData: false,
            contentType: false,
            async: false,
            json: false,
            success: function (response) {
                return response;
            }
        };

        let response = await jQuery.ajax(request);
        if (typeof response === "string") {
            response = JSON.parse(response);
        }
        return response;
    }

    async getStudentDocument(studentID, docType, parFolder) {
        const data = {
            studentID: studentID,
            docType: docType,
            parFolder: parFolder,
        };
        const response = await this.callWebService("/controller/Students.asmx/getStudentDocument", data, "POST");
        return response;
    }

    async getStudentDocumentBase64String(studentFilesID) {
        const data = {
            studentFilesID: studentFilesID,
        };
        const response = await this.callWebService("/controller/Students.asmx/getStudentDocumentBase64String", data, "POST");
        return response;
    }

    async updateStudentDocument(studentFilesID, actionStatus) {
        const data = {
            studentFilesID: studentFilesID,
            actionStatus: actionStatus,
        };
        const response = await this.callWebService("/controller/Students.asmx/updateStudentDocument", data, "POST");
        return response;
    }

    async getSchoolInfoBySchoolID(schoolID) {
        const data = {
            schoolID: schoolID,
        };
        const response = await this.callWebService("/controller/User.asmx/getSchoolInfoBySchoolID", data, "POST");
        return response;
    }

    async getStudentAllergies(studentID, allergiesType) {
        const data = {
            studentID: studentID,
            allergiesType: allergiesType,
        };
        const response = await this.callWebService("/controller/Students.asmx/getStudentAllergies", data, "POST");
        return response;
    }

    async getPaymentList(studentCourseID, studentID) {
        const data = {
            studentCourseID: studentCourseID,
            studentID: studentID,
        };
        const response = await this.callWebService("/controller/Billing.asmx/getPaymentList", data, "POST");
        return response;
    }

    async getItemTransDetailsList(SPDID) {
        const data = {
            SPDID: SPDID,
        };
        const response = await this.callWebService("/controller/Billing.asmx/getItemTransDetailsList", data, "POST");
        return response;
    }

    async saveEvent(files, obj, participantObj) {
        const formData = new FormData();
        formData.append("obj", obj);
        formData.append("ParticipantObj", participantObj);
        formData.append('token', Cookies.get('authToken'));
        formData.append('UserID_Session', Cookies.get('userIDSession'));
        formData.append('UserSchool_Session', Cookies.get('schoolSession'));
        formData.append('UserType_Session', Cookies.get('userTypeSession'));
        formData.append('UserUniversitySession', Cookies.get('userUniversitySession'));
        formData.append('UserEmailSession', Cookies.get('userEmailSession'));
        formData.append('USRidSession', Cookies.get('usRidSession'));
        formData.append('UserNameSession', Cookies.get('userNameSession'));
        console.log(files, "files");
        if (files && files.length > 1) {
            for (let key in files) {
                // console.log(key);
                if (files.hasOwnProperty(key)) {
                    // console.log(files[key]);
                    if (key > 0) {
                        formData.append(`upload_${key}`, files[key]);
                    } else {
                        formData.append("upload", files[key]);
                    }
                }
            }
        } else if (files) {
            formData.append("upload", files[0]);
        }
        const request = {
            url: `${API_HOST}/controller/Event.asmx/saveEvent`,
            cache: false,
            type: 'POST',
            data: formData,
            enctype: 'multipart/form-data',
            processData: false,
            contentType: false,
            async: false,
            json: false,
            success: function (response) {
                return response;
            }
        };
        let response = await jQuery.ajax(request);
        if (typeof response === "string") {
            response = JSON.parse(response);
        }
        return response;
        // const data = {
        //     obj: obj,
        //     ParticipantObj: participantObj,
        // };
        // if (files && files.length > 1) {
        //     for (let key in files) {
        //         // console.log(key);
        //         if (files.hasOwnProperty(key)) {
        //             // console.log(files[key]);
        //             if (key > 0) {
        //                 data[`upload_${key}`] = files[key];
        //             } else {
        //                 data.upload = files[key];
        //             }
        //         }
        //     }
        // } else if (files) {
        //     data.upload = files[0];
        // }
        //
        // console.log("data", data);
        //
        // const response = await this.callWebService("/controller/Event.asmx/saveEvent", data, "POST",true,false);
        //
        // console.log("res", response);
        //
        // return response;
    }

    async getEvent(dateFrom, dateTo) {
        const data = {
            dateFrom: dateFrom,
            dateTo: dateTo,
        };
        const response = await this.callWebService("/controller/Event.asmx/getEventList", data, "POST");
        return response;
    }

    async getEventDetails(eventID) {
        const data = {
            eventID: eventID,
        };
        const response = await this.callWebService("/controller/Event.asmx/getEventDetails", data, "POST");
        return response;
    }

    async getPublicRegistrationDetails(encryptedEventParID) {
        const data = {
            encryptedEventParID: encryptedEventParID,
        };
        const response = await this.callWebService("/controller/Event.asmx/getPublicRegistrationDetails", data, "POST");
        return response;
    }

    async getEventFile(eventID) {
        const data = {
            eventID: eventID
        };
        const response = await this.callWebService("/controller/Event.asmx/getEventFiles", data, "POST");
        return response;
    }

    async getUpComingEvent() {
        const data = {};
        const response = await this.callWebService("/controller/Event.asmx/getLatestUpComingEvents", data, "POST");
        return response;
    }

    async getUpComingEventDetail(obj) {
        const data = {
            obj: obj,
        };
        const response = await this.callWebService("/controller/Event.asmx/getUpComingEventDetail", data, "POST");
        return response;
    }

    async getEventParticipant(eventParticipantID) {
        const data = {
            eventParticipantID: eventParticipantID,
        };
        const response = await this.callWebService("/controller/Event.asmx/getEventParticipant", data, "POST");
        return response;
    }

    async getEventParticipantByEventID(eventID) {
        const data = {
            eventID: eventID,
        };
        const response = await this.callWebService("/controller/Event.asmx/getEventParticipantList", data, "POST");
        return response;
    }

    async saveEventRegistration(eventID, ParticipantObj) {
        const data = {
            eventID: eventID,
            ParticipantObj: ParticipantObj
        };
        const response = await this.callWebService("/controller/Event.asmx/saveEventRegistration", data, "POST");
        return response;
    }

    async savePublicRegistration(encryptedEventParID, action) {
        const data = {
            encryptedEventParID: encryptedEventParID,
            action: action
        };
        const response = await this.callWebService("/controller/Event.asmx/savePublicRegistration", data, "POST");
        return response;
    }

    async updateEvent(files, obj, participantObj) {
        const formData = new FormData();
        formData.append("Obj", obj);
        formData.append("ParticipantObj", participantObj);
        formData.append('token', Cookies.get('authToken'));
        formData.append('UserID_Session', Cookies.get('userIDSession'));
        formData.append('UserSchool_Session', Cookies.get('schoolSession'));
        formData.append('UserType_Session', Cookies.get('userTypeSession'));
        formData.append('UserUniversitySession', Cookies.get('userUniversitySession'));
        formData.append('UserEmailSession', Cookies.get('userEmailSession'));
        formData.append('USRidSession', Cookies.get('usRidSession'));
        formData.append('UserNameSession', Cookies.get('userNameSession'));


        if (files && files.length > 1) {
            for (let key in files) {
                // console.log(key);
                if (files.hasOwnProperty(key)) {
                    // console.log(files[key]);
                    if (key > 0) {
                        formData.append(`upload_${key}`, files[key]);
                    } else {
                        formData.append("upload", files[key]);
                    }
                }
            }
        } else if (files && files[0]) {
            formData.append("upload", files[0]);
        }

        console.log("files");
        console.log(files);

        const request = {
            url: `${API_HOST}/controller/Event.asmx/updateEvent`,
            cache: false,
            type: 'POST',
            data: formData,
            enctype: 'multipart/form-data',
            processData: false,
            contentType: false,
            async: false,
            json: false,
            success: function (response) {
                return response;
            }
        };

        let response = await jQuery.ajax(request);
        if (typeof response === "string") {
            response = JSON.parse(response);
        }
        return response;

        // const data = {
        //     Obj: obj,
        //     ParticipantObj: participantObj,
        // };
        // const response = await this.callWebService("/controller/Event.asmx/updateEvent", data, "POST");
        // return response;
    }

    async deleteEvent(eventID/*, SendEmailFlag*/) {
        const data = {
            eventID: eventID,
            /*SendEmailFlag: SendEmailFlag*/
        };
        const response = await this.callWebService("/controller/Event.asmx/deleteEvent", data, "POST");
        return response;
    }

    async sendEvent(eventID, Obj) {
        const data = {
            eventID: eventID,
            Obj: Obj
        };
        const response = await this.callWebService("/controller/Event.asmx/sendEventEmail", data, "POST");
        return response;
    }

    async getStudentGraduationListByClassLevel(str_LevelID, str_ClassID) {
        const data = {levelID: str_LevelID, classID: str_ClassID};

        const response = await this.callWebService("/controller/Students.asmx/getStudentGraduationListByClassLevel", data, "POST");
        return response;
    }

    async getClassStudentList(academicYearID, levelID, className) {
        const data = {
            academicYearID: academicYearID,
            levelID: levelID,
            className: className
        };

        const response = await this.callWebService("/controller/Course.asmx/getClassStudentList", data, "POST");
        return response;
    }

    async getStudentProjectedBySchool() {
        try {
            const data = {};
            const response = await this.callWebService("/controller/Students.asmx/getStudentProjectedBySchool", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getStudentMovementDetailNewEnroll() {
        try {
            const data = {};
            const response = await this.callWebService("/controller/Students.asmx/getStudentMovementDetail_NewEnroll", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getStudentsMovementLastAndCurrentYear() {
        try {
            const data = {};
            const response = await this.callWebService("/controller/Students.asmx/getStudentsMovementLastAndCurrentYear", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getBusMasterList(type) {
        try {
            const data = {
                type: type,
            };
            const response = await this.callWebService("/controller/Attendance.asmx/getBusMasterList", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async saveBusMasterList(busNo, type) {
        try {
            const data = {
                busNo: busNo,
                type: type,
            };
            const response = await this.callWebService("/controller/Attendance.asmx/saveBusMasterList", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async updateBusMasterList(busID, busStatus) {
        try {
            const data = {
                busID: busID,
                busStatus: busStatus,
            };
            const response = await this.callWebService("/controller/Attendance.asmx/updateBusMasterList", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getActiveStudentListBySchoolIDOfBusNo(busID, type) {
        try {
            const data = {
                busID: busID,
                type: type,
            };

            const response = await this.callWebService("/controller/Attendance.asmx/getActiveStudentListBySchoolIDOfBusNo", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async updateStudentBusNo(jsonString, status) {
        try {
            const data = {
                jsonString: jsonString,
                status: status,
            };

            const response = await this.callWebService("/controller/Attendance.asmx/updateStudentBusNo", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async LoadBusAttendanceList(busID) {
        try {
            const data = {
                busID: busID,
            };

            const response = await this.callWebService("/controller/Attendance.asmx/LoadBusAttendanceList", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async updateBusAttendanceList(jsonString) {
        try {
            const data = {
                jsonString: jsonString,
            };

            const response = await this.callWebService("/controller/Attendance.asmx/updateBusAttendanceList", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async deletePaymentItem(SPDID, paymentPlanDetailID, studentCourseID) {
        const data = {
            SPDID: SPDID,
            paymentPlanDetailID: paymentPlanDetailID,
            studentCourseID: studentCourseID,
        };
        const response = await this.callWebService("/controller/Billing.asmx/deletePaymentItem", data, "POST");
        return response;
    }

    async getCurrencyValueDropdownlist() {
        const data = {};
        const response = await this.callWebService("/controller/Billing.asmx/getCurrencyValueDropdownlist", data, "POST");
        return response;
    }

    async saveItem(btnAddItemObject) {
        const data = {
            SPPD_FK_Student_Course_ID: btnAddItemObject.SPPD_FK_Student_Course_ID,
            SPPD_PayerName: btnAddItemObject.SPPD_PayerName,
            SPPD_PaymentSchedule: btnAddItemObject.SPPD_PaymentSchedule,
            SPPD_PaymentItemType: btnAddItemObject.SPPD_PaymentItemType,
            SPPD_Currency: btnAddItemObject.SPPD_Currency,
            SPPD_PaymentAmount: btnAddItemObject.SPPD_PaymentAmount,
            SPPD_PaymentDate: btnAddItemObject.SPPD_PaymentDate,
            noOfRecurring: btnAddItemObject.noOfRecurring,
            itemDescription: btnAddItemObject.itemDescription,
            itemFromDate: btnAddItemObject.itemFromDate,
            itemToDate: btnAddItemObject.itemToDate,
        };
        const response = await this.callWebService("/controller/Billing.asmx/saveItem", data, "POST");
        return response;
    }

    async getPaymentPlanMasterList(studentCourseID) {
        const data = {
            studentCourseID: studentCourseID,
        };
        const response = await this.callWebService("/controller/Billing.asmx/getPaymentPlanMasterList", data, "POST");
        return response;
    }

    async getPaymentPlanRules(studentCourseID, jsonString) {
        const data = {
            studentCourseID: studentCourseID,
            jsonString: jsonString,
        };
        const response = await this.callWebService("/controller/Billing.asmx/getPaymentPlanRules", data, "POST");
        return response;
    }

    async checkRateFeeEligible(studentID, studentCourseID, rateFeeMode) {
        const data = {
            studentID: studentID,
            studentCourseID: studentCourseID,
            rateFeeMode: rateFeeMode,
        };
        const response = await this.callWebService("/controller/Billing.asmx/checkRateFeeEligible", data, "POST");
        return response;
    }

    async getPaymentPlanLevelStartDate(studentCourseID) {
        const data = {
            studentCourseID: studentCourseID,
        };
        const response = await this.callWebService("/controller/Billing.asmx/getPaymentPlanLevelStartDate", data, "POST");
        return response;
    }

    async getPaymentPlanRuleDetails(paymentPlanRuleID) {
        const data = {
            paymentPlanRuleID: paymentPlanRuleID,
        };
        const response = await this.callWebService("/controller/Billing.asmx/getPaymentPlanRuleDetails", data, "POST");
        return response;
    }

    async checkSiblingDiscountEligible(studentID) {
        const data = {
            studentID: studentID,
        };
        const response = await this.callWebService("/controller/Billing.asmx/checkSiblingDiscountEligible", data, "POST");
        return response;
    }

    async getSiblingList(studentID) {
        const data = {
            studentID: studentID,
        };
        const response = await this.callWebService("/controller/Billing.asmx/getSiblingList", data, "POST");
        return response;
    }

    async getPaymentPlanMasterDetails(courseFeeSchemeID) {
        const data = {
            courseFeeSchemeID: courseFeeSchemeID,
        };
        const response = await this.callWebService("/controller/Billing.asmx/getPaymentPlanMasterDetails", data, "POST");
        return response;
    }

    async getPaymentPlanMasterDetailsList(courseFeeSchemeID) {
        const data = {
            courseFeeSchemeID: courseFeeSchemeID,
        };
        const response = await this.callWebService("/controller/Billing.asmx/getPaymentPlanMasterDetailsList", data, "POST");
        return response;
    }

    async getStudentCourseSemesterInfo(studentID, studentCourseID) {
        const data = {
            studentID: studentID,
            studentCourseID: studentCourseID
        };
        const response = await this.callWebService("/controller/Course.asmx/getStudentCourseSemesterInfo", data, "POST");
        return response;
    }

    async savePaymentPlan(btnAddPaymentPlanObject) {
        const data = {
            btnAddPaymentPlanObject: btnAddPaymentPlanObject,
        };
        const response = await this.callWebService("/controller/Billing.asmx/savePaymentPlan", data, "POST");
        return response;
    }

    async checkStaffDiscountEligible(studentID) {
        const data = {
            studentID: studentID,
        };
        const response = await this.callWebService("/controller/Billing.asmx/checkStaffDiscountEligible", data, "POST");
        return response;
    }

    async getPaymentPlanStaffRules(studentID) {
        const data = {
            studentID: studentID,
        };
        const response = await this.callWebService("/controller/Billing.asmx/getPaymentPlanStaffRules", data, "POST");
        return response;
    }

    async getUserDetails(conID) {
        const data = {
            conID: conID,
        };
        const response = await this.callWebService("/controller/User.asmx/getUserDetails", data, "POST");
        return response;
    }

    async checkStudentPaymentPlan(studentCourseID) {
        const data = {
            studentCourseID: studentCourseID,
        };
        const response = await this.callWebService("/controller/Billing.asmx/checkStudentPaymentPlan", data, "POST");
        return response;
    }

    async savePaymentPlanDiscount(obj) {
        const data = {
            obj: obj,
        };
        const response = await this.callWebService("/controller/Billing.asmx/savePaymentPlanDiscount", data, "POST");
        return response;
    }

    async generateInvoice(obj, studentID, studentCourseID, inputPaymentDueDate, inputRemarks, action, invoiceName, isRefundRebate, refundRebateobj, gstRate) {
        const data = {
            obj: obj,
            studentID: studentID,
            studentCourseID: studentCourseID,
            inputPaymentDueDate: inputPaymentDueDate,
            inputRemarks: inputRemarks,
            action: action,
            invoiceName: invoiceName,
            isRefundRebate: isRefundRebate,
            refundRebateobj: refundRebateobj,
            GstPercentage: gstRate
        };
        const response = await this.callWebService("/controller/Billing.asmx/generateInvoice", data, "POST");
        return response;
    }

    async getReInvoice(studentID, studentCourseID, invoiceName) {
        const data = {
            studentID: studentID,
            studentCourseID: studentCourseID,
            invoiceName: invoiceName,

        };
        const response = await this.callWebService("/controller/Billing.asmx/getReinvoiceActiveList", data, "POST");
        return response;
    }

    async generateReceipt(obj, studentID, studentCourseID, action, gstRate) {
        let data;
        if(gstRate){
            data = {
                obj: obj,
                studentID: studentID,
                studentCourseID: studentCourseID,
                action: action,
                GstPercentage: gstRate
            };
        }else{
            data = {
                obj: obj,
                studentID: studentID,
                studentCourseID: studentCourseID,
                action: action,
            };
        }
        const response = await this.callWebService("/controller/Billing.asmx/generateReceipt", data, "POST");
        return response;
    }

    async getReceiptWithTransactionHistory(Obj, studentID, invoiceName) {
        const data = {
            receiptNameListObj: Obj,
            studentID: studentID,
            invoiceName: invoiceName,
        };
        const response = await this.callWebService("/controller/Billing.asmx/getTransactionHistoryList", data, "POST");
        return response;
    }

    async getStudentSchoolFeeRebate(studentID, checkRebateExist, rebateDesc) {
        const data = {
            studentID: studentID,
            checkRebateExist: checkRebateExist,
            rebateDesc: rebateDesc,
        };
        const response = await this.callWebService("/controller/Billing.asmx/getStudentSchoolFeeRebate", data, "POST");
        return response;
    }

    async tagRebateSchoolFeesToInvoice(PK_Invoice_ID, RebatePKInvoiceID) {
        const data = {
            PK_Invoice_ID: PK_Invoice_ID,
            RebatePKInvoiceID: RebatePKInvoiceID,

        };
        const response = await this.callWebService("/controller/Billing.asmx/tagRebateSchoolFeesToInvoice", data, "POST");
        return response;
    }

    async getLeftOverPaymentReceipt(Obj, studentID, invoiceName, studentCourseID, action) {
        const data = {
            receiptNameListObj: Obj,
            studentID: studentID,
            invoiceName: invoiceName,
            studentCourseID: studentCourseID,
            action: action,
        };
        const response = await this.callWebService("/controller/Billing.asmx/getLeftoverPayment", data, "POST");
        return response;
    }

    async getActivePaymentNoTransactionHistoryList(studentCourseID, value) {
        const data = {
            studentCourseID: studentCourseID,
            transType: value,
        };
        const response = await this.callWebService("/controller/Billing.asmx/getActivePaymentNoTransactionHistoryList", data, "POST");
        return response;
    }

    async getInvoiceDetails(InvHeaderID) {
        const data = {
            InvHeaderID: InvHeaderID,
        };
        const response = await this.callWebService("/controller/Billing.asmx/getInvoiceDetails", data, "POST");
        return response;
    }

    async getInvoiceDetailsList(InvHeaderID) {
        const data = {
            InvHeaderID: InvHeaderID,
        };
        const response = await this.callWebService("/controller/Billing.asmx/getInvoiceDetailsList", data, "POST");
        return response;
    }

    async generateCN(obj, isfullCN) {
        const data = {
            obj: obj,
            fullCN: isfullCN,
        };
        const response = await this.callWebService("/controller/Billing.asmx/generateCN", data, "POST");
        return response;
    }

    async getTransactionDocumentPdf(documentType, invRecID) {
        const data = {
            DocumentType: documentType,
            InvRecID: invRecID,
        };
        const response = await this.callWebService("/controller/Billing.asmx/getTransactionDocument", data, "POST");
        return response;
    }

    async updateAttendanceListWithTemperature(deviceOutput) {
        try {
            const data = {
                deviceOutput: deviceOutput,
            };

            const response = await this.callWebService("/controller/Attendance.asmx/updateAttendanceListWithTemperature", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getNumberOfAttendanceAllClassBySchool() {
        try {
            const data = {};

            const response = await this.callWebService("/controller/Attendance.asmx/getNumberOfAttendanceAllClassBySchool", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getEcaMasterList() {
        try {
            const data = {};

            const response = await this.callWebService("/controller/Attendance.asmx/getEcaMasterList", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async saveEcaMasterList(ecaName) {
        try {
            const data = {
                ecaName: ecaName,
            };

            const response = await this.callWebService("/controller/Attendance.asmx/saveEcaMasterList", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async updateEcaMasterList(ecaID, ecaStatus) {
        try {
            const data = {
                ecaID: ecaID,
                ecaStatus: ecaStatus,
            };

            const response = await this.callWebService("/controller/Attendance.asmx/updateEcaMasterList", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getEcaDetails(ecaID, EcaDtlDateAttend) {
        try {
            const data = {
                ecaID: ecaID,
                EcaDtlDateAttend: EcaDtlDateAttend,
            };

            const response = await this.callWebService("/controller/Attendance.asmx/getEcaDetails", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getEcaDetailsUnAssignStudent(ecaID, ecaDtlDateAttend) {
        try {
            const data = {
                ecaID: ecaID,
                ecaDtlDateAttend: ecaDtlDateAttend,
            };

            const response = await this.callWebService("/controller/Attendance.asmx/getEcaDetailsUnAssignStudent", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getEcaSummaryGroupByEcaID(ecaID) {
        try {
            const data = {
                ecaID: ecaID
            };

            const response = await this.callWebService("/controller/Attendance.asmx/getEcaSummaryGroupByEcaID", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async saveEcaDetails(jsonString, mode) {
        try {
            const data = {
                jsonString: jsonString,
                mode: mode
            };

            const response = await this.callWebService("/controller/Attendance.asmx/saveEcaDetails", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async updateEcaDetails(ecaDtlID, ecaDtlStatus) {
        try {
            const data = {
                ecaDtlID: ecaDtlID,
                ecaDtlStatus: ecaDtlStatus
            };

            const response = await this.callWebService("/controller/Attendance.asmx/updateEcaDetails", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getEcaBySchoolIDDate(dateAttend) {
        try {
            const data = {
                dateAttend: dateAttend
            };

            const response = await this.callWebService("/controller/Attendance.asmx/getEcaBySchoolIDDate", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async LoadEcaAttendanceList(ecaID) {
        try {
            const data = {
                ecaID: ecaID
            };

            const response = await this.callWebService("/controller/Attendance.asmx/LoadEcaAttendanceList", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async updateEcaAttendanceList(jsonString) {
        try {
            const data = {
                jsonString: jsonString
            };

            const response = await this.callWebService("/controller/Attendance.asmx/updateEcaAttendanceList", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async generateEcaAttendanceReport(jsonString) {
        try {
            const data = {
                jsonString: jsonString
            };

            const response = await this.callWebService("/controller/Attendance.asmx/generateEcaAttendanceReport", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getReceiptList(invoiceName, receiptName, receiptDateFrom, receiptDateTo, studentIndexNo, studentName, receiptStatus,mode ,schoolID) {
        try {
            const data = {
                receiptName: receiptName,
                invoiceName: invoiceName,
                receiptDateFrom: receiptDateFrom,
                receiptDateTo: receiptDateTo,
                studentIndexNo: studentIndexNo,
                studentName: studentName,
                receiptStatus: receiptStatus,
                schoolID :schoolID,
                mode :mode,
            };
            const response = await this.callWebService("/controller/Billing.asmx/getReceiptList", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getPayee(studentID_Index) {
        try {
            const data = {
                studentID_Index: studentID_Index,
            };
            const response = await this.callWebService("/controller/Students.asmx/getPayee", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getReceiptDetails(receiptID) {
        try {
            const data = {
                receiptID: receiptID,
            };
            const response = await this.callWebService("/controller/Billing.asmx/getReceiptDetails", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getUnbilledBatchPaymentList(schoolID, semesterID, courseID, classID, fromDate, toDate) {
        try {
            const data = {
                schoolID: schoolID,
                semesterID: semesterID,
                courseID: courseID,
                classID: classID,
                fromDate: fromDate,
                toDate: toDate,
            };
            const response = await this.callWebService("/controller/Billing.asmx/getUnbilledBatchPaymentList", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async cancelReceipt(receiptID, remarks) {
        try {
            const data = {
                receiptID: receiptID,
                remarks: remarks,
            };
            const response = await this.callWebService("/controller/Billing.asmx/cancelReceipt", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async generateBatchInvoice(obj, inputPaymentDueDate, action, breakdownFlag) {
        try {
            const data = {
                obj: obj,
                inputPaymentDueDate: inputPaymentDueDate,
                action: action,
                breakdownFlag: breakdownFlag,
            };
            const response = await this.callWebService("/controller/Billing.asmx/generateBatchInvoice", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async importECADetailsByCSVExcel(files, ecaID) {
        const data = new FormData();
        data.append('token', Cookies.get('authToken'));
        data.append('UserSchool_Session', Cookies.get('schoolSession'));
        data.append('UserID_Session', Cookies.get('userIDSession'));
        data.append('UserUniversity_Session', Cookies.get('userUniversitySession'));

        if (files && files.length > 1) {
            for (let key in files) {
                //console.log(key);
                if (files.hasOwnProperty(key)) {
                    // console.log(files[key]);
                    if (key > 0) {
                        data.append(`upload_${key}`, files[key]);
                    } else {
                        data.append("upload", files[key]);
                    }
                }
            }
        } else if (files) {
            data.append("upload", files[0]);
        }

        data.append('ecaID', ecaID);

        const request = {
            url: `${API_HOST}/controller/Attendance.asmx/importECADetailsByCSVExcel`,
            cache: false,
            type: 'POST',
            data: data,
            enctype: 'multipart/form-data',
            processData: false,
            contentType: false,
            async: false,
            json: false,
            success: function (response) {
                return response;
            }
        };

        let response = await jQuery.ajax(request);
        if (typeof response === "string") {
            response = JSON.parse(response);
        }
        return response;
    }

    async getValueFromGeneralSearch(searchValueInput) {
        try {
            const data = {
                searchValueInput: searchValueInput,
            };
            const response = await this.callWebService("/controller/General.asmx/getValueFromGeneralSearch", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async generatePortfolioPDF(portfolioID) {
        try {
            const data = {
                portfolioID: portfolioID,
            };
            const response = await this.callWebService("/controller/Portfolio.asmx/generatePortfolioPDF", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getTransferPendingScheduleList() {
        try {
            const data = {};
            const response = await this.callWebService("/controller/Operations.asmx/getTransferPendingScheduleList", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async updateTransferPendingScheduleList(studentSchoolID, status) {
        try {
            const data = {
                studentSchoolID: studentSchoolID,
                status: status
            };
            const response = await this.callWebService("/controller/Operations.asmx/updateTransferPendingScheduleList", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getWithdrawGraduatePendingScheduleList(changeType) {
        try {
            const data = {
                changeType: changeType
            };
            const response = await this.callWebService("/controller/Operations.asmx/getWithdrawGraduatePendingScheduleList", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async updateWithdrawGraduatePendingScheduleList(studentGraduationDatesID, status) {
        try {
            const data = {
                studentGraduationDatesID: studentGraduationDatesID,
                status: status
            };
            const response = await this.callWebService("/controller/Operations.asmx/updateWithdrawGraduatePendingScheduleList", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getReminderEmail(noOfReminder, invoiceNo, studentCourseID, studentID) {
        try {
            const data = {
                noOfReminder: noOfReminder,
                invoiceNo: invoiceNo,
                studentCourseID: studentCourseID,
                studentID: studentID
            };
            const response = await this.callWebService("/controller/Billing.asmx/getReminderEmail", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async sendReminderEmail(emailTo, emailSubject, emailMessage, invoiceNo) {
        try {
            const data = {
                emailTo: emailTo,
                emailSubject: emailSubject,
                emailMessage: emailMessage,
                invoiceNo: invoiceNo
            };
            const response = await this.callWebService("/controller/Billing.asmx/sendReminderEmail", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }


    async getCourseBySemesterID(schoolID, semesterID) {
        try {
            const data = {
                schoolID: schoolID,
                semesterID: semesterID,
            };
            const response = await this.callWebService("/controller/Course.asmx/getCourseBySemesterID", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }


    async getClassByMonthYear(month, year, filterByStaffInCharge) {
        try {
            const data = {
                month: month,
                year: year,
                filterByStaffInCharge: filterByStaffInCharge,
            };
            const response = await this.callWebService("/controller/Class.asmx/getClassByMonthYear", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getClassAttendanceReportByMonthYear(month, year, classID, reportType) {
        try {
            const data = {
                month: month,
                year: year,
                classID: classID,
                reportType: reportType,
            };
            const response = await this.callWebService("/controller/Attendance.asmx/getClassAttendanceReportByMonthYear", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getInvoiceCNList(invoiceDateFrom, invoiceDateTo, invoiceDueDateFrom, invoiceDueDateTo,
                           studentIndexNo, invoiceNo, studentName, type, studentID) {
        try {
            const data = {
                invoiceDateFrom: invoiceDateFrom,
                invoiceDateTo: invoiceDateTo,
                invoiceDueDateFrom: invoiceDueDateFrom,
                invoiceDueDateTo: invoiceDueDateTo,
                studentIndexNo: studentIndexNo,
                invoiceNo: invoiceNo,
                studentName: studentName,
                type: type,
                studentID: studentID,
            };
            const response = await this.callWebService("/controller/Billing.asmx/getInvoiceCNList", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getAgentCommissionList(agentName, studentName, type) {
        try {
            const data = {
            agentName: agentName,
            studentName: studentName,
            type: type,
        };
        const response = await this.callWebService("/controller/AgentTracker.asmx/getAgentCommissionList", data, "POST");
        return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getddlAcadYearList(StudentId) {
        try {
            const data = {
                StudentId: StudentId,
        };
        const response = await this.callWebService("/controller/AgentTracker.asmx/getAcademicYearByStudent", data, "POST");
        return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getddlSemesterTermList(semesterID) {
        try {
            const data = {
                semesterID: semesterID,
        };
        const response = await this.callWebService("/controller/AgentTracker.asmx/getSemesterTerm", data, "POST");
        return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getAgentDetailList(agentname, studentName, type) {
        try {
            const data = {
            agentname: agentname,
            studentName: studentName,
            type: type,
        };
        const response = await this.callWebService("/controller/AgentTracker.asmx/getAgentDetailList", data, "POST");
        return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getAgentList(
        studentIndexNo, studentName, type) {
        try {
        const data = {
        AgentName: studentName,
        AgentShortName: studentIndexNo,
        type:type
        };
        const response = await this.callWebService("/controller/AgentTracker.asmx/getAgentList", data, "POST");
        return response;
        } catch (e) {
        console.log(e);
        }
     }

     async LoadAgentSchoolList() {
        try {
            let conUserId = Cookies.get('userIDSession');
            
            const data = {
                conUserId: conUserId,
            };
        const response = await this.callWebService("/controller/AgentTracker.asmx/LoadAgentSchoolList", data, "POST");
        return response;
        } catch (e) {
        console.log(e);
        }
     }
      async getJapanschoolIDs() {
        try {
            const data = {
                AgentName: "",
                AgentShortName: "",
                type:""
                };
        const response = await this.callWebService("/controller/AgentTracker.asmx/getJapanschoolIDs", data, "POST");
        return response;
        } catch (e) {
        console.log(e);
        }
     }

     async getAgentOnboardDate(
        agentname, studentid, obdate, type) {
        try {
        const data = {
            agentname: agentname,
            studentid: studentid,
            obdate: obdate,
            type: type
        };
        const response = await this.callWebService("/controller/AgentTracker.asmx/getAgentOnboardDate", data, "POST");
        return response;
        } catch (e) {
        console.log(e);
        }
     }

     async checkAgentHide() {
        try {
        const data = {
            agentname: "",
            studentid: ""
        };
        const response = await this.callWebService("/controller/AgentTracker.asmx/checkAgentHide", data, "POST");
        return response;
        } catch (e) {
        console.log(e);
        }
     }

     async checkAgentHideBySchool(schoolId) {
        try {
        const data = {
            schoolId : schoolId
        };
        const response = await this.callWebService("/controller/AgentTracker.asmx/checkAgentHideBySchool", data, "POST");
        return response;
        } catch (e) {
        console.log(e);
        }
     }

     async updateAgentHide(Id, optValue) {
        try {
        const data = {
            agentname: "",
            studentid: "",
            optValue: optValue,
            Id: Id
        };
        const response = await this.callWebService("/controller/AgentTracker.asmx/updateAgentHide", data, "POST");
        return response;
        } catch (e) {
        console.log(e);
        }
     }

    async getItemTotalReceipt(receiptNameListObj) {
        try {
            const data = {
                receiptNameListObj: receiptNameListObj
            };
            const response = await this.callWebService("/controller/Billing.asmx/getItemTotalReceipt", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async advanceAttendanceMarking(jsonString) {
        try {
            const data = {
                jsonString: jsonString
            };
            const response = await this.callWebService("/controller/Attendance.asmx/advanceAttendanceMarking", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async generateRefund(obj, action, refundGstRate) {
        try {
            const data = {
                obj: obj,
                action: action,
                GstPercentage: refundGstRate
            };
            const response = await this.callWebService("/controller/Billing.asmx/generateRefund", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getadvanceAttendanceMarkingList() {
        try {
            const data = {};
            const response = await this.callWebService("/controller/Attendance.asmx/getAdvanceAttendanceMarkingList", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async updateAdvanceAttendanceMarking(mode, attendanceID) {
        try {
            const data = {
                mode: mode,
                attendanceID: attendanceID,
            };
            const response = await this.callWebService("/controller/Attendance.asmx/updateAdvanceAttendanceMarking", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getClassStudentByClassName(classValue) {

        const data = {
            classValue: classValue,
        };
        const response = await this.callWebService("/controller/Class.asmx/getClassStudentByClassName", data, "POST");
        return response;
    }

    async getClassStudentByClassID(classValue) {

        const data = {
            classValue: classValue,
        };
        const response = await this.callWebService("/controller/Class.asmx/getClassStudentByClassID", data, "POST");
        return response;
    }

    async getClassStudentByClassIDIncludeInactive(classValue) {

        const data = {
            classValue: classValue,
        };
        const response = await this.callWebService("/controller/Class.asmx/getClassStudentByClassIDIncludeInactive", data, "POST");
        return response;
    }

    async getAgencyListSummary(academicYear) {

        const data = {
            academicYear: academicYear,
        };
        const response = await this.callWebService("/controller/AgentTracker.asmx/getAgencyListSummary", data, "POST");
        return response;
    }

    async getAgencyStudentList(agentname, academicYear) {

        const data = {
            academicYear: academicYear,
            agentname: agentname,
        };
        const response = await this.callWebService("/controller/AgentTracker.asmx/getAgencyStudentList", data, "POST");
        return response;
    }

    async checkDeferActionValid(studentID) {
        try {
            const data = {
                studentID: studentID,
            };
            const response = await this.callWebService("/controller/Students.asmx/checkDeferActionValid", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async setDeferDate(studentID, deferDate) {
        try {
            const data = {
                studentID: studentID,
                deferDate: deferDate,
            };
            const response = await this.callWebService("/controller/Students.asmx/setDeferDate", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async sendEmailInvoice(obj) {
        try {
            const data = {
                obj: obj,
            };
            const response = await this.callWebService("/controller/Billing.asmx/sendEmailInvoice", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async sendEmailRebate(obj) {
        try {
            const data = {
                obj: obj,
            };
            const response = await this.callWebService("/controller/Billing.asmx/sendEmailRebate", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async checkCourseOrderByLevelIDStudentID(levelID, studentID) {
        try {
            const data = {
                levelID: levelID,
                studentID: studentID,
            };
            const response = await this.callWebService("/controller/Course.asmx/checkCourseOrderByLevelIDStudentID", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async sendBreakdownEmail(obj) {
        try {
            const data = {
                obj: obj,
            };
            const response = await this.callWebService("/controller/Billing.asmx/sendBreakdownEmail", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async saveNewAgent(agentname, agentshortname, agentid, agentstatus) {
        try {
            const data = {
                agentname: agentname,
                agentshortname: agentshortname,
                agentid: agentid,
                agentstatus: agentstatus,
                UserID_Session: Cookies.get('userIDSession'),
            };
            const response = await this.callWebService("/controller/AgentTracker.asmx/saveNewAgent", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async saveAgentStudent(editId, SchoolFee, Remarks, Status, AgentId, SchoolId, CourseId, StudentId) {
        try {
            const data = {
                editId: editId,
                SchoolFee: SchoolFee,
                Remarks: Remarks,
                Status: Status,
                AgentId: AgentId,
                SchoolId: SchoolId,
                CourseId: CourseId,
                StudentId: StudentId,
                UserID_Session: Cookies.get('userIDSession'),
            };
            const response = await this.callWebService("/controller/AgentTracker.asmx/saveAgentStudent", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async saveAgentCommission(editId, receiptAmt, Commission, PaidAgentDate,
    InvoiceRefNo, Remarks, Status, agentid, studentid, receiptno, SemDetID) {
        try {
            const data = {
                editId: editId,
                receiptAmt:receiptAmt,
                Commission:Commission,
                PaidAgentDate:PaidAgentDate,
                InvoiceRefNo:InvoiceRefNo,
                Remarks:Remarks,
                Status:Status,
                agentid:agentid,
                studentid:studentid,
                receiptno:receiptno,
                SemDetID:SemDetID,
                UserID_Session: Cookies.get('userIDSession'),
            };
            const response = await this.callWebService("/controller/AgentTracker.asmx/saveAgentCommission", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }


    async generateClassStudentForPrinting(obj) {
        try {
            const data = {
                obj: obj,
            };
            const response = await this.callWebService("/controller/Class.asmx/generateClassStudentForPrinting", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async generateClassStudentQRForPrinting(obj) {
        try {
            const data = {
                obj: obj,
            };
            const response = await this.callWebService("/controller/Class.asmx/generateClassStudentForPrintingQR", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getAllCoursesLevel() {
        try {
            const data = {};
            const response = await this.callWebService("/controller/Course.asmx/getAllCoursesLevel", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getPlannerMaster(level, type, mode, lang, courseType) {
        try {
            const data = {
                level: level,
                type: type,
                mode: mode,
                lang: lang,
                courseType: courseType
            };
            const response = await this.callWebService("/controller/Portfolio.asmx/getPlannerMaster", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getPlannerMaster2(level) {
        try {
            const data={
                levels: level
            }
            const response = await this.callWebService("/controller/Api.asmx/GetPlannerMaster", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async savePlannerMaster(newPlannerMasterObjJson) {
        try {
            const data = {
                newPlannerMasterObjJson: newPlannerMasterObjJson,
            };
            const response = await this.callWebService("/controller/Portfolio.asmx/savePlannerMaster", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async updatePlannerMaster(plannerMasterID, mode) {
        try {
            const data = {
                plannerMasterID: plannerMasterID,
                mode: mode,
            };
            const response = await this.callWebService("/controller/Portfolio.asmx/updatePlannerMaster", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getPlannerAssignedToSchool(schID, semID) {
        try {
            const data = {
                schID: schID,
                semID: semID,
            };
            const response = await this.callWebService("/controller/Portfolio.asmx/getPlannerAssignedToSchool", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getPlannerAssignedDetialsToSchool(schID, semID, crsID) {
        try {
            const data = {
                schID: schID,
                semID: semID,
                crsID: crsID,
            };
            const response = await this.callWebService("/controller/Portfolio.asmx/getPlannerAssignedDetialsToSchool", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async updatePlannerAssignedDetialsToSchool(plannerSchoolAssginDetailsID, mode) {
        try {
            const data = {
                plannerSchoolAssginDetailsID: plannerSchoolAssginDetailsID,
                mode: mode
            };
            const response = await this.callWebService("/controller/Portfolio.asmx/updatePlannerAssignedDetialsToSchool", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getPlannerUnAssignToSchool(crsID, semID, schID, levelType) {
        try {
            const data = {
                schID: schID,
                semID: semID,
                crsID: crsID,
                levelType: levelType,
            };
            const response = await this.callWebService("/controller/Portfolio.asmx/getPlannerUnAssignToSchool", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async savePlannerAssignedToSchool(newPlannerAssignedToSchoolObjJson) {
        try {
            const data = {
                newPlannerAssignedToSchoolObjJson: newPlannerAssignedToSchoolObjJson,
            };
            const response = await this.callWebService("/controller/Portfolio.asmx/savePlannerAssignedToSchool", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async savePlannerAssignedToClass(newPlannerAssignedToClassObjJson) {
        try {
            const data = {
                newPlannerAssignedToClassObjJson: newPlannerAssignedToClassObjJson,
            };
            const response = await this.callWebService("/controller/Planner.asmx/savePlannerAssignedToClass", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async SavePlannerAssignedToClass2(classId, checkList) {
        try {
            const data = {
                data: JSON.stringify(checkList),
                classID: classId
            };
            const response = await this.callWebService("/controller/Api.asmx/SavePlannerAssignedToClass", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async SavePlannerAssignedToStudent(studentID, checkList) {
        try {
            const data = {
                data: JSON.stringify(checkList),
                studentID: studentID
            };
            const response = await this.callWebService("/controller/Api.asmx/SavePlannerAssignedToStudent", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async SavePlannerAssignedToClass2(classId, checkList) {
        try {
            const data = {
                data: JSON.stringify(checkList),
                classID: classId
            };
            const response = await this.callWebService("/controller/Api.asmx/SavePlannerAssignedToClass", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async SavePlannerAssignedToStudent(studentID, checkList) {
        try {
            const data = {
                data: JSON.stringify(checkList),
                studentID: studentID
            };
            const response = await this.callWebService("/controller/Api.asmx/SavePlannerAssignedToStudent", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async savePlannerAssignedToCourse(newPlannerAssignedToCourseObjJson) {
        try {
            const data = {
                newPlannerAssignedToCourseObjJson: newPlannerAssignedToCourseObjJson,
            };
            const response = await this.callWebService("/controller/Planner.asmx/savePlannerAssignedToCourse", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async savePlannerAssignedToStudentK2(newPlannerAssignedToStudentObjJson) {
        try {
            const data = {
                newPlannerAssignedToStudentObjJson: newPlannerAssignedToStudentObjJson,
            };
            const response = await this.callWebService("/controller/Planner.asmx/savePlannerAssignedToStudentK2", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getPlannerAssignedToClass(crsID, classID, semdID) {
        try {
            const data = {
                crsID: crsID,
                classID: classID,
                semdID: semdID,

            };
            const response = await this.callWebService("/controller/Planner.asmx/getPlannerAssignedToClass", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getPlannerAssignedToClass2(classID) {
      try {
        const data = {
          classID: classID
        };
        const response = await this.callWebService("/controller/Api.asmx/GetPlannerAssignedToClass", data, "POST");
        return response;
      } catch (e) {
        console.log(e);
      }
    }

    async GetPlannerAssignedToStudent(studID) {
      try {
        const data = {
          studID: studID
        };
        const response = await this.callWebService("/controller/Api.asmx/GetPlannerAssignedToStudent", data, "POST");
        return response;
      } catch (e) {
        console.log(e);
      }
    }

    async getPlannerAssignedToClassReworked(crsID, classID, semID,Term1SemdID,Term2SemdID,Term3SemdID,Term4SemdID ) {
        try {
            const data = {

                crsID: crsID,
                classID: classID,
                semID : semID,
                Term1SemdID: Term1SemdID,
                Term2SemdID: Term2SemdID,
                Term3SemdID: Term3SemdID,
                Term4SemdID: Term4SemdID,


            };
            const response = await this.callWebService("/controller/Planner.asmx/getPlannerAssignedToClassReworked", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getPlannerAssignedToLevel(crsID, semdID) {
        try {
            const data = {
                crsID: crsID,
                semdID: semdID,

            };
            const response = await this.callWebService("/controller/Planner.asmx/getPlannerAssignedToLevel", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getPlannerAssignedToStudent(crsID, classID, termID, studentID) {
        try {
            const data = {
                crsID: crsID,
                classID: classID,
                semdID: termID,
                studentID: studentID,
            };
            const response = await this.callWebService("/controller/Planner.asmx/getPlannerAssignedToStudent", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getStudentsByClass(crsID, classID, semID) {
        try {
            const data = {
                crsID: crsID,
                semID: semID,
                classID: classID,

            };
            const response = await this.callWebService("/controller/Portfolio.asmx/getStudentsByClass", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }
    async GetAttendanceWithStudentType(studentType, courseID,ClassID, Index_No, fromDate, toDate) {
        try {
            const data = {
                studentType: studentType,
                courseID: courseID,
                ClassID : ClassID,
                Index_No: Index_No,
                fromDate : fromDate,
                toDate : toDate

            };
                const response = await this.callWebService("/controller/Attendance.asmx/GetAttendanceWithStudentType", data, "POST");


            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async GetAttendanceWithStudentTypeSummary(studentType, courseID, ClassID, Index_No, fromDate, toDate) {

        try {
            const data = {
                studentType: studentType,
                courseID: courseID,
                ClassID : ClassID,
                Index_No: Index_No,
                fromDate: fromDate,
                toDate: toDate

            };


            const response = await this.callWebService("/controller/Attendance.asmx/GetAttendanceWithStudentTypeSummary", data, "POST");

            return response;
        } catch (e) {
            console.log(e);
        }
    }


    async getPlannerAssignedStudentSummaryByClassSemester(classValue) {
        try {
            const data = {
                classValue: classValue,
            };
            const response = await this.callWebService("/controller/Portfolio.asmx/getPlannerAssignedStudentSummaryByClassSemester", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getPlannerAssignedStudentDetails(mode, studentID, semID, crsID, semdID, plannerApproverID) {
        try {
            const data = {
                studentID: studentID,
                semID: semID,
                crsID: crsID,
                semdID: semdID,
                mode: mode,
                plannerApproverID: plannerApproverID,
            };
            const response = await this.callWebService("/controller/Portfolio.asmx/getPlannerAssignedStudentDetails", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async savePlannerAssignStudent(newPlannerStudentObjJson, approverComment) {
        try {
            const data = {
                newPlannerStudentObjJson: newPlannerStudentObjJson,
                approverComment: approverComment
            };
            const response = await this.callWebService("/controller/Portfolio.asmx/savePlannerAssignStudent", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async deletePlannerAssignStudentPendingApprover(approverID) {
        try {
            const data = {
                approverID: approverID,
            };
            const response = await this.callWebService("/controller/Portfolio.asmx/deletePlannerAssignStudentPendingApprover", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getPlannerAssignedStudentsGroupByClassID(classID, studentIDJsonString) {
        try {
            const data = {
                classID: classID,
                studentIDJsonString: studentIDJsonString,
            };
            const response = await this.callWebService("/controller/Portfolio.asmx/getPlannerAssignedStudentsGroupByClassID", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getPlannerAssignedStudentsGroupByClassIDK2(classIDList, studentIDList) {

        try {
            const data = {
                classIDList: JSON.stringify(classIDList),
                studentIDList: JSON.stringify(studentIDList),
            };
            const response = await this.callWebService("/controller/Planner.asmx/getPlannerAssignedStudentsGroupByClassIDK2", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getNewPlannerAssigned(classIDList, studentIDList, levelIDList) {

        try {
        const data = {
            courses: JSON.stringify(levelIDList),
            classes: JSON.stringify(classIDList),
            students: JSON.stringify(studentIDList),
        };

        const response = await this.callWebService("/controller/Api.asmx/GetPlannerAssigned", data, "POST");
        return response;
        } catch (e) {
            console.log(e);
        }
    }

    async downloadPlannerByStudent(classIDList, studentIDList, levelIDList, type) {
        const formData = new FormData();
        formData.append('token', Cookies.get('authToken'));
        formData.append('UserID_Session', Cookies.get('userIDSession'));
        formData.append('courses', JSON.stringify(levelIDList));
        formData.append('classes', JSON.stringify(classIDList));
        formData.append('students', JSON.stringify(studentIDList));
        formData.append('type', type);

        const request = {
            url: `${API_HOST}/controller/Api.asmx/GetPlannerAssigned`,
            cache: false,
            type: 'POST',
            data: formData,
            enctype: 'multipart/form-data',
            processData: false,
            contentType: false,
            async: false,
            json: false,
            success: function (response) {
                return response;
            }
        };

        return jQuery.ajax(request);

        // const response = await this.callWebService("/controller/Api.asmx/GetPlannerAssigned", data, "POST");
        // console.log(response,"response")
        // return response;
    }

    async getStudentPlannerProgressByClassIDRange(classID, studentID, semdID) {
        try {
            const data = {
                classID: classID,
                studentID: studentID,
                semdID: semdID,
            };
            const response = await this.callWebService("/controller/Portfolio.asmx/getStudentPlannerProgressByClassIDRange", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getPendingStudentMovementStatusAction(studentID) {
        try {
            const data = {
                studentID: studentID
            };
            const response = await this.callWebService("/controller/Students.asmx/getPendingStudentMovementStatusAction", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getTransactionListing(inputFromDate, inputToDate, dateRange, type) {
        try {
            const data = {
                dateFrom: inputFromDate,
                dateTo: inputToDate,
                type: type,
                dateRange: dateRange,
            };
            const response = await this.callWebService("/controller/Billing.asmx/getTransactionListing", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getStudentListReport(semID, password = null) {
        try {
            const data = { semID, password, email: Cookies.get('userEmailSession') };
            const response = await this.callWebService("/controller/Students.asmx/getStudentListReport", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async sendEmailReceipt(obj) {
        try {
            const data = {
                obj: obj,
            };
            const response = await this.callWebService("/controller/Billing.asmx/sendEmailReceipt", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getSalesLedger(type, dateRange, inputFromDate, inputToDate) {
        try {
            const data = {
                type: type,
                dateRange: dateRange,
                dateFrom: inputFromDate,
                dateTo: inputToDate
            };
            const response = await this.callWebService("/controller/Billing.asmx/getSalesLedger", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async studentEmailAction(mode, studentIndexNo) {
        try {
            const data = {
                mode: mode,
                studentIndexNo: studentIndexNo,
            };
            const response = await this.callWebService("/controller/Students.asmx/studentEmailAction", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async studentEmailActionManualPassword(mode, studentIndexNo, password) {
        try {
            const data = {
                mode: mode,
                studentIndexNo: studentIndexNo,
                password: password,
            };
            const response = await this.callWebService("/controller/Students.asmx/studentEmailAction", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async studentEmailActionByBatch(mode, studentIndexNoBatch) {
        try {
            const data = {
                mode: mode,
                studentIndexNoBatch: studentIndexNoBatch,
            };
            const response = await this.callWebService("/controller/Students.asmx/studentEmailAction", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getPostLearningMoment(portfolioDetailsPostID) {
        try {
            const data = {
                portfolioDetailsPostID: portfolioDetailsPostID,
            };
            const response = await this.callWebService("/controller/Posting.asmx/getPostLearningMoment", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getPostPortfolioDetailsPortfolio(portfolioDetailsPostID, type) {
        try {
            const data = {
                portfolioDetailsPostID: portfolioDetailsPostID,
                type: type,
            };
            const response = await this.callWebService("/controller/Posting.asmx/getPostPortfolioDetailsPortfolio", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getPostPortfolioDetailsPortfolioByPassToken(portfolioDetailsPostID, type, byPassToken) {
        try {
            const data = {
                portfolioDetailsPostID: portfolioDetailsPostID,
                type: type,
                byPassToken: byPassToken,
            };
            const response = await this.callWebService("/controller/Posting.asmx/getPostPortfolioDetailsPortfolio", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getPostPortfolioDetailsThemes(portfolioDetailsPostID) {
        try {
            const data = {
                portfolioDetailsPostID: portfolioDetailsPostID,
            };
            const response = await this.callWebService("/controller/Posting.asmx/getPostPortfolioDetailsThemes", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getPostPortfolioDetailsThemesByPassToken(portfolioDetailsPostID, byPassToken) {
        try {
            const data = {
                portfolioDetailsPostID: portfolioDetailsPostID,
                byPassToken: byPassToken,
            };
            const response = await this.callWebService("/controller/Posting.asmx/getPostPortfolioDetailsThemes", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getZipFiles(obj, type) {
        try {
            const data = {
                obj: obj,
                type: type,
            };
            const response = await this.callWebService("/controller/Billing.asmx/getZipFiles", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getHubSpotDetails(dealID) {
        try {
            const data = {
                dealId: dealID,
            };

            const request = {
                url: `${API_HOST2}/hubspot/getHubspotDetail`,
                data: JSON.stringify(data),
                cache: false,
                type: 'POST',
                enctype: 'multipart/form-data',
                processData: false,
                contentType: false,
                async: false,
                json: false,
                success: function (response) {
                    return response;
                }
            };

            let response = await jQuery.ajax(request);
            if (typeof response === "string") {
                response = JSON.parse(response);
            }

            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getStudentHubSpotDetials(studentID, dealID) {
        try {
            const data = {
                studentID: studentID,
                dealID: dealID,
            };
            const response = await this.callWebService("/controller/Students.asmx/getStudentHubSpotDetials", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getStudentHubSpotAttachment(HsdItemID) {
        try {
            const data = {
                HsdItemID: HsdItemID,
            };
            const response = await this.callWebService("/controller/Students.asmx/getStudentHubSpotAttachment", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async saveBatchItem(studentCourseObj, itemObj) {
        try {
            const data = {
                studentCourseObj: studentCourseObj,
                itemObj: itemObj,
            };
            const response = await this.callWebService("/controller/billing.asmx/saveBatchItem", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getActiveStudentsBySemSchool(semID, levelID, classID, studentCourseStatus, mealPreference, additionalLanguage, subsidy) {
        try {
            const data = {
                semID: semID,
                levelID: levelID,
                classID: classID,
                studentCourseStatus: studentCourseStatus,
                mealPreference: mealPreference,
                additionalLanguage: additionalLanguage,
                subsidy: subsidy,
            };
            const response = await this.callWebService("/controller/students.asmx/getActiveStudentsBySemSchool", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getBatchPaymentPlanMasterList(schoolID, courseID, classID) {
        try {
            const data = {
                schoolID: schoolID,
                courseID: courseID,
                classID: classID,
            };
            const response = await this.callWebService("/controller/billing.asmx/getBatchPaymentPlanMasterList", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async saveBatchPaymentPlan(studentCourseObj, paymentPlanObj) {
        try {
            const data = {
                studentCourseObj: studentCourseObj,
                paymentPlanObj: paymentPlanObj,
            };
            const response = await this.callWebService("/controller/billing.asmx/saveBatchPaymentPlan", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getBatchPaymentStartDate(semesterID, courseID, classID, studentCourseStatus) {
        try {
            const data = {
                semesterID: semesterID,
                courseID: courseID,
                classID: classID,
                studentCourseStatus: studentCourseStatus,
            };
            const response = await this.callWebService("/controller/billing.asmx/getBatchPaymentStartDate", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getStudentAuthorizedPickup(studentID) {
        try {
            const data = {
                studentID: studentID,
            };
            const response = await this.callWebService("/controller/Students.asmx/getStudentAuthorizedPickup", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getPickupAcknowledgementDetail(studentID) {
        try {
            const data = {
                studentID: studentID,
            };
            const response = await this.callWebService("/controller/Students.asmx/getPickupAcknowledgement", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async savePickupAcknowledgement(base64String, studentID, AuthPickUpID, pickAuthStatus, PaType) {
        try {
            const data = {
                base64String: base64String,
                studentID: studentID,
                AuthPickUpID: AuthPickUpID,
                pickAuthStatus: pickAuthStatus,
                PaType: PaType,
            };
            const response = await this.callWebService("/controller/Students.asmx/savePickupAcknowledgement", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getGlobalUniversityCode() {
        try {
            const data = {};
            const response = await this.callWebService("/controller/General.asmx/getGlobalUniversityCode", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getSemesterTermDetailsBySemID(semesterID, semdID, SMT_Status) {
        try {
            const data = {
                semesterID: semesterID,
                SMT_Status: SMT_Status,
                semd_ID: semdID,
            };
            const response = await this.callWebService("/controller/Course.asmx/getSemesterTermDetails", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getSemesterTermDetailsBySemDetailID(semesterID, semd_ID, SMT_Status) {
        try {
            const data = {
                semd_ID: semd_ID,
            };
            const response = await this.callWebService("/controller/Course.asmx/getSemesterTermDetails", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getNotificationsByRowNumber(natID, numberOfRows, passNumberOfDays) {
        try {
            const data = {
                natID: natID,
                numberOfRows: numberOfRows,
                passNumberOfDays: passNumberOfDays,
            };
            const response = await this.callWebService("/controller/Posting.asmx/getNotificationsByRowNumber", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async updateNotificationsStatus(natID, action) {
        try {
            const data = {
                natID: natID,
                action: action,
            };
            const response = await this.callWebService("/controller/Posting.asmx/updateNotifications", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getPayNowItems(InvoiceName, studentID, isEncrypted, ID) {
        try {
            const data = {
                InvoiceName: InvoiceName,
                studentID: studentID,
                isEncrypted: isEncrypted,
                ID: ID,
            };
            const response = await this.callWebService("/controller/Billing.asmx/getPayNowItems", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getQRCode(invoiceName, studentID, totalAmount, isEncrypted, ID) {
        try {
            const data = {
                invoiceName: invoiceName,
                studentID: studentID,
                totalAmount: totalAmount,
                isEncrypted: isEncrypted,
                ID: ID,
            };
            return await this.callWebService("/controller/Billing.asmx/getQRCode", data, "POST");
        } catch (e) {
            console.log(e);
        }
    }

    async getQRCodeNew(totalAmount, invoiceName, schoolUEN, schoolName) {
        try {
            const school = schoolName.replace(/[^a-zA-Z0-9 ]/g, '').replace(/\s+/g, ' ');
            const paynow = `/paynow?amount=${totalAmount}&reference=${invoiceName.trim()}&uen=${schoolUEN.trim()}&name=${school.trim()}`;
            return await this.callAPI(paynow, "GET", null, null, false, "https://payment.etonhouse.com");
        } catch (e) {
            console.log(e);
        }
    }

    // async studentInvoicePayment(student, invoice){
    //     try{
    //         const data = {
    //             student: student,
    //             invoice: invoice,
    //         };
    //         const response = await this.callWebService('/remember/student-invoice', data, "POST", false, false,false, "https://payment.etonhouse.com");
    //         return response
    //     }catch(e){
    //         console.log(e)
    //     }

    // }

    //todo for Payment Gateway page only:start
    async getPaymentGatewayStudentDetail(invoiceName, studentID, totalAmount, isEncrypted, type, ID) {
        try {
            const data = {
                invoiceName: invoiceName,
                studentID: studentID,
                totalAmount: totalAmount,
                isEncrypted: isEncrypted,
                type: type,
                ID: ID,
            };
            const response = await this.callWebService("/controller/Billing.asmx/getStudentDtlPaymentGateway", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    //todo for Payment Gateway page only:end

    //todo For re-print(invoice and receipt)
    async getStudentDtlPaymentGateway(invoiceName, studentID, totalAmount, isEncrypted, type) {
        try {
            const data = {
                invoiceName: invoiceName,
                studentID: studentID,
                totalAmount: totalAmount,
                isEncrypted: isEncrypted,
                type: type,
            };
            const response = await this.callWebService("/controller/Billing.asmx/getStudentDtlPaymentGateway", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    //todo For re-print(invoice and receipt)
    async getPaymentStatus(invoiceName, studentID, totalAmount, isEncrypted, ID) {
        try {
            const data = {
                invoiceName: invoiceName,
                studentID: studentID,
                totalAmount: totalAmount,
                isEncrypted: isEncrypted,
                ID: ID,
            };
            const response = await this.callWebService("/controller/Billing.asmx/getPaymentStatus", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getPtcPopulateSlots(objToPtcPopulateSlots) {
        try {
            const data = {
                objToPtcPopulateSlots: objToPtcPopulateSlots,
            };
            const response = await this.callWebService("/controller/Event.asmx/getPtcPopulateSlots", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async reprintInvoice(InvRecID, studentID) {
        try {
            const data = {
                InvRecID: InvRecID,
                studentID: studentID,
            };
            const response = await this.callWebService("/controller/Billing.asmx/reprintInvoice", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async reprintReceipt(InvRecID, studentID) {
        try {
            const data = {
                InvRecID: InvRecID,
                studentID: studentID,
            };
            const response = await this.callWebService("/controller/Billing.asmx/reprintReceipt", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getReprintDetail(studentID) {
        try {
            const data = {
                studentID: studentID,
            };
            const response = await this.callWebService("/controller/Billing.asmx/getReprintHistory", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getReprintHistoryList(InvRecID, type) {
        try {
            const data = {
                InvRecID: InvRecID,
                type: type,
            };
            const response = await this.callWebService("/controller/Billing.asmx/getReprintHistoryList", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getReprintDocumentHistory(InvRecID, auditID, type) {
        try {
            const data = {
                InvRecID: InvRecID,
                auditID: auditID,
                type: type,
            };
            const response = await this.callWebService("/controller/Billing.asmx/getReprintDocumentHistory", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async InviteParentRegister(email, type, parentID) {
        try {
            const data = {
                email: email,
                type: type,
                parentID: parentID,
            };

            const response = await this.callWebService("/controller/Api.asmx/CreateParentAccount", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async GetParentRegisterDetails(inputString) {
        try {
            const data = {
                inputString: inputString,
            };

            const response = await this.callWebService("/controller/Register.asmx/GetParentRegisterDetails", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async parentRegistrationByLink(email, password, type, parentID, notification) {
        try {
            const data = {
                email: email,
                password: password,
                type: type,
                parentID: parentID,
                notification: notification,
            };

            const response = await this.callWebService("/controller/Register.asmx/parentRegistrationByLink", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async updateUserConfigurationLanguege(value) {
        try {
            const data = {
                value: value,
            };

            const response = await this.callWebService("/controller/User.asmx/updateUserConfigurationLanguege", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getClassBySemesterLevel(crsID, semID) {
        try {
            const data = {
                crsID: crsID,
                semID: semID,
            };

            const response = await this.callWebService("/controller/Class.asmx/getClassBySemesterLevel", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getClassesInchargeSpecialistStaff(levelID, semesterID, className) {
        try {
            const data = {
                levelID: levelID,
                semesterID: semesterID,
                className: className,
            };

            const response = await this.callWebService("/controller/Class.asmx/getClassesInchargeSpecialistStaff", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getNavigationMenuMaster() {
        try {
            const data = {};

            const response = await this.callWebService("/controller/UserMagt.asmx/getNavigationMenuMaster", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async saveNavigationMenu(newMenuName) {
        try {
            const data = {
                newMenuName: newMenuName,
            };

            const response = await this.callWebService("/controller/UserMagt.asmx/saveNavigationMenu", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async updateNavigationMenu(menuID, mode) {
        try {
            const data = {
                menuID: menuID,
                mode: mode
            };

            const response = await this.callWebService("/controller/UserMagt.asmx/updateNavigationMenu", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getNavigationSubMenuByMenuID(menuID) {
        try {
            const data = {
                menuID: menuID
            };

            const response = await this.callWebService("/controller/UserMagt.asmx/getNavigationSubMenuByMenuID", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async saveNavigationSubMenu(newSubMenuName, newSubMenuLink, menuID) {
        try {
            const data = {
                newSubMenuName: newSubMenuName,
                newSubMenuLink: newSubMenuLink,
                menuID: menuID,
            };

            const response = await this.callWebService("/controller/UserMagt.asmx/saveNavigationSubMenu", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async updateNavigationSubMenu(subMenuID, mode) {
        try {
            const data = {
                subMenuID: subMenuID,
                mode: mode
            };

            const response = await this.callWebService("/controller/UserMagt.asmx/updateNavigationSubMenu", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getNavigationSubMenuWithoutMenu() {
        try {
            const data = {};

            const response = await this.callWebService("/controller/UserMagt.asmx/getNavigationSubMenuWithoutMenu", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getUserGroup() {
        try {
            const data = {};

            const response = await this.callWebService("/controller/UserMagt.asmx/getUserGroup", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getNavigationGroupAccessByGroupID(groupID) {
        try {
            const data = {
                groupID: groupID,
            };

            const response = await this.callWebService("/controller/UserMagt.asmx/getNavigationGroupAccessByGroupID", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getUnassignedSubMenuToGroupAccessByGroupID(groupID) {
        try {
            const data = {
                groupID: groupID,
            };

            const response = await this.callWebService("/controller/UserMagt.asmx/getUnassignedSubMenuToGroupAccessByGroupID", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async saveNavigationGroupAccess(subMenuID, groupID) {
        try {
            const data = {
                subMenuID: subMenuID,
                groupID: groupID,
            };

            const response = await this.callWebService("/controller/UserMagt.asmx/saveNavigationGroupAccess", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async updateNavigationGroupAccess(groupAccessID, mode) {
        try {
            const data = {
                groupAccessID: groupAccessID,
                mode: mode,
            };

            const response = await this.callWebService("/controller/UserMagt.asmx/updateNavigationGroupAccess", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async savePTCEvent(files, obj, participantObj, timeslotObj) {
        const formData = new FormData();
        formData.append("obj", obj);
        formData.append("ParticipantObj", participantObj);
        formData.append("TimeslotObj", timeslotObj);
        formData.append('token', Cookies.get('authToken'));
        formData.append('UserID_Session', Cookies.get('userIDSession'));
        formData.append('UserSchool_Session', Cookies.get('schoolSession'));
        formData.append('UserType_Session', Cookies.get('userTypeSession'));
        formData.append('UserUniversitySession', Cookies.get('userUniversitySession'));
        formData.append('UserEmailSession', Cookies.get('userEmailSession'));
        formData.append('USRidSession', Cookies.get('usRidSession'));
        formData.append('UserNameSession', Cookies.get('userNameSession'));
        console.log(files, "files");
        if (files && files.length > 1) {
            for (let key in files) {
                if (files.hasOwnProperty(key)) {
                    if (key > 0) {
                        formData.append(`upload_${key}`, files[key]);
                    } else {
                        formData.append("upload", files[key]);
                    }
                }
            }
        } else if (files) {
            formData.append("upload", files[0]);
        }
        const request = {
            url: `${API_HOST}/controller/Event.asmx/saveEvent`,
            cache: false,
            type: 'POST',
            data: formData,
            enctype: 'multipart/form-data',
            processData: false,
            contentType: false,
            async: false,
            json: false,
            success: function (response) {
                return response;
            }
        };
        let response = await jQuery.ajax(request);
        if (typeof response === "string") {
            response = JSON.parse(response);
        }
        return response;
    }

    async getPtcTimeslots(eventID) {
        try {
            const data = {
                eventID: eventID,
            };

            const response = await this.callWebService("/controller/Event.asmx/getEventTimeslots", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async updatePTCEvent(files, obj, participantObj, timeslotObj, timeslotValid) {
        const formData = new FormData();
        formData.append("obj", obj);
        formData.append("ParticipantObj", participantObj);
        formData.append("TimeslotObj", timeslotObj);
        formData.append("timeslotValid", timeslotValid);
        formData.append('token', Cookies.get('authToken'));
        formData.append('UserID_Session', Cookies.get('userIDSession'));
        formData.append('UserSchool_Session', Cookies.get('schoolSession'));
        formData.append('UserType_Session', Cookies.get('userTypeSession'));
        formData.append('UserUniversitySession', Cookies.get('userUniversitySession'));
        formData.append('UserEmailSession', Cookies.get('userEmailSession'));
        formData.append('USRidSession', Cookies.get('usRidSession'));
        formData.append('UserNameSession', Cookies.get('userNameSession'));
        if (files && files.length > 1) {
            for (let key in files) {
                // console.log(key);
                if (files.hasOwnProperty(key)) {
                    // console.log(files[key]);
                    if (key > 0) {
                        formData.append(`upload_${key}`, files[key]);
                    } else {
                        formData.append("upload", files[key]);
                    }
                }
            }
        } else if (files && files[0]) {
            formData.append("upload", files[0]);
        }

        console.log("files");
        console.log(files);

        const request = {
            url: `${API_HOST}/controller/Event.asmx/updateEvent`,
            cache: false,
            type: 'POST',
            data: formData,
            enctype: 'multipart/form-data',
            processData: false,
            contentType: false,
            async: false,
            json: false,
            success: function (response) {
                return response;
            }
        };

        let response = await jQuery.ajax(request);
        if (typeof response === "string") {
            response = JSON.parse(response);
        }
        return response;
    }

    async getPtcParticipant(eventID) {
        try {
            const data = {
                eventID: eventID,
            };

            const response = await this.callWebService("/controller/Event.asmx/getPtcParticipant", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async saveTimeslotBooking(eventTimeslotID, eventParID, eventID, eventHangoutLink, eventCalendarID) {
        try {
            const data = {
                eventTimeslotID: eventTimeslotID,
                eventParID: eventParID,
                eventID: eventID,
                eventHangoutLink: eventHangoutLink,
                eventCalendarID: eventCalendarID,
            };

            const response = await this.callWebService("/controller/Event.asmx/saveTimeslotBooking", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }
    async updateTimeslotBooking(eventTimeslotID, eventParID, eventID, eventHangoutLink, eventCalendarID) {
        try {
            const data = {
                eventTimeslotID: eventTimeslotID,
                eventID: eventID,
                eventHangoutLink: eventHangoutLink,
                eventCalendarID: eventCalendarID,
            };

            const response = await this.callWebService("/controller/Event.asmx/updateTimeSlotBooking", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async saveScheduleStudentClass(scheduleStudentListJsonString) {
        try {
            const data = {
                scheduleStudentListJsonString: scheduleStudentListJsonString,
            };

            const response = await this.callWebService("/controller/Students.asmx/saveScheduleStudentClass", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getScheduleStudentClass() {
        try {
            const data = {};

            const response = await this.callWebService("/controller/Students.asmx/getScheduleStudentClass", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async updateScheduleStudentClass(ClsSheID, mode) {
        try {
            const data = {
                ClsSheID: ClsSheID,
                mode: mode,
            };

            const response = await this.callWebService("/controller/Students.asmx/updateScheduleStudentClass", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getUnAssignStudentListFromBusScheduleByBusIDEffectiveDate(busType, effectiveDate) {
        try {
            const data = {
                busType: busType,
                effectiveDate: effectiveDate,
            };

            const response = await this.callWebService("/controller/Attendance.asmx/getUnAssignStudentListFromBusScheduleByBusIDEffectiveDate", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async saveScheduleBusNo(scheduleStudentListJsonString) {
        try {
            const data = {
                scheduleStudentListJsonString: scheduleStudentListJsonString,
            };

            const response = await this.callWebService("/controller/Attendance.asmx/saveScheduleBusNo", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getScheduleBusNo() {
        try {
            const data = {};

            const response = await this.callWebService("/controller/Attendance.asmx/getScheduleBusNo", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async updateScheduleusNo(BusSheID, mode) {
        try {
            const data = {
                BusSheID: BusSheID,
                mode: mode,
            };

            const response = await this.callWebService("/controller/Attendance.asmx/updateScheduleusNo", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getLibertyReport(inputDateFrom, inputDateTo) {
        try {
            const data = {
                dateFrom: inputDateFrom,
                dateTo: inputDateTo,
            };

            const response = await this.callWebService("/controller/Billing.asmx/getLibertyReport", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }

    }

    async getLibertyReport2(inputDateFrom, inputDateTo) {
        try {
            const data = {
                dateFrom: inputDateFrom,
                dateTo: inputDateTo,
            };

            const response = await this.callWebService("/controller/Billing.asmx/getLibertyReport2", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }

    }

    
    async getAllHistorySemesterAndSemesterDetailsByStudentID(studentID) {
        try {
            const data = {
                studentID: studentID,
            };

            const response = await this.callWebService("/controller/Students.asmx/getAllHistorySemesterAndSemesterDetailsByStudentID", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getPortfolioPostFile(postID, byPassToken) {
        const data = {
            postID: postID,
            byPassToken: byPassToken
        };
        const response = await this.callWebService("/controller/Posting.asmx/getPostFile", data, "POST");
        return response;
    }

    async saveWithdrawForm(Obj, WithdrawParentSignature, WithdrawOfficeUseSignature) {
        try {
            const data = {
                Obj: Obj,
                WithdrawParentSignature: WithdrawParentSignature,
                WithdrawOfficeUseSignature: WithdrawOfficeUseSignature,
            };

            const response = await this.callWebService("/controller/Parents.asmx/saveWithdrawForm", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getWithdrawFormDetail(classNameBatch, studentID, withdrawDate, isEncrypted, encrytedID, studentCourseID) {
        try {
            const data = {
                classNameBatch: classNameBatch,
                studentID: studentID,
                withdrawDate: withdrawDate,
                isEncrypted: isEncrypted,
                encrytedID: encrytedID,
                studentCourseID: studentCourseID,
            };

            const response = await this.callWebService("/controller/Parents.asmx/getWithdrawFormDetail", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async reTriggerWithdrawEmail(WithdrawEmailID) {
        const data = {
            WithdrawEmailID: WithdrawEmailID
        };
        const response = await this.callWebService("/controller/Parents.asmx/reTriggerWithdrawEmail", data, "POST");
        return response;
    }

    async saveStudentWithdraw(obj) {
        const data = {
            obj: obj
        };
        const response = await this.callWebService("/controller/Students.asmx/saveStudentWithdraw", data, "POST");
        return response;
    }

    async getWithdrawStatusByStudentID(studentID) {
        try {
            const data = {
                studentID: studentID,
            };

            const response = await this.callWebService("/controller/Parents.asmx/getWithdrawStatusByStudentID", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }


    async approvePlanner(actionStatus, plannerApproverID, approverComment) {
        try {
            const data = {
                actionStatus: actionStatus,
                plannerApproverID: plannerApproverID,
                approverComment: approverComment,
            };

            const response = await this.callWebService("/controller/Portfolio.asmx/approvePlanner", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async createGoogleCalendarEvent(creatorEmail, title, location, attendeeEmail, calStart, calEnd, randID, evtType, createType) {
        try {
            const data = {
                creatorEmail: creatorEmail,
                title: title,
                location: location,
                attendeeEmail: attendeeEmail,
                calStart: calStart,
                calEnd: calEnd,
                randID: randID,
                evtType: evtType,
                createType: createType,
            };

            const request = {
                url: `${API_HOST2}gmailaccount/createGoogleCalendarEvent`,
                // url: 'https://localhost:44310/api/gmailaccount/createGoogleCalendarEvent',
                data: JSON.stringify(data),
                type: 'POST',
                contentType: 'application/json',
                dataType: 'json',
                success: function (response) {
                    return response;
                }
            };

            console.log(data);
            let response = await jQuery.ajax(request);
            if (typeof response === "string") {
                response = JSON.parse(response);
            }

            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async deleteGoogleCalendarEvent(calEventID, attendeeEmail) {
        try {
            const data = {
                calEventID: calEventID,
                attendeeEmail: attendeeEmail,
            };

            const request = {
                url: `${API_HOST2}gmailaccount/deleteGoogleCalendarEvent`,
                // url: 'https://localhost:44310/api/gmailaccount/deleteGoogleCalendarEvent',
                data: JSON.stringify(data),
                type: 'POST',
                contentType: 'application/json',
                dataType: 'json',
                success: function (response) {
                    return response;
                }
            };

            let response = await jQuery.ajax(request);
            if (typeof response === "string") {
                response = JSON.parse(response);
            }

            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async saveStudentWithdraw(obj) {
        const data = {
            obj: obj
        };
        const response = await this.callWebService("/controller/Students.asmx/saveStudentWithdraw", data, "POST");
        return response;
    }

    async getStudentSiblingReport(type) {
        const data = {
            type: type
        };
        const response = await this.callWebService("/controller/Students.asmx/getStudentSiblingReport", data, "POST");
        return response;
    }

    async getPlannerAssignedStudentDetailsByAcademicYear(studentID, semID) {
        const data = {
            studentID: studentID,
            semID: semID,
        };
        const response = await this.callWebService("/controller/Portfolio.asmx/getPlannerAssignedStudentDetailsByAcademicYear", data, "POST");
        return response;
    }

    async getWithdrawDetailBySchoolID(mode) {
        const data = {
            mode: mode,
        };
        const response = await this.callWebService("/controller/Parents.asmx/getWithdrawDetailBySchoolID", data, "POST");
        return response;
    }

    async updateWithdrawDetailByID(withdrawID) {
        const data = {
            withdrawID: withdrawID,
        };
        const response = await this.callWebService("/controller/Parents.asmx/updateWithdrawDetailByID", data, "POST");
        return response;
    }

    async getStudentMovementReport(type, from_date, to_date) {
        const data = {
            type: type,
            from_date: from_date,
            to_date: to_date,
        };
        const response = await this.callWebService("/controller/Students.asmx/getStudentMovementReport", data, "POST");
        return response;
    }

    async getPortfolioItemMaster(type, type2, classID) {
        const data = {
            type: type,
            type2: type2,
            classID: classID,
        };

        const response = await this.callWebService("/controller/Portfolio.asmx/getPortfolioItemMaster", data, "POST");
        return response;
    }

    async saveTravelDeclaration(jsonObj) {
        const data = {
            jsonDetails: jsonObj
        };
        const response = await this.callWebService("/controller/Parents.asmx/saveParentTravelDeclaration", data, "POST");
        return response;
    }

    async getTravelDeclaration(parentID) {
        const data = {
            UserID_Session: parentID
        };
        const response = await this.callWebService("/controller/Parents.asmx/getParentTravelDeclaration", data, "POST");
        return response;
    }

    async deleteTravelDeclaration(trdcID, mode, remarks) {
        const data = {
            trdcID: trdcID,
            mode: mode,
            remark: remarks
        };
        const response = await this.callWebService("/controller/Parents.asmx/updateParentTravelDeclaration", data, "POST");
        return response;
    }

    async getActiveWithdrawFormWithStudID(studentID) {
        const data = {
            studentID: studentID,
        };
        const response = await this.callWebService("/controller/Parents.asmx/getActiveWithdrawFormWithStudID", data, "POST");
        return response;
    }

    async getWithdrawLeftOverAmountByStudentCourse(studentCourseID) {
        const data = {
            studentCourseID: studentCourseID,
        };
        const response = await this.callWebService("/controller/Parents.asmx/getWithdrawLeftOverAmountByStudentCourse", data, "POST");
        return response;
    }

    //getWithdrawLeftOverAmountByStudentCourse

    async getTravelDeclarationReport(schoolID) {
        const data = {
            UserSelectSchool: schoolID
        };
        const response = await this.callWebService("/controller/Parents.asmx/getJoinParentTravelDeclaration", data, "POST");
        return response;
    }

    async getNonTravelDeclarationReport(schoolID) {
        const data = {
            UserSelectSchool: schoolID
        };
        const response = await this.callWebService("/controller/Parents.asmx/getJoinParentTravelNonDeclaration", data, "POST");
        return response;
    }

    async getPaymentDocumentZip(InvoiceName, studentID, isEncrypted, ID) {
        const data = {
            InvoiceName: InvoiceName,
            studentID: studentID,
            isEncrypted: isEncrypted,
            ID: ID,
        };
        const response = await this.callWebService("/controller/Billing.asmx/getPaymentDocumentZip", data, "POST");
        return response;
    }

    async getParentTravelUnDeclaration(UserSelectSchool) {
        const data = {
            UserSelectSchool: UserSelectSchool
        };
        const response = await this.callWebService("/controller/Parents.asmx/getParentTravelUnDeclaration", data, "POST");
        return response;
    }

    async saveEndResult(files, eventID, remarks) {
        const formData = new FormData();
        formData.append("eventID", eventID);
        formData.append("remarks", remarks);
        formData.append('token', Cookies.get('authToken'));
        formData.append('UserID_Session', Cookies.get('userIDSession'));
        formData.append('UserSchool_Session', Cookies.get('schoolSession'));
        formData.append('UserType_Session', Cookies.get('userTypeSession'));
        formData.append('UserUniversitySession', Cookies.get('userUniversitySession'));
        formData.append('UserEmailSession', Cookies.get('userEmailSession'));
        formData.append('USRidSession', Cookies.get('usRidSession'));
        formData.append('UserNameSession', Cookies.get('userNameSession'));

        if (files && files.length > 1) {
            for (let key in files) {
                // console.log(key);
                if (files.hasOwnProperty(key)) {
                    // console.log(files[key]);
                    if (key > 0) {
                        formData.append(`upload_${key}`, files[key]);
                    } else {
                        formData.append("upload", files[key]);
                    }
                }
            }
        } else if (files) {
            formData.append("upload", files[0]);
        }
        const request = {
            url: `${API_HOST}/controller/Event.asmx/saveEventPostBack`,
            cache: false,
            type: 'POST',
            data: formData,
            enctype: 'multipart/form-data',
            processData: false,
            contentType: false,
            async: false,
            json: false,
            success: function (response) {
                return response;
            }
        };
        let response = await jQuery.ajax(request);
        if (typeof response === "string") {
            response = JSON.parse(response);
        }
        return response;
    }

    async getEventPostBack(eventID, mode) {
        const data = {
            eventID: eventID,
            mode: mode
        };
        const response = await this.callWebService("/controller/Event.asmx/getEventPostBack", data, "POST");
        return response;
    }

    async getEventPostBackFile(eventPBID) {
        const data = {
            eventPBID: eventPBID
        };
        const response = await this.callWebService("/controller/Event.asmx/getEventPostBackFile", data, "POST");
        return response;
    }

    async getAllEventPostBackZipFile(eventID, createdBy) {
        try {
            const data = {
                EventID: eventID,
                PostBackCreatedBy: createdBy,
            };
            const response = await this.callWebService("/controller/Event.asmx/getAllEventPostBackZipFile", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getPostFileReturnFilePath(postID) {
        const data = {
            postID: postID
        };
        const response = await this.callWebService("/controller/Posting.asmx/getPostFileReturnFilePath", data, "POST");
        return response;
    }

    async getServerCurrentDatetime() {
        const data = {};
        const response = await this.callWebService("/controller/Event.asmx/getCurrentDateTime", data, "POST");
        return response;
    }

    async saveRegistrationForm(parentID, Obj) {
        const data = {
            parentID: parentID,
            Obj: Obj,
        };
        const response = await this.callWebService("/controller/Register.asmx/saveRegistrationForm", data, "POST");
        return response;
    }

    async getRegistrationForm(parentID, regFormID) {
        const data = {
            parentID: parentID,
            regFormID: regFormID,
        };
        const response = await this.callWebService("/controller/Register.asmx/getRegistrationForm", data, "POST");
        return response;
    }

    async printStudentNameAndBarcode(obj, mode) {
        try {
            const data = {
                obj: obj,
                mode: mode,
            };
            const response = await this.callWebService("/controller/Class.asmx/printStudentNameAndBarcode", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getPortfolioMomentPost(int_NumberOfPost, str_LastPostID, studentID) {
        const data = {
            UserID_Session: Cookies.get('userIDSession'),
            numberOfPortfolio: int_NumberOfPost,
            lasPortfolioID: str_LastPostID,
            studentID: studentID,
        };
        const response = await this.callWebService("/controller/Portfolio.asmx/getPortfolioMomentPost", data, "POST");
        return response;
    }

    async getPostKeyTag(postID) {
        const data = {
            postID: postID,
        };
        const response = await this.callWebService("/controller/Posting.asmx/getPostKeyTag", data, "POST");
        return response;
    }

    async getTermlyReportList(studentID, classID, dateFrom, dateTo, status) {
      const data = {
        studentID: studentID,
        classID: classID,
        dateFrom: dateFrom,
        dateTo: dateTo,
        status: status
      };
      const response = await this.callWebService("/controller/TermlyReport.asmx/getTermlyReportList", data, "POST");
      return response;
    }

    async getTermlyReportPostList(studentID, classID) {
        const data = {
            studentID: studentID,
            classID: classID,
        };
        const response = await this.callWebService("/controller/TermlyReport.asmx/getTermlyReportPostList", data, "POST");
        return response;
    }

    async saveTermlyReport(studentID, classID, header, content, domainComments, inviteTeacher, teacherApproverList) {
        const data = {
            studentID: studentID,
            classID: classID,
            header: header,
            content: content,
            domainComments: domainComments,
            inviteTeacher: inviteTeacher,
            teacherApproverList: teacherApproverList,
        };
        const response = await this.callWebService("/controller/TermlyReport.asmx/saveTermlyReport", data, "POST");
        return response;
    }

    async getTermlyReport(termlyReportID) {
        const data = {
            termlyReportID: termlyReportID,
        };
        const response = await this.callWebService("/controller/TermlyReport.asmx/getTermlyReport", data, "POST");
        return response;
    }

    async removeTeacherTermlyReport(termlyReportID, ConId) {
        const data = {
            termlyReportID: termlyReportID,
            ConId: ConId,
        };
        const response = await this.callWebService("/controller/TermlyReport.asmx/removeTeacherTermlyReport", data, "POST");
        return response;
    }

    async checkTermlyReportFlow(termlyReportID, classID) {
        const data = {
            termlyReportID: termlyReportID,
            classID: classID,
        };
        const response = await this.callWebService("/controller/TermlyReport.asmx/checkTermlyReportFlow", data, "POST");
        return response;
    }

    async saveTermlyReportComments(termlyReportID, domainComments, classID) {
        const data = {
            termlyReportID: termlyReportID,
            domainComments: domainComments,
            classID: classID,
        };
        const response = await this.callWebService("/controller/TermlyReport.asmx/saveTermlyReportComments", data, "POST");
        return response;
    }

    async generateDownloadTermlyReportPDF(termlyReportID) {
        const data = {
            termlyReportID: termlyReportID,
        };
        const response = await this.callWebService("/controller/TermlyReport.asmx/generateDownloadTermlyReportPDF", data, "POST");
        return response;
    }

    async getTermlyReportFlow(termlyReportID, classID) {
        const data = {
            termlyReportID: termlyReportID,
            classID: classID,
        };
        const response = await this.callWebService("/controller/TermlyReport.asmx/getTermlyReportFlow", data, "POST");
        return response;
    }

    async getTermlyReportStudentInfoPart(studentID, classID) {
        const data = {
            studentID: studentID,
            classID: classID,
        };
        const response = await this.callWebService("/controller/TermlyReport.asmx/getTermlyReportStudentInfoPart", data, "POST");
        return response;
    }

    async submitTermlyReport(termlyReportID) {
        const data = {
            termlyReportID: termlyReportID,
        };
        const response = await this.callWebService("/controller/TermlyReport.asmx/submitTermlyReport", data, "POST");
        return response;
    }

    async submitTermlyReport(termlyReportID) {
        const data = {
            termlyReportID: termlyReportID,
        };
        const response = await this.callWebService("/controller/TermlyReport.asmx/submitTermlyReport", data, "POST");
        return response;
    }

    async signTermlyReportComments(termlyReportID, status) {
        const data = {
            termlyReportID: termlyReportID,
            status: status,
        };
        const response = await this.callWebService("/controller/TermlyReport.asmx/signTermlyReportComments", data, "POST");
        return response;
    }

    async savePostDM(postID, toConID, msgContent, postLink) {
        const data = {
            postID: postID,
            toConID: toConID,
            msgContent: msgContent,
            postLink: postLink,
        };
        const response = await this.callWebService("/controller/Posting.asmx/savePostDirectMsg", data, "POST");
        return response;
    }

    async getDMHistoryChat() {
        const data = {};
        const response = await this.callWebService("/controller/Posting.asmx/getPostDirectMsgHistoryChatPersonList", data, "POST");
        return response;
    }

    async getDMPersonChat(dmWithConID) {
        const data = {
            dmWithConID: dmWithConID,
        };
        const response = await this.callWebService("/controller/Posting.asmx/getPostDirectMsg", data, "POST");
        return response;
    }

    async deletePTCTimesolt(eventTimeslotID) {
        const data = {
            eventTimeslotID: eventTimeslotID,
        };
        const response = await this.callWebService("/controller/Event.asmx/deleteTimeSlotBooking", data, "POST");
        return response;
    }


    async insertApplicationQuestion(Question, QuestionOrdering) {
        try {
            const data = {
                QuestionDesc: Question,
                QuestionOrdering: QuestionOrdering,
            };
            const response = await this.callWebService("/controller/Form.asmx/insertApplicationQuestion", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getApplicationQuestion() {
        try {
            const data = {
                //QuestionDesc:Question,
                //QuestionOrdering: QuestionOrdering,
            };
            const response = await this.callWebService("/controller/Form.asmx/getApplicationQuestion", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }


    async saveFileTest(files, galFolderID) {
        const formData = new FormData();

        formData.append('fileType', "File");
        formData.append('ApplicationFormID', "APF_ID");
        formData.append('token', Cookies.get('authToken'));
        formData.append('UserID_Session', Cookies.get('userIDSession'));

        if (files && files.length > 1) {
            // console.log('multiple files');
            for (let i = 0; i < files.length; i++) {
                formData.append("files" + i, files[i]);
                formData.append("files" + i + '_UploadType', files[i].uploadType);
                console.log("files" + i + '_UploadType');
            }
        } else {
            // console.log('single file',files[0]);
            formData.append("files", files[0]);
            formData.append("files_UploadType", files[0].uploadType);
        }

        const request = {
            url: `${API_HOST}/controller/Form.asmx/testuploadFile`,
            cache: false,
            type: 'POST',
            data: formData,
            enctype: 'multipart/form-data',
            processData: false,
            contentType: false,
            async: false,
            json: false,
            success: function (response) {
                return response;
            }
        };

        let response = await jQuery.ajax(request);

        return response;
    }

    async saveApplicationAttachment(files, type){
        //note: params:
        // Doc1: File1
        // Doc_UploadType: xxx
        //
        // Doc2: File2
        // Doc2_UploadType: yyy
        const formData = new FormData();
        if (files && files.length > 1) {
            for (let key in files) {
                // console.log(key);
                if (files.hasOwnProperty(key)) {
                    // console.log(files[key]);
                    if (key > 0) {
                        formData.append(`Doc${Number(key)+1}`, files[key]);
                        formData.append(`Doc${Number(key)+1}_UploadType`, type);
                    } else {
                        formData.append("Doc1", files[key]);
                        formData.append(`Doc1_UploadType`, type);
                    }
                }
            }
        } else if (files && files.length) {
            formData.append("Doc1", files[0]);
            formData.append(`Doc1_UploadType`, type);
        }else{
            formData.append("Doc1", files);
            formData.append(`Doc1_UploadType`, type);
        }
        const response = await this.callWebService("/controller/Api.asmx/SaveApplicationAttachment", formData, "POST", true, true);
        return response;
    }

    async saveApplicationForm(status, PrevAttachedFiles, files, StuObj, ParentObj, QNAObj, SiblingObj, DeclareObj, selectedSchID, applicationFormID, applicationFormParentID, currentStudentImageAPATID, apat_ids) {
        const formData = new FormData();
        formData.append("status", status);
        formData.append("PrevAttachedFiles", PrevAttachedFiles);
        formData.append("StuObj", StuObj);
        formData.append("ParentObj", ParentObj);
        formData.append("QNAObj", QNAObj);
        formData.append("SiblingObj", SiblingObj);
        formData.append("DeclareObj", DeclareObj);
        formData.append('selectedSchID', selectedSchID);
        formData.append('fileType', "File");
        formData.append('token', Cookies.get('authToken'));
        formData.append("applicationFormID", applicationFormID);
        formData.append("applicationFormParentID", applicationFormParentID);
        formData.append("currentStudentImageAPATID", currentStudentImageAPATID);
        formData.append("apat_ids", apat_ids);

        // if (files && files.length > 1) {
        //     for (let i = 0; i < files.length; i++) {
        //         formData.append("files" + i, files[i]);
        //         formData.append("files" + i + '_UploadType', files[i].uploadType);
        //     }
        // } else if (files && files.length === 1) {
        //     formData.append("files", files[0]);
        //     formData.append("files_UploadType", files[0].uploadType);
        // }

        // const request = {
        //     url: `${API_HOST}/controller/Api.asmx/SaveApplicationForm`,
        //     cache: false,
        //     type: 'POST',
        //     data: formData,
        //     enctype: 'multipart/form-data',
        //     processData: false,
        //     contentType: false,
        //     async: false,
        //     json: false,
        //     success: function (response) {
        //         return response;
        //     }
        // };
        // let response = await jQuery.ajax(request);
        // if (typeof response === "string") {
        //     response = JSON.parse(response);
        // }
        // return response;

        const response = await this.callWebService("/controller/Api.asmx/SaveApplicationForm", formData, "POST", true, true);
        return response;

    }

    async getDraftApplicationForm(applicationFormID) {
        try {
            const data = {
                applicationFormID: applicationFormID,
            };
            const response = await this.callWebService("/controller/Form.asmx/getDraftApplicationForm", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    //todo: application list only
    async getApplicationList(schoolID) {
        try {
            const data = {
                schoolID: schoolID,
            };
            const response = await this.callWebService("/controller/Api.asmx/GetApplicationFormList", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getApplicationDetail(applicationFormID) {
        try {
            const data = {
                applicationFormID: applicationFormID,
            };
            const response = await this.callWebService("/controller/Api.asmx/GetApplicationFormList", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async updateApplicationFormStatus(ApprovedStatus, ApplicationFormID, RejectedReason, CommencementDate, mode) {
        try {
            const data = {
                ApprovedStatus: ApprovedStatus,
                ApplicationFormID: ApplicationFormID,
                RejectedReason: RejectedReason,
                CommencementDate: CommencementDate,
                mode: mode,
            };
            const response = await this.callWebService("/controller/Form.asmx/updateApplicationFormStatus", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async triggerApplicationEmail(apfID, primaryEmailAddress, remark, ChildFirstName) {
        const data = {
            apfID: apfID,
            primaryEmailAddress: primaryEmailAddress,
            remark: remark,
            ChildFirstName: ChildFirstName,
        };
        const response = await this.callWebService("/controller/Form.asmx/triggerApplicationEmail", data, "POST");
        return response;
    }

    //todo: get withdrawal list



    async saveWithdrawalForm({Date, StudentID, MainReason, School, SchoolDetails, Reason1, Reason2, Reason3, Reason1Text, Reason2Text, Reason3Text,StudentPass, BankAccountHolder,
                                 BankName, BankCode, BankAccount, Email, Contact, ParentName, ParentSignature, NoticeGiven,
                                 ExceptionRequest,ExceptionRequestDocs,CountryName,Improvement,SchoolType,
                                 RefundFeesPercentage, RefundFees, tempRemarksPL, RemarksPL, RemarksPrincipal, RemarksFinance,
                             ID,CopyToAdmin, CopyToParents, CopyToBusProvider, UpdateToICA, UpdateClassList, InformClassTeacher,StudentName, FormType}) {
        const formData = new FormData();

        // formData.append('fileType', "File");
        Date && formData.append("Date", Date);
        StudentID && formData.append("StudentID", StudentID);
        MainReason && formData.append("MainReason", MainReason);
        School && formData.append("School", School);
        SchoolDetails && formData.append("SchoolDetails", SchoolDetails);
        SchoolType && formData.append("SchoolType", SchoolType);
        Reason1 && formData.append("Reason1", Reason1);
        Reason2 && formData.append("Reason2", Reason2);
        Reason3 && formData.append("Reason3", Reason3);
        Reason1Text && formData.append("Reason1Details", Reason1Text);
        Reason2Text && formData.append("Reason2Details", Reason2Text);
        Reason3Text && formData.append("Reason3Details", Reason3Text);
        CountryName && formData.append("CountryName", CountryName);
        Improvement && formData.append("Improvement", Improvement);
        StudentPass && formData.append("StudentPass", StudentPass);
        BankAccountHolder && formData.append("BankAccountHolder", BankAccountHolder);
        BankName && formData.append("BankName", BankName);
        BankCode && formData.append("BankCode", BankCode);
        BankAccount && formData.append("BankAccount", BankAccount);
        Email && formData.append("Email", Email);
        Contact && formData.append("Contact", Contact);
        ParentName && formData.append("ParentName", ParentName);
        StudentName && formData.append("StudentName", StudentName);
        ParentSignature && formData.append("ParentSignature", ParentSignature);
        NoticeGiven && formData.append("NoticeGiven", NoticeGiven);
        FormType && formData.append("FormType", FormType);
        ExceptionRequest && formData.append("ExceptionRequest", ExceptionRequest);
        if(ExceptionRequest==="yes"){
            ExceptionRequestDocs && formData.append("ExceptionRequestDocs", JSON.stringify(ExceptionRequestDocs));
        }
        RefundFeesPercentage && formData.append("RefundFeesPercentage", RefundFeesPercentage);
        RefundFees && formData.append("RefundFees", RefundFees);
        if(tempRemarksPL){
            formData.append("RemarksPL", RemarksPL + "\n" + tempRemarksPL);
        }else if(RemarksPL){
            formData.append("RemarksPL", RemarksPL);
        }
        RemarksPrincipal && formData.append("RemarksPrincipal", RemarksPrincipal);
        RemarksFinance && formData.append("RemarksFinance", RemarksFinance);
        ID && formData.append("ID", ID);
        CopyToAdmin && formData.append("CopyToAdmin", CopyToAdmin);
        CopyToParents && formData.append("CopyToParents", CopyToParents);
        CopyToBusProvider && formData.append("CopyToBusProvider", CopyToBusProvider);
        UpdateToICA && formData.append("UpdateToICA", UpdateToICA);
        UpdateClassList && formData.append("UpdateClassList", UpdateClassList);
        InformClassTeacher && formData.append("InformClassTeacher", InformClassTeacher);
        formData.append('UserID_Session', Cookies.get('userIDSession'));
        formData.append('UserSchool_Session', Cookies.get('schoolSession'));
        formData.append('UserType_Session', Cookies.get('userTypeSession'));
        formData.append('UserUniversitySession', Cookies.get('userUniversitySession'));
        formData.append('UserEmailSession', Cookies.get('userEmailSession'));
        formData.append('USRidSession', Cookies.get('usRidSession'));
        formData.append('UserNameSession', Cookies.get('userNameSession'));

        const response = await this.callWebService("/controller/Api.asmx/SaveWithdrawalForm", formData, "POST", true, true);
        return response;
    }

    async getWithdrawalList() {
        try {
            const data = {
            };
            const response = await this.callWebService("/controller/Api.asmx/GetWithdrawalFormList", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getWithdrawalFormDetail(withdrawalFormID) {
        try {
            const data = {
            };
            const response = await this.callWebService("/controller/Api.asmx/GetWithdrawalForm?id="+withdrawalFormID, data, "GET");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getStudentforWithdrawal(studentID,date) {
        try {
            const data = {
            };
            let params;
            if (date) {
                params = "id=" + studentID + "&classDate=" + date;
            } else {
                params = "id=" + studentID;
            }
            const response = await this.callWebService("/controller/Api.asmx/GetStudent?"+params, data, "GET");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async approveWithdrawalForm(FormID){
        const data = {
            ConID: getUserID(),
            FormID: FormID,
            callIndex: generateRandomIndex()
        };

        return await this.callWebService("/controller/Api.asmx/ApproveWithdrawalForm", data, "POST");
    }

    async rejectWithdrawalForm(FormID){
        const data = {
            ConID: getUserID(),
            FormID: FormID,
        };

        return await this.callWebService("/controller/Api.asmx/RejectWithdrawalForm", data, "POST");
    }

    async deleteWithdrawalForm(FormID){
        const data = {
            ConID: getUserID(),
            FormID: FormID,
        };

        return await this.callWebService("/controller/Api.asmx/DeleteWithdrawalForm", data, "POST");
    }

    async sendWithdrawalFormNotifications(FormID){
        const data = {
            ConID: getUserID(),
            FormID: FormID,
        };

        return await this.callWebService("/controller/Api.asmx/SendWithdrawalFormNotifications", data, "POST");
    }

    async sendWithdrawFormLinkToParent(studentID){
        const data = {
            studentID: studentID,
        };
        return await this.callWebService("/controller/Api.asmx/SendWithdrawFormLinkToParent", data, "POST");
    }
    //todo: get withdrawal list: end

    async getPlannerProgressPost(itemID) {
        const data = {
            itemID: itemID,
        };
        const response = await this.callWebService("/controller/Portfolio.asmx/getPlannerProgressPost", data, "POST");
        return response;
    }

    async savePortfolio(mode, studentID, portfolioTitle, portfolioEditID, portfolioTemplateHtml, portfolioTemplateCss, learningMoments) {

        const data = {
            portfolioEditID: portfolioEditID,
            mode: mode,
            studentID: studentID,
            portfolioTitle: portfolioTitle,
            portfolioTemplateHtml: portfolioTemplateHtml,
            portfolioTemplateCss: portfolioTemplateCss,
            learningMoments: learningMoments,
        };

        return await this.callWebService("/controller/Portfolio.asmx/savePortfolio", data, "POST");
    }

    async getTermlyReportInfoByLink(termlyReportID) {
        const data = {
            termlyReportID: termlyReportID,
        };
        return await this.callWebService("/controller/TermlyReport.asmx/getTermlyReportInfoByLink", data, "POST");
    }

    async donwloadPlannerAssignedStudent(objectItem) {
        const data = {
            objectItem: objectItem,
        };
        return await this.callWebService("/controller/Portfolio.asmx/donwloadPlannerAssignedStudent", data, "POST");
    }

    async updateUserConfiguration(objectItem) {
        const data = {
            objectItem: objectItem,
        };
        return await this.callWebService("/controller/User.asmx/updateUserConfiguration", data, "POST");
    }

    async getUserConfigurationValueByType(typeJsonString) {
        const data = {
            typeJsonString: typeJsonString,
        };
        return await this.callWebService("/controller/User.asmx/getUserConfigurationValueByType", data, "POST");
    }

    async getPostDevelopmentGoals(postID) {
        try {
            const data = {
                postID: postID,
            };
            const response = await this.callWebService("/controller/Posting.asmx/getPostLearningMoment", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getPostSeen(postID) {
        try {
            const data = {
                postID: postID,
            };
            const response = await this.callWebService("/controller/Posting.asmx/getPostSeen", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getStudentTravelDeclaration(studentID) {
        try {
            const data = {
                studentID: studentID,
            };
            const response = await this.callWebService("/controller/Students.asmx/getStudentTravelDeclaration", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async saveIncidentForm(files, schoolID, Obj, TeacherSignObj, parentSelectedObj) {
        const formData = new FormData();
        formData.append("Obj", Obj);
        formData.append("TeacherSignObj", TeacherSignObj);
        formData.append("parentSelectedObj", parentSelectedObj);
        formData.append('token', Cookies.get('authToken'));
        formData.append('UserID_Session', Cookies.get('userIDSession'));
        formData.append('UserSchool_Session', Cookies.get('schoolSession'));
        formData.append('UserType_Session', Cookies.get('userTypeSession'));
        formData.append('UserUniversitySession', Cookies.get('userUniversitySession'));
        formData.append('UserEmailSession', Cookies.get('userEmailSession'));
        formData.append('USRidSession', Cookies.get('usRidSession'));
        formData.append('UserNameSession', Cookies.get('userNameSession'));
        if (files && files.length > 1) {
            for (let key in files) {
                if (files.hasOwnProperty(key)) {
                    if (key > 0) {
                        formData.append(`upload_${key}`, files[key]);
                    } else {
                        formData.append("upload", files[key]);
                    }
                }
            }
        } else if (files) {
            formData.append("upload", files[0]);
        }
        const request = {
            url: `${API_HOST}/controller/Form.asmx/saveIncidentForm`,
            cache: false,
            type: 'POST',
            data: formData,
            enctype: 'multipart/form-data',
            processData: false,
            contentType: false,
            async: false,
            json: false,
            success: function (response) {
                return response;
            }
        };
        let response = await jQuery.ajax(request);
        if (typeof response === "string") {
            response = JSON.parse(response);
        }
        return response;
    }

    async getIncidentForm(IncidentFormID) {
        const data = {
            IncidentFormID: IncidentFormID,
        };
        return await this.callWebService("/controller/Form.asmx/getIncidentForm", data, "POST");
    }

    async approveIncidentForm(IncidentID, IncidentLogID, ApproveReason) {
        const data = {
            IncidentID: IncidentID,
            IncidentLogID: IncidentLogID,
            ApproveReason: ApproveReason,
        };
        return await this.callWebService("/controller/Form.asmx/approveIncidentForm", data, "POST");
    }

    async rejectIncidentForm(IncidentID, IncidentLogID, RejectReason) {
        const data = {
            IncidentID: IncidentID,
            IncidentLogID: IncidentLogID,
            RejectReason: RejectReason,
        };
        return await this.callWebService("/controller/Form.asmx/rejectIncidentForm", data, "POST");
    }

    async appealIncidentForm(files, IncidentID, IncidentLogID, UpdateAppealObj) {

        const formData = new FormData();

        formData.append("IncidentID", IncidentID);
        formData.append("IncidentLogID", IncidentLogID);
        formData.append("UpdateAppealObj", UpdateAppealObj);
        formData.append('token', Cookies.get('authToken'));
        formData.append('UserID_Session', Cookies.get('userIDSession'));
        formData.append('UserSchool_Session', Cookies.get('schoolSession'));
        formData.append('UserType_Session', Cookies.get('userTypeSession'));
        formData.append('UserUniversitySession', Cookies.get('userUniversitySession'));
        formData.append('UserEmailSession', Cookies.get('userEmailSession'));
        formData.append('USRidSession', Cookies.get('usRidSession'));
        formData.append('UserNameSession', Cookies.get('userNameSession'));
        // formData.append('commentValue', commentValue);
        if (files && files.length > 1) {
            for (let key in files) {
                if (files.hasOwnProperty(key)) {
                    if (key > 0) {
                        formData.append(`upload_${key}`, files[key]);
                    } else {
                        formData.append("upload", files[key]);
                    }
                }
            }
        } else if (files) {
            formData.append("upload", files[0]);
        }
        const request = {
            url: `${API_HOST}/controller/Form.asmx/appealIncidentForm`,
            cache: false,
            type: 'POST',
            data: formData,
            enctype: 'multipart/form-data',
            processData: false,
            contentType: false,
            async: false,
            json: false,
            success: function (response) {
                return response;
            }
        };
        let response = await jQuery.ajax(request);
        if (typeof response === "string") {
            response = JSON.parse(response);
        }
        return response;
    }

    async generateIncidentPDF(IncidentID) {
        const data = {
            IncidentID: IncidentID,
        };
        return await this.callWebService("/controller/Form.asmx/generateIncidentPDF", data, "POST");
    }

    async getIncidentList(schoolID) {
        const data = {
            schoolID: schoolID,
        };
        return await this.callWebService("/controller/Form.asmx/getIncidentList", data, "POST");
    }

    async getIncidentFileDetail(IncidentID) {
        const data = {
            IncidentID: IncidentID,
        };
        return await this.callWebService("/controller/Form.asmx/getIncidentFileDetail", data, "POST");
    }

    async cancelIncidentForm(IncidentID, cancelReason) {
        const data = {
            IncidentID: IncidentID,
            cancelReason: cancelReason
        };
        return await this.callWebService("/controller/Form.asmx/cancelIncidentForm", data, "POST");
    }

    async updateLevel(scrID, mode, voidReasons) {
        try {
            const data = {
                scrID: scrID,
                mode: mode,
                voidReasons: voidReasons,
            };
            const response = await this.callWebService("/controller/Course.asmx/updateLevel", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async updateLevelClass(scrID, mode, voidReasons, newlevel, newclass, newstartdate) {
        try {
            const data = {
                scrID: scrID,
                mode: mode,
                voidReasons: voidReasons,
                newlevel: newlevel,
                newclass: newclass,
                newstartdate: newstartdate,
            };
            const response = await this.callWebService("/controller/Course.asmx/updateLevelClass", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getInvoicListPT(type, studentID) {
        try {
            const data = {
                type: type,
                studentID: studentID,
            };
            const response = await this.callWebService("/controller/Billing.asmx/getInvoicListPT", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getPortfolioMomentPostWithNewsFeed(lastItemID, noOfItem, studentID, searchTitle, fromDate, endDate) {
        try {
            const data = {
                lastItemID: lastItemID,
                noOfItem: noOfItem,
                studentID: studentID,
                searchTitle: searchTitle,
                fromDate: fromDate,
                endDate: endDate,
            };
            const response = await this.callWebService("/controller/Portfolio.asmx/getPortfolioMomentPostWithNewsFeed", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getPowerbiEmbedReport() {
        try {
            const data = {};

            const request = {
                url: `${API_HOST2}/powerbi/EmbedReport`,
                // url: `https://localhost:44310/api/powerbi/EmbedReport`,
                data: JSON.stringify(data),
                cache: false,
                type: 'POST',
                enctype: 'multipart/form-data',
                processData: false,
                contentType: false,
                async: false,
                json: false,
                success: function (response) {
                    return response;
                }
            };

            let response = await jQuery.ajax(request);
            if (typeof response === "string") {
                response = JSON.parse(response);
            }

            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getPowerbiEmbedAgingReport() {
        try {
            const data = {
                // reportId: "a0bbad68-4ca4-43ed-b9be-4eeb8762af0d",
            };

            const request = {
                url: `${API_HOST2}/powerbi/EmbedAgingReport`,
                // url: `https://localhost:44310/api/powerbi/EmbedAgingReport`,
                data: JSON.stringify(data),
                cache: false,
                type: 'POST',
                enctype: 'multipart/form-data',
                processData: false,
                contentType: false,
                async: false,
                json: false,
                success: function (response) {
                    return response;
                }
            };

            let response = await jQuery.ajax(request);
            if (typeof response === "string") {
                response = JSON.parse(response);
            }

            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getCreateTermlyClassTeacher(classID) {
        try {
            const data = {
                id: classID
            };
            const response = await this.callWebService("/controller/Api.asmx/GetClass", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getTermlyReportDomainMapping() {
        try {
            const data = {};
            const response = await this.callWebService("/controller/TermlyReport.asmx/getTermlyReportDomainMapping", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async updateAttendanceListWithTemperatureNew(deviceOutput, student_Index, temprature, inOut, remark) {
        try {
            const data = {
                deviceOutput: deviceOutput,
                student_Index: student_Index,
                temprature: temprature,
                inOut: inOut,
                remark: remark,
            };

            const response = await this.callWebService("/controller/Attendance.asmx/updateAttendanceListWithTemperature", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getStudentNew(studentID_Index, studentStatus) {
        const data = {
            studentID_Index: studentID_Index,
            studentStatus: studentStatus,
        };
        const response = await this.callWebService("/controller/Students.asmx/getStudent", data, "POST");
        return response;
    }

    async getSystemValue(appType) {
        const data = {
            appType: appType,
        };
        const response = await this.callWebService("/controller/General.asmx/getSystemValue", data, "POST");
        return response;
    }

    async updateTermlyReport(termlyReportID, mode) {
        const data = {
            termlyReportID: termlyReportID,
            mode: mode,
        };
        const response = await this.callWebService("/controller/TermlyReport.asmx/updateTermlyReport", data, "POST");
        return response;
    }

    async getStudentCurrentClassMate(studentID) {
        const data = {
            studentID: studentID,
        };
        const response = await this.callWebService("/controller/Students.asmx/getStudentCurrentClassMate", data, "POST");
        return response;
    }

    async getDailyRoutineByStudentIDwithDate(studentID, selectedDate) {
        const data = {
            studentID: studentID,
            selectedDate: selectedDate,
        };

        const response = await this.callWebService("/controller/Daily_Routine.asmx/getKgm_DailyRoutineByDate", data, "POST");
        return response;
    }

    async getStudentFileParentID(fileID) {
        const data = {
            fileID: fileID,
        };

        const response = await this.callWebService("/controller/Students.asmx/getStudentFileParentID", data, "POST");
        return response;
    }

    async getUserLatestGroupPostKeyTag(noPostKeyTag) {
        const data = {
            noPostKeyTag: noPostKeyTag,
        };

        const response = await this.callWebService("/controller/Posting.asmx/getUserLatestGroupPostKeyTag", data, "POST");
        return response;
    }

    async getClassCoordinator() {
        const data = {};

        const response = await this.callWebService("/controller/Class.asmx/getClassCoordinator", data, "POST");
        return response;
    }

    async updateClassCoordinator(list) {
        const data = {
            list: list,
        };

        const response = await this.callWebService("/controller/Class.asmx/updateClassCoordinator", data, "POST");
        return response;
    }

    async publishTermlyReport(termlyReportID) {
        const data = {
            termlyReportID: termlyReportID,
        };

        const response = await this.callWebService("/controller/TermlyReport.asmx/publishTermlyReport", data, "POST");
        return response;
    }

    async getPublishedTermlyReport(numberOfTermlyReport, lastTermlyReportID, mode) {
        const data = {
            numberOfTermlyReport: numberOfTermlyReport,
            lastTermlyReportID: lastTermlyReportID,
            mode: mode,
        };

        const response = await this.callWebService("/controller/TermlyReport.asmx/getPublishedTermlyReport", data, "POST");
        return response;
    }

    async updateTermlyReportCommentsByApproval(termlyReportID, termlyReportCommentID, editTermlyReportComment) {
        const data = {
            termlyReportID: termlyReportID,
            termlyReportCommentID: termlyReportCommentID,
            editTermlyReportComment: editTermlyReportComment,
        };

        const response = await this.callWebService("/controller/TermlyReport.asmx/updateTermlyReportCommentsByApproval", data, "POST");
        return response;
    }

    async getCardUpURL(invoiceName, studentID, totalAmount, isEncrypted, ID) {
        try {
            const data = {
                invoiceName: invoiceName,
                studentID: studentID,
                totalAmount: totalAmount,
                isEncrypted: isEncrypted,
                ID: ID,
            };
            const response = await this.callWebService("/controller/Billing.asmx/getCardUpURL", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async checkLinkExpiry(invoiceName, studentID, totalAmount, isEncrypted, ID) {
        try {
            const data = {
                invoiceName: invoiceName,
                studentID: studentID,
                totalAmount: totalAmount,
                isEncrypted: isEncrypted,
                ID: ID,
            };
            const response = await this.callWebService("/controller/Billing.asmx/checkLinkExpiry", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getSchoolDropdownList(universityID) {
        try {
            const data = {
                universityID: universityID,
            };
            const response = await this.callWebService("/controller/UserMagt.asmx/getSchoolDropdownList", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getSchoolDropdownListByUser(universityID) {
        try {
            let conUserId = Cookies.get('userIDSession');
            
            const data = {
                universityID: universityID,
                conUserId: conUserId,
            };
            const response = await this.callWebService("/controller/UserMagt.asmx/getSchoolDropdownListByUser", data, "POST");
            return response; 
        } catch (e) {
            console.log(e);
        }
    }

    async getSchoolGroupDropdownListByUser(universityID) {
        try {
            let conUserId = Cookies.get('userIDSession');
            
            const data = {
                universityID: universityID,
                conUserId: conUserId,
            };
            const response = await this.callWebService("/controller/UserMagt.asmx/getSchoolGroupDropdownList", data, "POST");
            return response; 
        } catch (e) {
            console.log(e);
        }
    }

    async getEmployeeTypeDropdownList() {
        const data = {};

        const response = await this.callWebService("/controller/UserMagt.asmx/getEmployeeTypeDropdownList", data, "POST");
        return response;
    }


    async getTermlyReportPendingActionList() {
        const data = {};

        const response = await this.callWebService("/controller/TermlyReport.asmx/getTermlyReportPendingActionList", data, "POST");
        return response;
    }

    async createNewStaffAccount(Obj) {
        try {
            const data = {
                Obj: Obj,
            };
            const response = await this.callWebService("/controller/UserMagt.asmx/saveNewStaffAccount", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getUserListBySchool(SchoolID, Status, CONnameLike) {
        try {
            const data = {
                SchoolID: SchoolID,
                Status: Status,
                CONnameLike: CONnameLike,
            };
            const response = await this.callWebService("/controller/UserMagt.asmx/getUserListBySchool", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getUserDetailsWithSchoolNameByCONID(conID, schoolID, conEmail) {
        try {
            const data = {
                conID: conID,
                schoolID: schoolID,
                conEmail: conEmail,
            };
            const response = await this.callWebService("/controller/UserMagt.asmx/getUserDetailsWithSchoolNameByCONID", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getUserGroupByUSRID(usrID) {
        try {
            const data = {
                usrID: usrID,
            };
            const response = await this.callWebService("/controller/UserMagt.asmx/getUserGroupByUSRID", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async updateStaffAccountStatus(Obj, status) {
        try {
            const data = {
                Obj: Obj,
                status: status,
            };
            const response = await this.callWebService("/controller/UserMagt.asmx/updateStaffAccountStatus", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async assignUserGroup(Obj, staffUSRid) {
        try {
            const data = {
                Obj: Obj,
                staffUSRid: staffUSRid,
            };
            const response = await this.callWebService("/controller/UserMagt.asmx/assignUserGroup", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getUserSchoolByCONEmail(CONEmail, CONStatus) {
        try {
            const data = {
                CONEmail: CONEmail,
                CONStatus: CONStatus,
            };
            const response = await this.callWebService("/controller/UserMagt.asmx/getUserSchoolByCONEmail", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getStudentsEmailBySchool() {
        const data = {};

        const response = await this.callWebService("/controller/Students.asmx/getStudentsEmailBySchool", data, "POST");
        return response;
    }

    async getApplicationFormDetail(applicationFormID) {
        try {
            const data = {
                applicationFormID: applicationFormID,
            };
            const response = await this.callWebService("/controller/Api.asmx/GetApplicationFormList", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async approveOrRejectApplicationForm(APMD_ID, APF_ID, mode, reason, additionalData) {
        try {
            const data = {
                APMD_ID: APMD_ID,
                APF_ID: APF_ID,
                mode: mode,
                reason: reason,
                ...additionalData
            };
            return await this.callWebService("/controller/Api.asmx/ApproveOrRejectApplicationForm", data, "POST");
        } catch (e) {
            console.log(e);
        }
    }

    async verifyEmailForApplicationForm(VerificationEmail, encryptedID) {
        try {
            const data = {
                VerificationEmail: VerificationEmail,
                encryptedID: encryptedID
            };
            return await this.callWebService("/controller/Form.asmx/verifyEmailForApplicationForm", data, "POST");
        } catch (e) {
            console.log(e);
        }
    }

    async getCountryListWithoutToken() {
        try {
            const data = {};
            const response = await this.callWebService("/controller/Form.asmx/getCountryListWithoutToken", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async updateUserDetail(conID, usrID, usrLoginID, obj) {
        try {
            const data = {
                conID: conID,
                usrID: usrID,
                usrLoginID: usrLoginID,
                obj: obj,
            };
            const response = await this.callWebService("/controller/UserMagt.asmx/updateUserAccountDetail", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async updateUserLoginDetail(conID, usrID, usrLoginID, pass) {
        try {
            const data = {
                conID: conID,
                usrID: usrID,
                usrLoginID: usrLoginID,
                pass: pass
            };
            const response = await this.callWebService("/controller/UserMagt.asmx/updateUserLoginDetail", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getParentRegisterStatusReport() {
        const data = {};

        const response = await this.callWebService("/controller/Register.asmx/getParentRegisterStatusReport", data, "POST");
        return response;
    }

    async saveCovid19Declaration(jsonObj) {
        const data = {
            jsonDetails: jsonObj
        };
        const response = await this.callWebService("/controller/Parents.asmx/saveParentCovidDeclaration", data, "POST");
        return response;
    }

    async getCovid19Declaration(/*parentID*/) {
        const data = {
            // UserID_Session: parentID
        };
        const response = await this.callWebService("/controller/Parents.asmx/getParentCovidDeclaration", data, "POST");
        return response;
    }

    async deleteCovid19Declaration(cvdcID, mode, remarks) {
        const data = {
            cvdcID: cvdcID,
            mode: mode,
            remark: remarks
        };
        const response = await this.callWebService("/controller/Parents.asmx/updateParentCovidDeclaration", data, "POST");
        return response;
    }

    async getAutoAssignLevelAcademicYear(commencementDate, dateOfBirth, selectedSchoolID) {
        try {
            const data = {
                selectedSchoolID: selectedSchoolID,
                commencementDate: commencementDate,
                dateOfBirth: dateOfBirth,
            };
            return await this.callWebService("/controller/Api.asmx/GetAutoAssignLevelAcademicYear", data, "POST");
        } catch (e) {
            console.log(e);
        }
    }

    async gethubspotDetail(contactID, dealID) {
        try {
            const data = {
                contactID: contactID,
                dealID: dealID,
            }
            const response = await this.callWebService("/controller/Form.asmx/gethubspotDetail ", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getParentStudentsInfoWithMode(parentID, mode) {
        const data = {
            parentID: parentID,
            mode: mode,
        };
        const response = await this.callWebService("/controller/Parents.asmx/getParentStudentsInfo", data, "POST");
        return response;
    }

    async getParentCovidDeclarationReport() {
        const data = {};
        const response = await this.callWebService("/controller/Parents.asmx/getParentCovidDeclarationReport", data, "POST");
        return response;
    }

    async changeParentEmail(secretKey, fromEmail, toEmail) {
        try {
            const data = {
                secretKey: secretKey,
                fromEmail: fromEmail,
                toEmail: toEmail
            }
            const response = await this.callWebService("/controller/Secret_Admin_Config_Token.asmx/changeParentEmail ", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getAttendanceListViewClass() {
        try {
            const data = {}
            const response = await this.callWebService("/controller/Attendance.asmx/getAttendanceListViewClass ", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async createDealAssociateWithContactID(contactID, schoolID, studObj) {
        try {
            const data = {
                contactID: contactID,
                studObj: studObj,
                schoolID: schoolID
            }
            const response = await this.callWebService("/controller/Form.asmx/createDealAssociateWithContactID ", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getFolderZipFiles(galID) {
        try {
            const data = {
                galID: galID,
            };
            const response = await this.callWebService("/controller/Gallery.asmx/getFolderZipFiles", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getUserDetailsByCONID(conID) {
        try {
            const data = {
                conID: conID,
            };
            const response = await this.callWebService("/controller/User.asmx/getUserDetailsByCONID", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async SendEmailBcc(str_EmailSubject, str_InnerHTML, lst_StudentID, lst_EmailGroupType, str_EmailFrom, str_AddEmailtoBCC) {
        try {
            const data = {
                str_EmailSubject: str_EmailSubject,
                str_InnerHTML: str_InnerHTML,
                lst_StudentID: lst_StudentID,
                lst_EmailGroupType: lst_EmailGroupType,
                str_EmailFrom: str_EmailFrom,
                str_AddEmailtoBCC: str_AddEmailtoBCC
            };
            const response = await this.callWebService("/controller/EmailSend.asmx/SendEmailBcc", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getLoadTemplate(mode, postStatus, numberOfPost) {
        const data = {
            mode,
            postStatus,
            numberOfPost
        };
        const response = await this.callWebService("/controller/Posting.asmx/getLoadTemplate", data, "POST");
        return response;
    }

    async getClassList() {
        const data = {};
        const response = await this.callWebService("/controller/Planner.asmx/GetClassList", data, "POST");
        return response;
    }

    async getDomainList(level) {
        const data = {
            level: level
        };
        const response = await this.callWebService("/controller/Planner.asmx/GetDomainList", data, "POST");
        return response;
    }

    async getLevelList(schID) {
        const data = {
            schID: schID
        };
        const response = await this.callWebService("/controller/Planner.asmx/GetLeveList", data, "POST");
        return response;
    }

    async insertCustomGoal(customGoalDomain, customGoalGoal, customGoalIndicator) {
        try {
            const data = {
                domain: customGoalDomain,
                goal: customGoalGoal,
                indicator: customGoalIndicator
            };
            const response = await this.callWebService("/controller/Planner.asmx/insertCustomGoal", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }

    }

    async fetchCustomGoals(customGoalDomain, customGoalGoal) {
        const data = {
            domain: customGoalDomain,
            goal: customGoalGoal,
        };
        const response = await this.callWebService("/controller/Planner.asmx/fetchCustomGoals", data, "POST");
        return response;
    }

    async saveCustomPlannerAssignedToCourse(newPlannerAssignedToCourseObjJson) {
        try {
            const data = {
                newPlannerAssignedToCourseObjJson: newPlannerAssignedToCourseObjJson,
            };
            const response = await this.callWebService("/controller/Planner.asmx/saveCustomPlannerAssignedToCourse", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getCustomPlannerAssignedToLevel(crsID, semdID) {
        try {
            const data = {
                crsID: crsID,
                semdID: semdID,

            };
            const response = await this.callWebService("/controller/Planner.asmx/getCustomPlannerAssignedToLevel", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getCustomPlannerAssignedToClass(crsID, clsId, semdID) {
        try {
            const data = {
                crsID: crsID,
                clsId: clsId,
                semdID: semdID,

            };
            const response = await this.callWebService("/controller/Planner.asmx/getCustomPlannerAssignedToClass", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getCustomPlannerAssignedToStudent(crsID, clsId, studID, semdID) {
        try {
            const data = {
                crsID: crsID,
                clsId: clsId,
                studID: studID,
                semdID: semdID,

            };
            const response = await this.callWebService("/controller/Planner.asmx/getCustomPlannerAssignedToStudent", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getSaveCustomGoalList(Term1GoalsList, Term2GoalsList, Term3GoalsList, Term4GoalsList) {
        try {
            const data = {
                Term1GoalsList: Term1GoalsList,
                Term2GoalsList: Term2GoalsList,
                Term3GoalsList: Term3GoalsList,
                Term4GoalsList: Term4GoalsList,
            };
            const response = await this.callWebService("/controller/Planner.asmx/getSaveCustomGoalList", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async saveCustomPlannerAssignedToClass(newPlannerAssignedToClassObjJson) {
        try {
            const data = {
                newPlannerAssignedToClassObjJson: newPlannerAssignedToClassObjJson,
            };
            const response = await this.callWebService("/controller/Planner.asmx/saveCustomPlannerAssignedToClass", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async saveCustomPlannerAssignedToStudent(newPlannerAssignedToStudentObjJson) {
        try {
            const data = {
                newPlannerAssignedToStudentObjJson: newPlannerAssignedToStudentObjJson,
            };
            const response = await this.callWebService("/controller/Planner.asmx/saveCustomPlannerAssignedToStudent", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getRoleConfigurationByUSRID(configurationType) {
        try {
            const data = {
                configurationType: configurationType,
            };
            const response = await this.callWebService("/controller/UserMagt.asmx/getRoleConfigurationByUSRID", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getNewsfeedStatsByTeacher(teacherName, schoolId, semesterId, courseId, classId,dates, limit, page) {
        try {
            const data = {
                teacherName: teacherName,
                schoolId: schoolId,
                semesterId: semesterId,
                courseId: courseId,
                classId: classId,
                limit: limit,
                dates: dates,
                page: page
            };
            const response = await this.callWebService("/controller/Api.asmx/GetNewsfeedStatsByTeacher", data, "POST");
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getUsers(params = {}) {
        try { return await this.callWebService("/controller/Api.asmx/GetUsers", params, "POST"); }
        catch (e) { console.error(e); }
    }

    async CreateStudentFromApplicationForm(apfId) {
        try { return await this.callWebService("/controller/Api.asmx/CreateStudentFromApplicationForm", { APF_ID: apfId }, "POST"); }
        catch (e) { console.error(e); }
    }

    async DeleteStudentFromApplicationForm(studentId) {
        try { return await this.callWebService("/controller/Api.asmx/DeleteStudentFromApplicationForm", { STUDENT_ID: studentId }, "POST"); }
        catch (e) { console.error(e); }
    }

    async GetAttendanceReport(fromDate,toDate,schoolId,studentType) {
        try { return await this.callWebService("/controller/Api.asmx/GetAttendanceReportData", {fromDate: fromDate,toDate: toDate, schoolId: schoolId,studentType:studentType }, "POST"); }
        catch (e) { console.error(e); }
    }
    async GetDailyAttendanceReportData(fromDate,toDate,schoolId,studentType) {
        try { return await this.callWebService("/controller/Api.asmx/GetDailyAttendanceReportData", {fromDate: fromDate,toDate: toDate, schoolId: schoolId,studentType:studentType }, "POST"); }
        catch (e) { console.error(e); }
    }
    async GetWithdrawReport(fromDate,toDate,schoolId) {
        try { return await this.callWebService("/controller/Api.asmx/GetWithdrawReport", {fromDate: fromDate,toDate: toDate, schoolId: schoolId }, "POST"); }
        catch (e) { console.error(e); }
    }
    async GetEnrolReport(fromDate,toDate,schoolId) {
        try { return await this.callWebService("/controller/Api.asmx/GetEnrolReport", {fromDate: fromDate,toDate: toDate, schoolId: schoolId }, "POST"); }
        catch (e) { console.error(e); }
    }


async getStudentMeals(studentID, studentCourseID) {
        try {
            const data = {
                StudentID: studentID,
                StudentCourseID: studentCourseID,
            };
            const response = await this.callWebService("/controller/Students.asmx/getStudentMealByStudentId", data, "POST");

            return response;
        } catch (e) {
            console.log(e);
        }
    }
    async saveStudentMeal(newSchoolMeal) {
        try {
            const data = {
                studentID: newSchoolMeal.studentID,
                studentCourseID: newSchoolMeal.studentCourseID,
                courseFeeDetailID: newSchoolMeal.courseFeeDetailID,
                courseFeeSchemeID:newSchoolMeal.courseFeeSchemeID,
                mealStartDate:moment(newSchoolMeal.startDate).format('Y-MM-DD HH:mm:ss'),
                mealEndDate:moment(newSchoolMeal.endDate).format('Y-MM-DD HH:mm:ss'),
                mealRemarks:newSchoolMeal.remarks,
                overwriteStartDate:newSchoolMeal.overwriteStartDate,
                isStartDateOverwrite:newSchoolMeal.isStartDateOverwrite,
            };

            const response = await this.callWebService("/controller/Students.asmx/saveStudentMeal", data, "POST");

            return response;
        } catch (e) {
            console.log(e);
        }
    }
    async updateStudentMeal(newSchoolMeal) {
        try {
            const data = {
                studentID: newSchoolMeal.studentID,
                studentMealID: newSchoolMeal.studentMealID,
                mealStartDate:moment(newSchoolMeal.startDate).format('Y-MM-DD HH:mm:ss'),
                mealEndDate:moment(newSchoolMeal.endDate).format('Y-MM-DD HH:mm:ss'),
                mealRemarks:newSchoolMeal.remarks,
                actionMode: newSchoolMeal.actionMode
            };

            const response = await this.callWebService("/controller/Students.asmx/updateStudentMeal", data, "POST");

            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getAddLang(studentID, studentCourseID) {
        try {
            const data = {
                StudentID: studentID,
                StudentCourseID: studentCourseID,
            };
            const response = await this.callWebService("/controller/Students.asmx/getStudentAddLangByStudentId", data, "POST");

            return response;
        } catch (e) {
            console.log(e);
        }
    }
    async saveAddLang(newAddLang) {
        try {
            const data = {
                studentID: newAddLang.studentID,
                studentCourseID: newAddLang.studentCourseID,
                courseFeeDetailID: newAddLang.courseFeeDetailID,
                courseFeeSchemeID:newAddLang.courseFeeSchemeID,
                stuAddLangStartDate:moment(newAddLang.startDate).format('Y-MM-DD HH:mm:ss'),
                stuAddLangEndDate:moment(newAddLang.endDate).format('Y-MM-DD HH:mm:ss'),
                stuAddLangRemarks:newAddLang.remarks,
                overwriteStartDate:newAddLang.overwriteStartDate,
                isStartDateOverwrite:newAddLang.isStartDateOverwrite,
            };

            const response = await this.callWebService("/controller/Students.asmx/saveStudentAddLang", data, "POST");

            return response;
        } catch (e) {
            console.log(e);
        }
    }
    async updateAddLang(newAddLang) {
        try {
            const data = {
                studentID: newAddLang.studentID,
                studentMealID: newAddLang.studentMealID,
                studentAddLangID: newAddLang.studentAddLangID,
                stuAddLangStartDate:moment(newAddLang.startDate).format('Y-MM-DD HH:mm:ss'),
                stuAddLangEndDate:moment(newAddLang.endDate).format('Y-MM-DD HH:mm:ss'),
                stuAddLangRemarks:newAddLang.remarks,
                actionMode: newAddLang.actionMode
            };

            const response = await this.callWebService("/controller/Students.asmx/updateStudentAddLang", data, "POST");

            return response;
        } catch (e) {
            console.log(e);
        }
    }
    async getFeeDetailsOptionList(studentID, courseID,semesterID,listType ) {
        try {
            const data = {
                studentID: studentID,
                courseID: courseID,
                semesterID:semesterID,
                listType:listType
            };
            const response = await this.callWebService("/controller/Students.asmx/getFeeDetailsOptionList", data, "POST");

            return response;
        } catch (e) {
            console.log(e);
        }
    }
    async LoadStudentMealList(schID,semesterID, courseID, termID, classID) {
        try {
            const data = {
                schID: schID,
                semesterID: semesterID,
                courseID: courseID,
                termID: termID,
                classID: classID
            };
            const response = await this.callWebService("/controller/Students.asmx/getStudentMealList", data, "POST");

            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async LoadStudentAddLangList(schID,semesterID, courseID, termID, classID) {
        try {
            const data = {
                schID: schID,
                semesterID: semesterID,
                courseID: courseID,
                termID: termID,
                classID: classID
            };
            const response = await this.callWebService("/controller/Students.asmx/getStudentAddLangList", data, "POST");

            return response;
        } catch (e) {
            console.log(e);
        }
    }
   async getUniversity(universityID, universityCode) {
        try {
            const data = {
                universityID: universityID,
                universityCode: universityCode
            };
            const response = await this.callWebService("/controller/Operations.asmx/getAllUniversity", data, "POST");

            return response;
        } catch (e) {
            console.log(e);
        }
    }
    async getPaymentPlanMasterBySchId(schID) {
        const data = {
            schID: schID,
        };
        const response = await this.callWebService("/controller/Billing.asmx/getPaymentPlanMasterBySchId", data, "POST");
        return response;
    }

    async getFeeMasterDetails(feeMasterID) {
        const data = {
            feeMasterID: feeMasterID,
        };
        const response = await this.callWebService("/controller/Billing.asmx/getPaymentPlanMasterDetailsById", data, "POST");
        return response;
    }
    async saveSemester(semID, schID, name, startDate, endDate, duration, status) {
        const data = {
            schID:schID,
            semID:semID,
            name:name,
            startDate:startDate,
            endDate:endDate,
            status:status,
            duration:duration
        };
        const response = await this.callWebService("/controller/Course.asmx/updateAcademicYear", data, "POST");
        return response;
    }
    async saveSemesterDetail(semDetailID,semDetailStatus, semID, name, startDate, endDate, status) {
        const data = {
            semDetailID:semDetailID,
            semDetailStatus:semDetailStatus,
            semID:semID,
            name:name,
            startDate:startDate,
            endDate:endDate,
            status:status,
        };
        const response = await this.callWebService("/controller/Course.asmx/updateAcademicYearDetails", data, "POST");
        return response;
    }
    async saveFeeMaster(
        feeMasterID,
        schID,
        feeMasterName,
        courseID,
        feeMasterGst,
        feeMasterCurrency,
        semID,
        feeMasterClassType,
        feeMasterStatus,
        feeMasterStartDate,
        feeMasterEndDate) {

        const data = {
            feeMasterID:feeMasterID,
        schID:schID,
        feeMasterName:feeMasterName,
        courseID:courseID,
        feeMasterGst:feeMasterGst,
        feeMasterCurrency:feeMasterCurrency,
        semID:semID,
        feeMasterClassType:feeMasterClassType,
        feeMasterStatus:feeMasterStatus,
        feeMasterStartDate:feeMasterStartDate,
        feeMasterEndDate:feeMasterEndDate
        };
        const response = await this.callWebService("/controller/Billing.asmx/saveFeeMaster", data, "POST");
        return response;
    }
    async saveSchoolBasicInfo(jsonString) {
        const data = {
            jsonString:jsonString
        };
        const response = await this.callWebService("/controller/Operations.asmx/saveSchoolBasicInfo", data, "POST");
        return response;
    }

    async getPaymentPlanRulesByFKId(PPR_FK_Course_FEE_Detail_ID){
        const data = {
            PPR_FK_Course_FEE_Detail_ID:PPR_FK_Course_FEE_Detail_ID
        };
        const response = await this.callWebService("/controller/Billing.asmx/getPaymentPlanRulesByFKId", data, "POST");
        return response;
    }
    async savePaymentPlanRules(paymentPlan){
        const data = {
            PPR_FK_School_ID: paymentPlan.PPR_FK_School_ID,
            PPR_Name: paymentPlan.PPR_Name,
            PPR_Category: paymentPlan.PPR_Category,
            PPR_Value: paymentPlan.PPR_Value,
            PPR_Unit: paymentPlan.PPR_Unit,
            PPR_ClassType: paymentPlan.PPR_ClassType,
            PPR_Timeline: paymentPlan.PPR_Timeline,
            PPR_FK_Course_ID: paymentPlan.PPR_FK_Course_ID,
            PPR_FK_Course_FEE_Detail_ID: paymentPlan.PPR_FK_Course_FEE_Detail_ID,
            PK_PPR_ID: paymentPlan.PK_PPR_ID,
            PPR_Status: paymentPlan.PPR_Status,

        };
        const response = await this.callWebService("/controller/Billing.asmx/savePaymentPlanRules", data, "POST");
        return response;
    }

    async getPaymentPlanMasterDetailsById(feeMasterID) {
        const data = {
            feeMasterID: feeMasterID,
        };
        const response = await this.callWebService("/controller/Billing.asmx/getPaymentPlanMasterDetailsById", data, "POST");
        return response;
    }

    async saveFeeDetail(paymentPlanDetail){
        const data = {
            PK_Course_Fee_Detail_ID: paymentPlanDetail.PK_Course_Fee_Detail_ID,
            FK_Course_Fee_Scheme_ID: paymentPlanDetail.FK_Course_Fee_Scheme_ID,
            PPD_PaymentTimeline: paymentPlanDetail.PPD_PaymentTimeline,
            PPD_PaymentItemType: paymentPlanDetail.PPD_PaymentItemType,
            PPD_CalCategory: paymentPlanDetail.PPD_CalCategory,
            FK_Semester_Details_ID: paymentPlanDetail.FK_Semester_Details_ID,
            PPD_Payee_Name: paymentPlanDetail.PPD_Payee_Name,
            PPD_Amount: paymentPlanDetail.PPD_Amount
        };
        const response = await this.callWebService("/controller/Billing.asmx/saveFeeDetail", data, "POST");
        return response;
    }
    async getSemesterTermDetailsBySemIDOverrideSchId(semesterID, semdID, SMT_Status, SMT_School) {
        console.log(SMT_School,"School")
        try {
            const data = {
                semesterID: semesterID,
                SMT_Status: SMT_Status,
                semd_ID: semdID,
                token:Cookies.get('authToken'),
                UserSchool_Session:SMT_School
            };
            const response = await this.callWebService("/controller/Course.asmx/getSemesterTermDetails", data, "POST", false);
            return response;
        } catch (e) {
            console.log(e);
        }
    }
    async calculateFPS(PK_Student_Course_ID) {
        try {
            const data = {
                PK_Student_Course_ID: PK_Student_Course_ID,
                token:Cookies.get('authToken')
            };
            const response = await this.callWebService("/controller/Operations.asmx/calculateFPS", data, "POST", false);
            return response;
        } catch (e) {
            console.log(e);
        }
    }
    async autoApplyPlan(PK_Student_Course_ID) {
        try {
            const data = {
                PK_Student_Course_ID: PK_Student_Course_ID,
                token:Cookies.get('authToken')
            };
            const response = await this.callWebService("/controller/Operations.asmx/autoApplyPlan", data, "POST", false);
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async generatePostPDF(postID, studentID){
        try {
            const response = await this.callWebService(`Posts/Actions/GeneratePdf/${postID}/${studentID}`, {}, "GET", false, false, false,"https://api.etonhouse.com/");
            return response;
        } catch (e) {
            console.log(e);
        }
    }


}

